/**
 * El catálogo, en español.
 *
 * This file defines what keys exist; `en.ts` is typed against it, so the two can never drift.
 * Keys read `pantalla.cosa` so a string can be found from the screen it appears on.
 *
 * Nothing the shop typed in belongs here — product names, client names, what a gasto was for.
 * Those are the user's words and stay as written.
 */

export const ES = {
  // ---------- Común ----------
  'comun.volver': 'Volver',
  'comun.inicio': 'Inicio',
  'comun.cancelar': 'Cancelar',
  'comun.guardar': 'Guardar',
  'comun.cerrar': 'Cerrar',
  'comun.quitar': 'Quitar',
  'comun.corregir': 'Corregir',
  'comun.nuevo': 'Nuevo',
  'comun.agregar': 'Agregar',
  'comun.buscar': 'Buscar',
  'comun.anular': 'Anular',
  'comun.abonar': 'Abonar',
  'comun.verMas': 'Ver más',
  'elegir.proveedor': 'Escriba o elija el proveedor',
  'elegir.cliente': 'Escriba o elija el cliente',
  'producto.categoriaEscriba': 'Escriba o elija la categoría',
  'producto.categoriaNueva': 'Categoría nueva: «{nombre}»',
  'comun.total': 'Total',
  'comun.fecha': 'Fecha',
  'comun.nota': 'Nota',
  'comun.motivo': 'Motivo',
  'comun.nombre': 'Nombre',
  'comun.telefono': 'Teléfono',
  'comun.direccion': 'Dirección',
  'comun.precio': 'Precio',
  'comun.cantidad': 'Cantidad',
  'comun.costo': 'Costo',
  'comun.utilidad': 'Utilidad',
  'comun.margen': 'Margen',
  'comun.referencia': 'Número de referencia',
  'comun.guardando': 'Guardando…',
  'comun.esDelDueno': 'Esta sección es del dueño.',
  'comun.sinAcceso': 'Sin acceso',
  'comun.sinPermiso': 'Su usuario no puede abrir esta pantalla.',
  'comun.abriendo': 'Abriendo…',
  'comun.entrar': 'Entrar',

  // ---------- Contexto inseguro ----------
  'inseguro.titulo': 'Esta página no se abrió de forma segura',
  'inseguro.explicacion':
    'El navegador solo permite cifrar el PIN y trabajar sin señal cuando la página viene por https, o desde localhost en esta misma computadora.',
  'inseguro.abiertaEn': 'Aquí se abrió desde {host}.',
  'inseguro.comoSeguir': 'Cómo seguir',
  'inseguro.opcionLocal': 'En la computadora donde corre el sistema: abra http://localhost:5173.',
  'inseguro.opcionDominio':
    'Para probar desde un teléfono: publique el dominio con certificado, que es lo que hace Caddy en el servidor.',
  'inseguro.noEsDeAqui':
    'No es una restricción de este sistema: es del navegador, y aplica a cualquier página que maneje contraseñas.',

  // ---------- Instalación ----------
  'instalar.tituloAbierta': 'Cree su cuenta y empiece.',
  'instalar.tituloCerrada':
    'Primera instalación. Cree la cuenta del dueño y registre este dispositivo.',
  'instalar.clave': 'Clave de instalación',
  'instalar.clavePlaceholder': 'SETUP_TOKEN del servidor',
  'instalar.nombreDueno': 'Nombre del dueño',
  'instalar.pin': 'PIN (6 a 10 dígitos)',
  'instalar.repitaPin': 'Repita el PIN',
  'instalar.nombreDispositivo': 'Nombre de este dispositivo',
  'instalar.avisoDesarrollo':
    'Servidor de desarrollo sin clave de instalación configurada. En un servidor de verdad hace falta la clave, y este aviso no aparece.',
  'instalar.botonAbierta': 'Crear mi cuenta y entrar',
  'instalar.botonCerrada': 'Instalar',
  'instalar.creando': 'Creando…',
  'instalar.instalando': 'Instalando…',
  'instalar.tituloRegistrar': 'Esta tienda ya está instalada. Registre este equipo con el PIN del dueño.',
  'instalar.dueno': 'Dueño',
  'instalar.pinDueno': 'PIN del dueño',
  'instalar.tipoEquipo': 'Qué es este equipo',
  'instalar.nombreEquipoEjemplo': 'Teléfono de Elvin',
  'instalar.registrar': 'Registrar este equipo',
  'instalar.registrando': 'Registrando…',
  'instalar.pinDuenoIncorrecto': 'Ese no es el PIN del dueño.',
  'instalar.falloRegistro': 'No se pudo registrar el equipo',
  'instalar.sinDuenos': 'No se pudo saber quién es el dueño. Revise la conexión y vuelva a abrir la aplicación.',
  'instalar.pinCorto': 'El PIN debe tener entre 6 y 10 dígitos',
  'instalar.pinDebil': 'Ese PIN es demasiado fácil de adivinar',
  'instalar.pinNoCoincide': 'Los PIN no coinciden',
  'instalar.sinInternet': 'No hay conexión. La instalación inicial sí requiere internet.',
  'instalar.fallo': 'No se pudo instalar',

  // ---------- Entrar ----------
  'entrar.quienAtiende': '¿Quién está atendiendo?',
  'entrar.cambiarUsuario': 'Cambiar de usuario',
  'entrar.sinUsuarios': 'Todavía no hay usuarios en este dispositivo',
  'entrar.descargarUsuarios':
    'Conéctese a internet una vez para descargar los usuarios. Después podrá entrar sin conexión.',
  'entrar.sincronizar': 'Sincronizar ahora',
  'entrar.inactivo': 'Ese usuario no está activo',
  'entrar.pinIncorrecto': 'PIN incorrecto. Intente otra vez.',
  'entrar.hola': '¡Hola, {nombre}!',

  // ---------- Sincronización ----------
  'sync.alDia': 'Al día',
  'sync.sincronizando': 'Sincronizando…',
  'sync.sinConexion': 'Sin conexión',
  'sync.error': 'Error al sincronizar',
  'sync.sinRegistrar': 'Sin registrar',
  'sync.demasiadoGrande': 'Es demasiado grande para mandarlo al servidor',
  'sync.dadoDeBaja': 'Dado de baja',
  'sync.practica': 'Modo práctica — nada se envía',
  'practica.montando': 'Armando la tienda de práctica…',
  'practica.usuario': 'Practicante',
  'practica.dispositivo': 'Equipo de práctica',
  'practica.salir': 'Salir',
  'copiaDeTienda.pestana': 'Copia',
  'copiaDeTienda.aviso': 'Esta es una copia de la tienda: lo que haga aquí no llega a ella. Se tomó el {cuando}',

  // --- Tutorial ---
  'tutorial.paso': 'Paso {n} de {total}',
  'tutorial.entendido': 'Entendido',
  'tutorial.saltar': 'Saltar este paso',
  'tutorial.salir': 'Salir del tutorial',
  'tutorial.hazlo': 'Hágalo usted. El tutorial sigue solo cuando esté hecho.',
  'tutorial.buscando': 'Esperando a que aparezca en pantalla…',
  'tutorial.terminada': 'Listo: {leccion}',
  'tutorial.terminadaDetalle': 'Puede repetirla cuando quiera. Nada de lo que hizo aquí es real.',
  'tutorial.verLecciones': 'Ver las lecciones',
  'tutorial.oferta.titulo': '¿Le enseñamos a usar esto?',
  'tutorial.oferta.detalle': 'Son lecciones cortas en una tienda de mentira: usted hace la venta, el corte y todo lo demás sin tocar nada de verdad. Toma unos veinte minutos.',
  'tutorial.oferta.si': 'Sí, enséñeme',
  'tutorial.oferta.no': 'Ahora no',
  'aprender.titulo': 'Aprender',
  'aprender.hechas': '{n} de {total} lecciones hechas',
  'aprender.lecciones': 'Lecciones',
  'aprender.pasos': '{n} pasos',
  'aprender.invitacion': 'Para aprender hay que hacer, y para hacer sin miedo hace falta que nada cuente. El modo práctica abre una pulpería de mentira, llena y funcionando, donde usted puede vender, equivocarse, anular y volver a empezar. Su tienda de verdad no se entera.',
  'aprender.empezar': 'Entrar a practicar',
  'aprender.abriendo': 'Abriendo la tienda de práctica…',
  'aprender.nadaReal': 'Nada de lo que haga ahí toca su tienda ni se envía a ningún lado.',
  'aprender.enPractica': 'Está en la tienda de práctica',
  'aprender.enPracticaDetalle': 'Todo lo que ve aquí es inventado. Las ventas no son ventas y la plata no es plata. Elija una lección y sígala.',
  'aprender.salirPractica': 'Salir y volver a mi tienda',
  'aprender.salirTitulo': '¿Salir de la práctica?',
  'aprender.salirMensaje': 'Se borra la tienda de práctica con todo lo que hizo en ella y usted vuelve a su tienda de verdad. Puede volver a entrar cuando quiera; siempre empieza limpia.',
  'aprender.salirConfirmar': 'Salir y borrar la práctica',
  'aprender.olvidar': 'Olvidar mi progreso y empezar de nuevo',
  'tutorial.rumbo.titulo': 'Dónde está cada cosa',
  'tutorial.rumbo.para': 'La pantalla principal y el menú',
  'tutorial.rumbo.bienvenida': 'Bienvenido. Este sistema hace cuatro cosas: cobra, lleva la cuenta de lo que hay, apunta a quién se le debe y le dice si está ganando. Nada más. Vamos por partes.',
  'tutorial.rumbo.practica': 'Está en una tienda de mentira. Los productos, los clientes y las ventas que va a ver son inventados. Haga lo que quiera: no puede dañar nada.',
  'tutorial.rumbo.inicio': 'Este botón grande es siempre lo siguiente que toca hacer. Si la caja está cerrada lo lleva a empezar el día, o su turno; si está abierta dice «Vender». Si no sabe qué hacer, apriete el botón grande.',
  'tutorial.rumbo.atajos': 'Debajo están los atajos: las pantallas que más se usan, a un toque. Siempre están en el mismo lugar.',
  'tutorial.rumbo.pendientes': 'Aquí salen los avisos: pedidos para hoy, transferencias sin confirmar, cosas por vencer. Si no hay nada, no aparece nada. Un renglón aquí es algo que alguien tiene que atender.',
  'tutorial.rumbo.mas': 'Todas las pantallas, ordenadas por secciones, están detrás de este botón. Apriételo.',
  'tutorial.rumbo.grupos': 'Todo lo demás está aquí, en unas pocas secciones. Cada renglón nombra las pantallas que tiene adentro, y cada sección tiene su color.',
  'tutorial.rumbo.pestanas': 'Adentro de cada sección, arriba, están sus pestañas. Un toque y pasa a la de al lado, sin volver al menú.',
  'tutorial.rumbo.volver': '«Volver» lo regresa a donde estaba, y la casita junto al nombre de la pantalla lo lleva directo al inicio. Nunca se va a quedar atrapado en una pantalla. Apriete «Volver».',
  'tutorial.rumbo.cierre': 'Eso es todo lo que hay que saber para moverse: el botón grande, los atajos, los avisos y «Todo lo demás». Ahora vamos a trabajar.',
  'tutorial.caja.titulo': 'Empezar el día',
  'tutorial.caja.para': 'Lo primero de cada día',
  'tutorial.caja.yaAbierta': 'La caja ya está abierta: se empieza una vez por turno, al llegar. Para practicar cómo se empieza, primero hay que terminar el turno: haga antes la lección «Terminar el día» y vuelva a esta.',
  'tutorial.caja.porque': 'Antes de vender se cuenta el dinero que hay en la gaveta y se apunta: así empieza el día, o su turno. Sin eso, al final el sistema no puede decirle si cuadra, porque no sabe de dónde partió.',
  'tutorial.caja.ir': 'Esta es la pantalla de la caja. Ahorita está cerrada: apriete el botón para empezar.',
  'tutorial.caja.contar': 'Siga los pasos: si puso plata de la caja fuerte, cuántos billetes hay de cada uno, las monedas y los dólares. Si le pide contar otra vez, hágalo con calma. Al final, revise y apriete el último botón: la caja queda abierta.',
  'tutorial.caja.listo': 'Listo, la caja está abierta. Lo que usted contó se compara con lo que dejó el turno anterior y lo que puso para el cambio, y lo que no coincida queda anotado como faltante o sobrante. Desde ahora el sistema apunta cada córdoba y cada dólar que entra y sale, y al terminar le va a decir si lo que hay coincide.',
  'tutorial.caja.pasos': 'Empezar va paso a paso: una pregunta por pantalla, y cada una dice qué hacer y por qué. Toque «Entendido» y siga los pasos; aquí arriba le acompaño.',
  'tutorial.vender.titulo': 'Hacer una venta',
  'tutorial.vender.para': 'Lo que va a hacer cien veces al día',
  'tutorial.vender.cajaCerrada': 'Primero la caja: está cerrada, y sin caja abierta no se vende. Empezar va paso a paso, una pregunta por pantalla. Toque «Entendido» y siga los pasos.',
  'tutorial.vender.abrirCaja': 'Siga los pasos hasta que la caja quede abierta: cuente lo que hay en la gaveta, pantalla por pantalla. Después seguimos con la lección.',
  'tutorial.vender.porque': 'Esta es la pantalla que más va a usar. Busca el producto, lo agrega, cobra. Vamos despacio una vez y después sale solo.',
  'tutorial.vender.buscar': 'Escriba parte del nombre de un producto — por ejemplo «arroz» — y toque el que quiera de la lista que sale abajo.',
  'tutorial.vender.linea': 'Ahí está, agregado. Cada renglón dice cuántos lleva, a cuánto y cuánto suma. Tocando el nombre se cambia el precio.',
  'tutorial.vender.cantidad': '¿Lleva dos? Toque +. Con − se quita uno, y tocando el número se escribe cuántos, por ejemplo 12.',
  'tutorial.vender.total': 'El total se va sumando solo. Nunca hay que sacar la cuenta a mano.',
  'tutorial.vender.cobrar': 'Cuando el cliente ya no lleva más, apriete «Cobrar».',
  'tutorial.vender.metodo': 'Aquí dice con qué le van a pagar: efectivo, dólares, transferencia, billetera, tarjeta o fiado. Está en efectivo, que es lo normal.',
  'tutorial.vender.monto': 'El monto ya viene puesto con lo que falta. Si el cliente le da justo, no toque nada.',
  'tutorial.vender.confirmar': 'Ahora sí: «Confirmar venta». Eso descuenta el inventario, apunta la plata en la caja y guarda la ganancia de esta venta.',
  'tutorial.vender.recibo': 'Ese es el recibo. Si tiene impresora sale impreso; si no, se lo puede enseñar al cliente en la pantalla. Ya está: esa fue una venta completa.',
  'tutorial.vuelto.titulo': 'Dar vuelto y pagos partidos',
  'tutorial.vuelto.para': 'Cuando pagan con un billete grande',
  'tutorial.vuelto.cajaCerrada': 'Para cobrar hace falta la caja abierta, y está cerrada. Toque «Entendido» y siga los pasos para empezar.',
  'tutorial.vuelto.abrirCaja': 'Siga los pasos hasta que la caja quede abierta: cuente lo que hay en la gaveta, pantalla por pantalla. Después seguimos con la lección.',
  'tutorial.vuelto.porque': 'Casi nadie paga justo. Vamos a cobrar una venta con un billete de más para que vea cómo le dice el vuelto.',
  'tutorial.vuelto.arma': 'Arme una venta: busque cualquier producto y agréguelo.',
  'tutorial.vuelto.cobrar': 'Apriete «Cobrar».',
  'tutorial.vuelto.masDeLaCuenta': 'Toque el monto y escriba lo que le dieron, MÁS de lo que cuesta — como si le hubieran dado un billete de 500 por una compra de 60.',
  'tutorial.vuelto.vuelto': 'Ahí está el vuelto, calculado. Eso es lo que le tiene que devolver al cliente. No hay que restar nada de cabeza.',
  'tutorial.vuelto.confirmar': 'Confirme la venta.',
  'tutorial.vuelto.partido': 'Si alguien paga una parte de una forma y el resto de otra — un poco en efectivo y lo demás con tarjeta — es este botón: escriba la primera parte y agréguela. Lo que falta queda puesto para cobrarlo con la otra forma.',
  'tutorial.fiado.titulo': 'Fiado y abonos',
  'tutorial.fiado.para': 'A quién le fía, y cuando viene a pagar',
  'tutorial.fiado.cajaCerrada': 'Para vender, fiado o no, hace falta la caja abierta, y está cerrada. Toque «Entendido» y siga los pasos para empezar.',
  'tutorial.fiado.abrirCaja': 'Siga los pasos hasta que la caja quede abierta: cuente lo que hay en la gaveta, pantalla por pantalla. Después seguimos con la lección.',
  'tutorial.fiado.porque': 'Fiar es la plata de la tienda que sale por la puerta sin pagarse todavía. Aquí queda apuntado lo que debe cada quien, y cada vez que paga algo, sin cuaderno. Vamos con Doña Marta, que ya debe algo: viene a pagar un poco y se lleva más.',
  'tutorial.fiado.cliente': 'Fiado siempre es a alguien. Toque aquí para escoger a quién es la venta.',
  'tutorial.fiado.elegir': 'Busque a Doña Marta y tóquela. Al lado de cada nombre dice cuánto debe.',
  'tutorial.fiado.abonar': 'La venta ya es de ella, y debajo de su nombre dice cuánto debe. Como trae para pagar, toque «Abonar a su cuenta».',
  'tutorial.fiado.abono': 'El monto viene con todo lo que debe; escriba lo que le da, por ejemplo 100, y toque «Registrar abono». El efectivo entra a la gaveta, y el corte lo va a esperar.',
  'tutorial.fiado.comprobante': 'Ese es el comprobante: dice lo que abonó y lo que queda debiendo. Se lo puede mandar por WhatsApp o imprimir. Toque «Listo».',
  'tutorial.fiado.agregar': 'Ahora se lleva algo más. Agréguelo como en cualquier venta: sigue siendo de ella.',
  'tutorial.fiado.cobrar': 'Apriete «Cobrar».',
  'tutorial.fiado.fiar': 'Escoja «Fiado». Nadie le da plata: la venta queda en su cuenta.',
  'tutorial.fiado.cuenta': 'Aquí dice lo que debe, lo que quedaría debiendo con esta venta y hasta cuánto se le fía. Si se pasa del límite, o si nunca le pusieron uno, la venta pide el PIN del dueño.',
  'tutorial.fiado.confirmar': 'Confirme la venta. El recibo dice cuánto debe en total, para que ella también lo sepa.',
  'tutorial.fiado.queda': 'Todo queda en su página, en «Clientes»: lo que se llevó, lo que abonó y lo que debe, con el estado de cuenta para mandárselo por WhatsApp o imprimirlo.',
  'tutorial.corregir.titulo': 'Deshacer una venta',
  'tutorial.corregir.para': 'Cuando se equivocó o el cliente se arrepintió',
  'tutorial.corregir.cajaCerrada': 'Para anular hace falta la caja abierta: la plata de la venta sale de ahí para devolvérsela al cliente. Está cerrada: toque «Entendido» y siga los pasos para empezar.',
  'tutorial.corregir.abrirCaja': 'Siga los pasos hasta que la caja quede abierta: cuente lo que hay en la gaveta, pantalla por pantalla. Después seguimos con la lección.',
  'tutorial.corregir.porque': 'Se va a equivocar. Todo el mundo se equivoca. Lo importante es que arreglarlo sea fácil y que quede apuntado quién lo arregló y por qué.',
  'tutorial.corregir.ir': 'Aquí están las últimas ventas, la más nueva arriba.',
  'tutorial.corregir.abrir': 'Toque una venta para abrirla y ver el detalle.',
  'tutorial.corregir.anular': 'Apriete «Anular esta venta».',
  'tutorial.corregir.motivo': 'Escriba por qué. El motivo no es papeleo: dentro de tres meses, cuando alguien pregunte por qué faltan mil córdobas de un martes, esto es lo único que va a contestar.',
  'tutorial.corregir.stock': 'Si el producto volvió bueno a la estantería, deje marcado que regresa al inventario. Si volvió quebrado o sucio, desmárquelo: la plata se devuelve igual, pero la mercadería se da por perdida.',
  'tutorial.corregir.confirmar': 'Confirme la anulación.',
  'tutorial.corregir.pin': 'Escriba el PIN: en la tienda de práctica es 000000. Anular pide el PIN de quien tiene la sesión abierta, para que la anulación quede a nombre de quien la hizo. Si la venta es de un turno ya cerrado, pide el del dueño.',
  'tutorial.corregir.queda': 'La venta no se borró: quedó marcada como anulada, con su motivo y su hora. En este sistema nada se borra nunca — se corrige con un apunte nuevo, igual que en un cuaderno de contabilidad.',
  'tutorial.cerrarCaja.titulo': 'Terminar el día',
  'tutorial.cerrarCaja.para': 'Lo último de cada día',
  'tutorial.cerrarCaja.cajaCerrada': 'Para terminar, la caja tiene que estar abierta, y esta está cerrada. Ábrala primero: toque «Entendido» y siga los pasos.',
  'tutorial.cerrarCaja.abrirCaja': 'Siga los pasos hasta que la caja quede abierta: cuente lo que hay en la gaveta, pantalla por pantalla. Después seguimos con la lección.',
  'tutorial.cerrarCaja.porque': 'Al terminar se cuenta la gaveta y se compara con lo que el sistema esperaba: es el corte de caja. Es la única forma de darse cuenta de que falta plata el mismo día y no tres meses después.',
  'tutorial.cerrarCaja.ir': 'Apriete «Terminar mi turno».',
  'tutorial.cerrarCaja.aCiegas': 'Fíjese en algo importante: el sistema NO le enseña cuánto esperaba hasta que usted escriba lo que contó. Es a propósito. Un conteo hecho viendo la respuesta no mide nada.',
  'tutorial.cerrarCaja.contar': 'Cuente los billetes de cada uno y las monedas, y después los dólares, pantalla por pantalla. Si no cuadra por mucho, le pide contar otra vez sin decirle cuánto: casi siempre es un billete mal contado.',
  'tutorial.cerrarCaja.queda': 'Aquí va lo que se queda en la gaveta para dar vuelto mañana: el fondo. Viene en 0; si hoy deja algo, escriba cuánto. Abajo dice cuánto sale para el dueño.',
  'tutorial.cerrarCaja.cerrar': 'Siga: diga quién recibe el dinero, revise todo y apriete el último botón para hacer el corte.',
  'tutorial.cerrarCaja.diferencia': 'Ahí le dice si sobró o faltó. Una diferencia chiquita casi siempre es vuelto mal dado. Una diferencia grande, o una chiquita que se repite todos los días con la misma persona, es otra cosa.',
  'tutorial.cerrarCaja.sacar': 'Y aquí, cuánto sacar: lo demás, y todos los dólares, se le entrega al dueño. Mañana, al empezar, se compara lo que cuenten con lo que quedó hoy.',
  'tutorial.cerrarCaja.quien': 'Primero pregunta si alguien atiende después de usted. Si sigue otra persona, le deja el vuelto; si se cierra la tienda, además se repasa el día. Para practicar el cierre del día, toque «No, se cierra la tienda».',
  'tutorial.cerrarCaja.dia': 'Como se cierra la tienda, sigue el repaso del día: el resumen para mandárselo al dueño, lo que queda pendiente, los pedidos de mañana y si todo quedó guardado en el servidor. Siga hasta el final.',
  'tutorial.productos.titulo': 'Agregar un producto',
  'tutorial.productos.para': 'Cuando empieza a vender algo nuevo',
  'tutorial.productos.porque': 'Un producto se crea una sola vez y después se vende mil veces. Vale la pena hacerlo bien.',
  'tutorial.productos.ir': 'Apriete «Nuevo».',
  'tutorial.productos.nombre': 'El nombre como usted lo dice en voz alta, no como viene en la factura del proveedor. Usted va a buscar «arroz», no «ARROZ GRANZA ORO 80/20 SACO».',
  'tutorial.productos.unidad': 'La unidad base es cómo se guarda la existencia: por unidad, por libra, por litro. Si vende arroz por libra suelta, es libra — aunque lo compre por quintal.',
  'tutorial.productos.categoria': 'La categoría sirve para buscar y para los reportes. No se complique: escoja la más obvia.',
  'tutorial.productos.guardar': 'Guarde.',
  'tutorial.precios.titulo': 'Ponerles precio',
  'tutorial.precios.para': 'Todos los precios de un solo tirón',
  'tutorial.precios.porque': 'Un producto sin precio no se puede vender. Esta pantalla existe para ponerle precio a todo de una sentada, en vez de entrar producto por producto.',
  'tutorial.precios.todos': 'La pantalla abre en «Sin precio»: solo los productos a los que todavía les falta algún precio, para que no se le pase ninguno. Toque «Todos» para verlos todos, con los precios que ya tienen.',
  'tutorial.precios.ir': 'Un renglón por producto, con una casilla para cada lista: el precio al público y el mayorista, lado a lado. Escriba en la que quiera.',
  'tutorial.precios.escribir': 'Escriba un precio y toque «Guardar» en su renglón: hasta entonces no se guarda nada. Lo guardado se queda en la lista hasta que cambie de vista, por si se equivocó.',
  'tutorial.precios.sugerido': 'Donde el sistema ya sabe cuánto le costó, le sugiere un precio con una ganancia razonable. Es una sugerencia, no una orden: usted conoce a su clientela.',
  'tutorial.precios.costos': '«Sin costo» lista los productos de los que el sistema todavía no sabe cuánto le costaron: sus ventas parecen pura ganancia y no hay precio que sugerir. El dueño se lo pone con «Costo», en el renglón de cada uno.',
  'tutorial.precios.listas': 'Hay dos listas: «Precio al público» y «Precio mayorista». Al cliente de ruta se le asigna la mayorista y ya nadie tiene que acordarse de hacerle precio especial. Cobrar con otra lista en la caja pide el visto bueno del dueño.',
  'tutorial.comprar.titulo': 'Recibir mercadería',
  'tutorial.comprar.para': 'Cuando llega el camión del proveedor',
  'tutorial.comprar.porque': 'Apuntar la compra es lo que hace que el inventario sirva y lo que le permite al sistema saber cuánto le costó cada cosa. Sin esto, la ganancia que le muestre es un invento.',
  'tutorial.comprar.agregar': 'Agregue un producto de los que le trajeron: escanee el código o búsquelo por el nombre. Si no está en el catálogo, lo crea aquí mismo.',
  'tutorial.comprar.costo': 'Ponga la cantidad y el costo TOTAL del renglón, tal como dice la factura. No el precio por unidad: el total. El sistema saca el resto y así no se pierden centavos en el redondeo.',
  'tutorial.comprar.proveedor': 'Toque el campo y escoja el proveedor que le trajo la mercadería, o escriba su nombre para encontrarlo.',
  'tutorial.comprar.pago': '¿Cómo la pagó? Si quedó debiendo, ponga «Al crédito» y la fecha en que vence — así el sistema le avisa antes de que el proveedor tenga que llamarlo. ¿Pagó una parte de una forma y otra de otra? Use «Pagar una parte de otra forma».',
  'tutorial.comprar.flete': 'Si pagó flete, póngalo aquí. Se reparte entre los productos según lo que vale cada uno, porque el flete es parte de lo que a usted le costó la mercadería. ¿Lo pagó a otra persona, como el camionero? Agréguelo también como un pago aparte.',
  'tutorial.comprar.registrar': 'Registre la compra.',
  'tutorial.comprar.costoPromedio': 'Con eso el inventario subió y el costo se recalculó. Si compró arroz a 20 y ahora lo compra a 24, el sistema no se queda con ninguno de los dos: saca el promedio de lo que tiene. Así la ganancia que le muestra es la de verdad.',
  'tutorial.inventario.titulo': 'Contar lo que hay',
  'tutorial.inventario.para': 'Inventario, conteos y mermas',
  'tutorial.inventario.porque': 'El sistema sabe lo que DEBERÍA haber. Solo contando se sabe lo que HAY. La diferencia entre esos dos números es lo que se está perdiendo.',
  'tutorial.inventario.ver': 'Esto es lo que el sistema cree que tiene, con lo que vale.',
  'tutorial.inventario.contar': 'Vamos a hacer un conteo. Agregue un producto al conteo.',
  'tutorial.inventario.aCiegas': 'Igual que en el corte de caja: mientras cuenta no le enseña lo que esperaba. Cuente de verdad y escriba lo que encontró.',
  'tutorial.inventario.registrar': 'Registre el conteo.',
  'tutorial.inventario.merma': 'Cuando se sabe por qué se perdió algo — se venció, se quebró, se lo llevaron — es mejor apuntarlo como salida con su motivo, en vez de dejar que aparezca como faltante en el próximo conteo.',
  'tutorial.clientes.titulo': 'Clientes',
  'tutorial.clientes.para': 'A quién le fía y a quién le lleva',
  'tutorial.clientes.porque': 'No hay que apuntar a todo el que entra a comprar una gaseosa. Aquí van los de ruta y los que llevan fiado — los que necesitan que alguien se acuerde de ellos.',
  'tutorial.clientes.ir': 'Apriete «Nuevo».',
  'tutorial.clientes.nombre': 'El nombre con que usted lo conoce. «Doña Marta la de la esquina» está bien si así le dice.',
  'tutorial.clientes.tipo': '«De mostrador» es el que viene a la tienda. «Mayorista / de ruta» es al que usted le lleva.',
  'tutorial.clientes.lista': 'La lista de precios que le corresponde. Se la pone una vez y de ahí en adelante ese cliente ve sus precios solo, sin que el cajero tenga que acordarse.',
  'tutorial.clientes.dia': 'Si le lleva un día fijo, póngalo. Así se sabe qué día le toca su pedido.',
  'tutorial.clientes.guardar': 'Guarde.',
  'tutorial.clientes.enLaVenta': 'Desde ahora, al cobrar puede escoger este cliente y la venta le queda asociada — con sus precios y con su cuenta.',
  'tutorial.pedidos.titulo': 'Tomar un pedido',
  'tutorial.pedidos.para': 'Preventa: lo que se entrega después',
  'tutorial.pedidos.porque': 'Un pedido es lo que el cliente encargó hoy para recibir otro día. La lista de pedidos dice qué hay que entregar cada día, y desde ahí se cobra.',
  'tutorial.pedidos.ir': 'Apriete «Nuevo pedido».',
  'tutorial.pedidos.cliente': 'Toque el campo y escoja el cliente que hizo el pedido, o escriba su nombre. Si es alguien nuevo, la última opción de la lista lo agrega sin salir del pedido.',
  'tutorial.pedidos.entrega': '¿Qué día se lo va a entregar? La lista pone los pedidos en el orden de ese día y marca los de hoy.',
  'tutorial.pedidos.agregar': 'Agregue lo que encargó, como en la caja: busque el producto por el nombre o escanee el código. Si lleva más de uno, toque +.',
  'tutorial.pedidos.guardar': 'Apriete «Guardar pedido». Vuelve a la lista, con el pedido en ella.',
  'tutorial.pedidos.cobrar': 'El día de la entrega, «Cobrar» lo lleva a la caja con todo cargado, a los precios que se le dieron al cliente. Se cobra como cualquier venta, y el pedido pasa a «Entregados» con su ticket.',
  'tutorial.pedidos.noReserva': 'Ojo con una cosa: un pedido no saca nada del inventario. La mercadería sale cuando el pedido se cobra. Si el dueño encendió en los ajustes del negocio que los pedidos aparten la mercadería, el pedido sí la aparta: lo apartado ya no se le promete a otro, y la caja pide el PIN del dueño para venderlo.',
  'tutorial.gastos.titulo': 'Gastos y pagos',
  'tutorial.gastos.para': 'La luz, el agua, lo que le debe al proveedor',
  'tutorial.gastos.porque': 'La ganancia no es lo que vendió menos lo que costó la mercadería. Hay que quitarle la luz, el agua, el alquiler y las bolsas. Si no apunta los gastos, el sistema le va a decir que está ganando más de lo que gana.',
  'tutorial.gastos.ir': 'Apriete «Nuevo gasto».',
  'tutorial.gastos.categoria': 'Escoja de qué fue. Las categorías son las que sirven para ver en qué se le va la plata.',
  'tutorial.gastos.descripcion': 'Escríbalo como se lo diría a alguien: «recibo de la luz de septiembre».',
  'tutorial.gastos.monto': 'Cuánto.',
  'tutorial.gastos.guardar': 'Guarde.',
  'tutorial.gastos.noEsRetiro': 'Una cosa importante: si usted saca plata de la caja para usted, eso NO es un gasto del negocio. Es un retiro del dueño, y va aparte, en «Dueño». Confundirlos es la forma más fácil de creer que el negocio va mal cuando lo que pasa es que usted está sacando mucho.',
  'tutorial.gastos.verPorPagar': 'Apriete «Por pagar».',
  'tutorial.gastos.proveedores': 'Aquí está lo que les debe a los proveedores, con su fecha de vencimiento, y el botón para abonarles.',
  'tutorial.numeros.titulo': 'Leer los números',
  'tutorial.numeros.para': 'Saber si está ganando',
  'tutorial.numeros.porque': 'Esta pantalla contesta una sola pregunta: ¿está ganando o está perdiendo? Todo lo demás que apuntó existe para que este número sea cierto.',
  'tutorial.numeros.ir': 'Primero escoja el período: hoy, este mes, el mes pasado.',
  'tutorial.numeros.ventas': '«Ingresos» es todo lo que entró por vender, sin quitarle nada; y si un corte salió con plata de más, eso también.',
  'tutorial.numeros.utilidad': '«Utilidad bruta» es lo que quedó después de quitarle lo que le costó la mercadería que vendió. Todavía no le ha quitado la luz ni el alquiler.',
  'tutorial.numeros.margen': 'El porcentaje de al lado es cuánto le queda de cada cien córdobas que vende. En una pulpería, entre veinte y treinta es normal. Si le sale mucho más bajo, o está vendiendo muy barato o no apuntó bien lo que le costó.',
  'tutorial.numeros.gastos': 'Y aquí los gastos del período. Utilidad bruta menos gastos es lo que de verdad ganó.',
  'tutorial.numeros.cuandoMirar': 'Mírelo una vez por semana, no todos los días. Un día malo no significa nada; cuatro semanas seguidas hacia abajo sí.',
  'tutorial.planilla.titulo': 'Planilla',
  'tutorial.planilla.para': 'Pagarle a la gente, con INSS y todo',
  'tutorial.planilla.porque': 'Si tiene gente trabajando, la ley pide INSS, aguinaldo, vacaciones e indemnización. El sistema saca todas esas cuentas por usted, con los porcentajes de Nicaragua.',
  'tutorial.planilla.ir': 'Esta es su gente, con su cargo y desde cuándo está.',
  'tutorial.planilla.acumulado': 'Aquí ve lo que ya se le debe a cada quien aunque todavía no se lo haya pagado: aguinaldo y vacaciones se van juntando mes a mes desde el primer día.',
  'tutorial.planilla.correr': '«Correr planilla» arma el pago: del mes, de la quincena o de la semana. Apriételo.',
  'tutorial.planilla.unaVez': 'Nadie se paga DOS veces el mismo día: quien ya está en otra planilla de esos días queda fuera, porque pagarle dos veces duplicaría todas las provisiones. Usted pone lo que cambia — los días de quien gana por día, horas extra, vacaciones pagadas, aguinaldo en diciembre — y el sistema calcula el resto.',
  'tutorial.planilla.pagar': 'Correr la planilla crea la deuda; entregar la plata es aparte, porque en la práctica pasan en días distintos.',
  'tutorial.respaldo.titulo': 'Respaldo e idioma',
  'tutorial.respaldo.para': 'Sin señal, y en dos idiomas',
  'tutorial.respaldo.porque': 'Dos cosas que conviene saber antes de soltarlo en la tienda de verdad.',
  'tutorial.respaldo.sync': 'En su tienda, este renglón dice si lo que hizo ya está guardado en el servidor: verde es al día, y un número «sin enviar» es lo que todavía está solo en este aparato. Aquí dice «Modo práctica», porque nada de lo que hace aquí se envía.',
  'tutorial.respaldo.sinConexion': 'Sin internet todo sigue funcionando: puede vender, cobrar y cerrar caja igual. Se guarda en el aparato y se manda solo cuando vuelva la señal. Lo único que no se puede hacer sin señal es registrar un aparato nuevo.',
  'tutorial.respaldo.codigo': 'Cada aparato tiene dos letras, y cada recibo empieza con ellas. Por eso dos cajas trabajando sin señal al mismo tiempo nunca pueden dar el mismo número de recibo.',
  'tutorial.respaldo.idioma': 'Y aquí se cambia el idioma. Es por aparato: uno puede tenerlo en español y otro en inglés, con la misma información.',
  'tutorial.respaldo.final': 'Ya está. Con esto puede trabajar. Cuando algo se le olvide, las lecciones quedan aquí para repetirlas.',
  'sync.sinEnviar': '{n} sin enviar',
  'sync.acumulando':
    'Hay {n} registros que aún no llegan al servidor. Si se pierde este dispositivo, se pierden. Conéctese a internet en cuanto pueda.',
  'sync.deriva':
    'La hora de este dispositivo está desfasada {s}s. Corríjala: las ventas pueden quedar registradas en el día equivocado.',
  'sync.rechazados': '{n} registro(s) rechazados por el servidor. Requieren revisión.',

  // ---------- Actualización ----------
  'actualizar.hayVersion': 'Hay una versión nueva del sistema.',
  'actualizar.ahora': 'Actualizar',
  'actualizar.despues': 'Después',
  'actualizar.revisando': 'Buscando actualizaciones…',
  'actualizar.titulo': 'Hay una versión nueva',
  'actualizar.hayQue':
    'Actualice para seguir. Lo que ya se guardó en este dispositivo no se pierde, aunque no se haya enviado.',
  'actualizar.actualizando': 'Actualizando…',
  'actualizar.fallo':
    'No se pudo actualizar. Revise la conexión e intente otra vez, o siga con la versión de antes y actualice en cuanto pueda.',
  'actualizar.reintentar': 'Intentar otra vez',
  'actualizar.seguirSinActualizar': 'Seguir sin actualizar',

  // ---------- PIN del dueño ----------
  'preguntar.anularGasto': 'Anular este gasto',
  'preguntar.cancelarPedido': 'Cancelar este pedido',
  'preguntar.abonar': 'Abonar a esta compra',
  'preguntar.abonarGasto': 'Abonar a este gasto',
  'preguntar.cuanto': '¿Cuánto abona?',
  'preguntar.faltaPagar': 'Falta pagar {monto}',
  'preguntar.desactivarCliente': 'Desactivar cliente',
  'preguntar.desactivar': 'Sí, desactivar',
  'preguntar.quitarDeLaVenta': '¿Quitar de la venta?',
  'preguntar.quitarDelPedido': '¿Quitar del pedido?',
  'pin.autorizacion': 'Autorización del dueño',
  'pin.incorrecto': 'PIN incorrecto. Intente otra vez.',
  'pin.espere': 'Demasiados intentos. Espere {tiempo} para probar otra vez.',
  'pin.segundos': '{n} s',
  'pin.minutos': '{n} min',
  'pin.aceptado': 'PIN correcto',
  'pin.confirmar': 'Confirme con su PIN',
  'pin.borrar': 'Borrar el último número',

  // ---------- Inicio ----------
  'inicio.vender': 'Vender',
  'inicio.ajustes': 'Ajustes',
  'inicio.bloquear': 'Bloquear/Cambiar de usuario',
  'inicio.sinSesion': 'Sin sesión',
  'inicio.vendidoHoy': 'Vendido hoy',
  'inicio.lotesPorVencer': '{n} lote(s) vencidos o por vencer',
  'inicio.pedidosHoy': '{n} pedido(s) para entregar hoy',
  'inicio.pedidosCortos': '{n} pedido(s) sin mercadería suficiente para entregar',
  'inicio.transferenciasPendientes': '{n} transferencia(s) sin confirmar',
  'inicio.transferenciasViejas': '{n} transferencia(s) sin confirmar, la más vieja de hace {dias} días',

  // ---------- Punto de venta ----------
  'pos.sinCaja': 'No hay caja abierta',
  'pos.sinCajaExplicacion':
    'Antes de vender hay que empezar el día, o su turno: contar el dinero con el que empieza la gaveta.',
  'pos.volverInicio': 'Volver al inicio',
  'pos.cliente': 'Cliente',
  'pos.clientes': 'Clientes',
  'pos.caja': 'Caja',
  'pos.historial': 'Historial',
  'pos.entregandoPedido':
    'Entregando un pedido de {cliente}. Al cobrar queda marcado como entregado.',
  'pos.unCliente': 'un cliente',
  'pos.pedidoDespues': 'El pedido de {cliente} se carga en cuanto la caja quede abierta.',
  'pos.pedidoAlRecibir': 'El pedido de {cliente} se carga en cuanto reciba la caja.',
  'pos.reemplazarTitulo': '¿Cambiar la venta por el pedido?',
  'pos.reemplazarMensaje': 'Ya hay {n} línea(s) en la venta. Si carga el pedido de {cliente}, se quitan, y la venta queda solo con el pedido.',
  'pos.cargarElPedido': 'Cargar el pedido',
  'pos.ventaRapidaEnlace': 'Venta rápida (algo que no está en el catálogo)',
  'pos.busqueEmpezar': 'Busque un producto para empezar',
  'pos.lista': 'lista',
  'pos.cobrar': 'Cobrar',
  'pos.noSePudoRegistrar': 'No se pudo registrar la venta',
  'pos.motivoAutorizacion':
    'Este precio queda bajo el margen mínimo. Se registrará quién lo autorizó.',
  'pos.motivoRapidas':
    'Las ventas rápidas de esta venta suman {monto}, más de los {maximo} que se cobran sin el dueño. Sin producto, nada revisa su precio. Se registrará quién lo autorizó.',
  'pos.rapidasPidenDueno': 'Las ventas rápidas de esta venta pasan de {maximo}: cobrarla pide el PIN del dueño.',
  'pos.loteVencido': 'hay vencidos',
  'pos.medicinaVencida':
    '{producto}: aquí hay unidades vencidas desde el {fecha}. Revise que la que se lleva no sea de esas; cobrarla pide el PIN del dueño. Las vencidas se sacan en «Vencimientos».',
  'pos.medicinaVencidaDueno':
    '{producto}: aquí hay unidades vencidas desde el {fecha}. Revise que la que se lleva no sea de esas, y sáquelas en «Vencimientos».',
  'pos.perecederoVencido':
    '{producto}: aquí hay unidades vencidas desde el {fecha}. No venda esas; se sacan en «Vencimientos».',
  'pos.motivoVencida':
    'En esta venta hay medicamento con unidades vencidas en el estante: {productos}. Revise que lo que se lleva el cliente no esté vencido. Se registrará quién lo autorizó.',
  'pos.lineaApartada': '{cantidad} apartado',
  'pos.apartadoPara': '{producto}: {cantidad} para {clientes}',
  'pos.apartadoPideDueno': '{producto}: {cantidad} de esta venta está apartado para {clientes}; cobrarla pide el PIN del dueño.',
  'pos.apartadoDueno': '{producto}: {cantidad} de esta venta está apartado para {clientes}. Vendido, no alcanza para lo que encargaron.',
  'pos.venderApartado': '¿Vender lo apartado?',
  'pos.venderIgual': 'Vender igual',
  'pos.motivoApartado':
    'Esta venta lleva lo apartado para pedidos: {productos}. Vendido, no alcanza para lo que encargaron hasta que llegue más. Se registrará quién lo autorizó.',
  'pos.motivoApartadoDueno':
    'Esta venta lleva lo apartado para pedidos: {productos}. Vendido, no alcanza para lo que encargaron hasta que llegue más.',
  'pos.lineaQueda': 'Quedan {cantidad}',
  'pos.faltaPara': '{producto}: quedan {libre} y lleva {lleva}',
  'pos.faltaDueno': '{producto}: quedan {libre} y la venta lleva {lleva}, más de lo que dicen los libros.',
  'pos.faltaPideDueno': '{producto}: quedan {libre} y la venta lleva {lleva}; cobrarla pide el PIN del dueño.',
  'pos.faltaApartadoDueno': '{producto}: quedan {libre} sin apartar y la venta lleva {lleva}; lo demás está apartado para {clientes}.',
  'pos.faltaApartadoPideDueno':
    '{producto}: quedan {libre} sin apartar y la venta lleva {lleva}; lo demás está apartado para {clientes}, y cobrarla pide el PIN del dueño.',
  'pos.venderDeMas': '¿Vender más de lo que hay?',
  'pos.motivoFaltaDueno':
    'Esta venta lleva más de lo que los libros dicen que hay libre: {productos}. Si lo tiene en la mano, véndalo: lo que dicen los libros se arregla contando.',
  'pos.motivoFalta':
    'Esta venta lleva más de lo que los libros dicen que hay libre: {productos}. Si lo tiene en la mano, véndalo: lo que dicen los libros se arregla contando. Se registrará quién lo autorizó.',
  'pos.confirmando': 'Confirmando con el servidor…',
  'pos.yaNoHay': '{motivo}. Otra caja la vendió primero: la venta no se cobró.',
  'pos.sinConexionVende': 'Sin conexión: las ventas no se confirman con el servidor. La caja sigue vendiendo.',
  'pos.sinConfirmar': 'El servidor no contestó a tiempo: la venta quedó registrada sin confirmar y se envía en cuanto haya conexión.',
  'pos.rapidaPideDueno': 'Con esta, las ventas rápidas de esta venta pasan de {maximo}: al cobrar se pedirá el PIN del dueño.',
  'pos.motivoLista':
    '«{lista}» no es la lista de esta venta. Se registrará quién lo autorizó.',
  'pos.nombreOTelefono': 'Nombre o teléfono',
  'pos.pedidosPorEntregar': 'Pedidos por entregar',
  'pos.entrega': 'Entrega {fecha} · {n} línea(s)',
  'pos.sinCliente': 'Sin cliente (venta de mostrador)',
  'pos.listaPredeterminada': 'Lista predeterminada',
  'pos.cobrarA': 'Cobrar a',
  'pos.listaDeLinea': 'Lista de precios de {producto}',
  'pos.presentacionDeLinea': 'Presentación de {producto}',
  'pos.clienteMostrador': 'Cliente de mostrador',
  'pos.clienteAyuda': 'Elija un cliente para usar sus precios o sus pedidos',
  'pos.clienteCambiar': 'Toque para cambiar',
  'pos.quitarCliente': 'Quitar el cliente',
  'pos.quitarLinea': 'Quitar {producto} de la venta',
  'pos.cantidadDe': 'Cantidad de {producto}',
  'pos.unoMas': 'Uno más',
  'pos.unoMenos': 'Uno menos',
  'pos.confirmarQuitar': '{producto} ({total}) se quita de esta venta.',
  'lista.publico': 'Precio al público',
  'lista.mayorista': 'Precio mayorista',
  'lista.publicoCorta': 'Público',
  'lista.mayoristaCorta': 'Mayorista',
  'pos.venta': 'Venta {ticket}',
  'pos.siguienteVenta': 'Siguiente venta',
  'pos.volverAPedidos': 'Volver a los pedidos',
  'pos.ventaRapida': 'Venta rápida',
  'pos.ventaRapidaExplicacion':
    'Para cobrar algo que todavía no está en el catálogo. No mueve inventario y queda marcado para que alguien lo convierta en producto después.',
  'pos.descripcion': 'Descripción',
  'pos.ejemploVentaRapida': 'Bolsa de hielo',
  'pos.producto': 'Producto',
  'pos.sinPrecio': 'sin precio',
  'pos.faltaPrecio':
    '{producto} no tiene precio en esta lista. Escríbalo aquí, o póngaselo en Productos para que quede guardado.',
  'pos.faltaPrecioSoloAqui':
    '{producto} no tiene precio en esta lista. Escríbalo aquí para esta venta; el precio de siempre se lo pone el dueño en Productos.',
  'pos.hayLineasSinPrecio':
    'Hay {n} producto(s) sin precio. Toque cada uno y escríbalo — no se puede cobrar en cero.',
  'pos.faltaPrecioPida':
    '{producto} no tiene precio en esta lista. Pídale al dueño que se lo ponga en Productos, o quítelo de la venta.',
  'pos.hayLineasSinPrecioPida':
    'Hay {n} producto(s) sin precio: el dueño se los pone en Productos, o quítelos de la venta. No se puede cobrar en cero.',
  'pos.enLaVenta': '{n} en la venta',

  // ---------- Cobro ----------
  'cobro.titulo': 'Cobrar',
  'cobro.vuelto': 'Vuelto',
  'cobro.registrando': 'Registrando…',
  'cobro.confirmarVenta': 'Confirmar venta',
  'cobro.faltan': 'Faltan {monto}',
  'cobro.redondeo': 'Redondeo de efectivo',
  'cobro.productosYEnvio': 'Productos + envío',
  'envio.campo': 'Envío',
  'envio.mal': 'Escriba un monto, o déjelo vacío.',
  'envio.demasiado': 'Con ese envío pasa de lo que el sistema puede llevar, C$ 100,000,000.',
  'cobro.sinConfirmar': 'sin confirmar',
  'cobro.agregarPago': 'Agregar este pago',
  'cobro.dividir': 'Pagar de varias formas',
  'cobro.ayudaParte': 'Escriba solo lo que paga de esta forma. El resto se cobra después.',
  'cobro.ayudaVuelto': 'Si le dan más, escríbalo para ver el vuelto.',
  'cobro.dolaresA': 'US$ {monto} a {tasa}',
  'cobro.dolaresRecibidos': 'Dólares recibidos',
  'cobro.monto': 'Monto',
  'cobro.equivale': 'Equivale a {monto} a {tasa}',
  'cobro.ayudaReferencia':
    'Queda pendiente hasta que alguien confirme que el dinero llegó. Una captura de pantalla no es un pago.',
  'cobro.referenciaObligatoria': 'Referencia del comprobante',
  'cobro.faltaReferencia': 'Escriba la referencia',
  'cobro.referenciaRepetida': 'Esa referencia ya pagó la venta {ticket} ({monto}). Un comprobante paga una sola vez: revíselo antes de aceptarlo.',
  'cobro.referenciaEnRecarga': 'Esa referencia ya pagó una recarga ({monto}). Un comprobante paga una sola vez: revíselo antes de aceptarlo.',
  'cobro.referenciaEnAbono': 'Esa referencia ya pagó un abono ({monto}). Un comprobante paga una sola vez: revíselo antes de aceptarlo.',
  'cobro.referenciaEnOtraParte': 'Esa referencia ya está en otra parte de este cobro.',
  'cobro.sinVuelto': 'Una transferencia o un pago por billetera no da vuelto: se cobran los {monto} que faltan.',
  'pago.efectivo_cordobas': 'Efectivo C$',
  'pago.efectivo_dolares': 'Dólares',
  'pago.transferencia': 'Transferencia',
  'pago.billetera': 'Billetera',
  'pago.tarjeta': 'Tarjeta',
  'pago.credito': 'Crédito',

  // ---------- Línea de venta ----------
  'linea.pedirAutorizacion': 'Pedir autorización',
  'linea.ayudaCantidad': 'Acepta medios y cuartos: 2 1/2, 0.25',
  'linea.presentacion': 'Presentación',
  'linea.precioLista': 'Precio de lista: {monto}',
  'linea.precioFijo': 'Precio de lista: {monto}. Su usuario no cambia precios.',
  'linea.motivoCambio': 'Motivo del cambio',
  'linea.ejemploMotivo': 'Cliente frecuente',
  'linea.faltaMotivo': 'Todo cambio de precio necesita un motivo',
  'linea.bajoMinimoRegistrado':
    'Este precio queda bajo el margen mínimo. Quedará registrado en la bitácora.',
  'linea.bajoMinimoPin': 'Este precio queda bajo el margen mínimo. Necesita el PIN del dueño.',
  'linea.sinCostoPin': 'No se sabe cuánto costó este producto: bajarle el precio necesita el PIN del dueño.',

  // ---------- Buscador y margen ----------
  'buscador.placeholder': 'Nombre o código…',
  'buscador.codigoDesconocido': 'El código {codigo} no está en el catálogo.',
  'buscador.crear': 'Crear «{nombre}»',
  'buscador.preguntaTitulo': 'Código desconocido',
  'buscador.desactivado': 'Desactivado',
  'abiertos.buscando': 'Buscando este código en los catálogos abiertos…',
  'abiertos.segun': 'Según {fuente}',
  'abiertos.nadie': 'Los catálogos abiertos tampoco lo conocen.',
  'abiertos.enPractica': 'La tienda de práctica no busca los códigos en los catálogos abiertos: eso lo hace la tienda de verdad.',
  'abiertos.sinRespuesta': 'No se pudo preguntar a los catálogos abiertos: sin señal, o no contestaron.',
  'abiertos.suyos': '¿Es uno de los suyos? Tóquelo y el código queda guardado en él.',
  'abiertos.alCrear': '«Crear producto» lo llena con estos datos.',
  'abiertos.esEste': '¿Es este producto?',
  'abiertos.usar': 'Usar estos datos',
  'abiertos.noUsar': 'No, lo lleno yo',
  'abiertos.ver': 'Ver lo que dice {fuente}',
  'abiertos.llenado': 'Llenado con lo que dice {fuente}. Revíselo antes de guardar.',
  'margen.margen': 'margen',
  'margen.sobreCosto': '{recargo} sobre costo · gana {ganancia}',
  'margen.bajoCosto': 'Se vende por debajo del costo',

  // ---------- Caja ----------
  'caja.titulo': 'Caja',
  'caja.abierta': 'Caja abierta',
  'caja.subtitulo': '{n} venta(s)',
  'caja.fondoInicial': 'Fondo inicial',
  'caja.ventasTurno': 'Ventas del turno',
  'caja.efectivoRecibido': 'Efectivo C$ recibido',
  'caja.dolaresRecibidos': 'Dólares recibidos',
  'caja.otrosMedios': 'Otros medios de pago',
  'caja.vueltoEntregado': 'Vuelto entregado',
  'caja.retiros': 'Retiros',
  'caja.ingresos': 'Ingresos',
  'caja.retirar': 'Retirar efectivo',
  'caja.ingresar': 'Ingresar efectivo',
  'caja.registrar': 'Registrar',
  'caja.ejemploRetiro': 'A la caja fuerte',
  'caja.ejemploIngreso': 'Cambio adicional',
  'caja.explicacionMovimiento':
    'El dinero no desaparece: sale de la gaveta y entra a la caja fuerte, así que el conteo esperado baja pero el balance sigue completo.',
  'caja.listo': 'Listo',
  'caja.esperadoCordobas': 'Esperado en córdobas',
  'caja.esperadoAyuda': 'Lo que debería haber en córdobas en la gaveta, según lo que se registró en el turno: el fondo con que abrió, más el efectivo que entró, menos el que salió. Lo cobrado con tarjeta, por transferencia, con billetera o al fiado no pasa por la gaveta, y los dólares se cuentan aparte.',
  'caja.contado': 'Contado',
  'caja.cuadraExacto': 'La caja cuadra exacto.',
  'caja.sobrante': 'Sobrante',
  'caja.faltante': 'Faltante',
  'caja.fondoCordobas': 'Córdobas en la gaveta',
  'caja.fondoDolares': 'Dólares en la gaveta',
  'caja.montoInvalido': 'Escriba solo el número, por ejemplo 20 o 20.50.',
  'caja.fondoEnDolares': 'Fondo en dólares',
  'caja.dolaresRetirados': 'Dólares retirados',
  'caja.dolaresIngresados': 'Dólares ingresados',
  'caja.moneda': 'Moneda',
  'caja.montoCordobas': 'Monto en córdobas',
  'caja.montoDolares': 'Monto en dólares',
  'caja.esperadoDolares': 'Esperado en dólares',
  'caja.esperadoDolaresAyuda': 'Los dólares que debería haber en la gaveta: los del fondo, más los que pagaron los clientes y los que se ingresaron, menos los que se retiraron. El vuelto se da en córdobas, así que no los baja.',
  'caja.cordobasCuadran': 'Los córdobas cuadran.',
  'caja.dolaresCuadran': 'Los dólares cuadran.',
  'caja.cordobasContados': 'Córdobas contados',
  'caja.dolaresContados': 'Dólares contados',
  'caja.seValoranA': 'Se valoran a {tasa}',
  'caja.turnosAnteriores': 'Turnos anteriores',
  'caja.sinTurnos': 'Sin turnos cerrados todavía.',
  'caja.vendido': 'vendido {monto}',
  'caja.cuadro': 'cuadró',
  'caja.dejoElCorte': 'Dejó el último corte',
  'caja.puestoDeGeneral': 'Puesto de efectivo general',
  'caja.debiaHaber': 'Debía haber',
  'caja.aperturaCuadra': 'Está todo lo que dejó el corte.',
  'caja.aperturaCuadraPuesto': 'Está todo: lo que dejó el corte y lo que usted puso.',
  'caja.aperturaCuadraLoPuesto': 'Está todo lo que usted puso.',
  'caja.aperturaCuadraVacia': 'La gaveta empezó vacía, como debía.',
  'caja.aperturaExplicacion':
    'La diferencia queda apuntada como sobrante o faltante de caja, igual que en un corte, y el turno arranca con lo que usted contó.',
  'caja.diferenciaApertura': 'Diferencia al abrir',
  'caja.ajusteEntrega': 'Diferencia al recibirla',
  'caja.ajusteEntregaDolares': 'Diferencia en dólares al recibirla',
  'caja.quedaMasQueContado': 'Contó {monto}: no puede dejar más que eso.',
  'caja.saque': 'Saque de la gaveta',
  'caja.saqueNota': 'Guárdelo con el efectivo general. En la gaveta quedan {monto} para el vuelto.',
  'caja.nadaQueSacar': 'No hay nada que sacar: los {monto} quedan en la gaveta para el vuelto.',
  'caja.saqueTodo': 'Guárdelo con el efectivo general. En la gaveta no queda nada.',
  'caja.recibeAhora': 'El dueño lo recibe ahora',
  'caja.recibeAhoraAyuda': 'Con su PIN: pasa directo a efectivo general.',
  'caja.porRecibirAyuda': 'Si no, queda por recibir: el dueño lo cuenta cuando lo recibe, y lo que falte es de este turno.',
  'caja.ustedRecibe': 'Usted lo recibe: pasa a efectivo general.',
  'caja.motivoRecibir': 'Lo que sale de la gaveta pasa a efectivo general, recibido a su nombre.',
  'caja.saqueNotaPorRecibir':
    'Entrégueselo al dueño: queda por recibir hasta que lo cuente. En la gaveta quedan {monto} para el vuelto.',
  'caja.saqueTodoPorRecibir': 'Entrégueselo al dueño: queda por recibir hasta que lo cuente. En la gaveta no queda nada.',
  'caja.gavetaVacia': 'La gaveta está vacía: no hay nada que sacar.',
  'caja.deRuta': 'Esta caja es de una ruta que salió antes de que se quitara el reparto: se cierra liquidando la ruta, la plata y lo que quedó en el camión juntos.',
  'caja.entregado': 'a efectivo general {monto}',
  'caja.alAbrir': 'al abrir {monto}',
  'caja.abrioCerro': 'abrió {abrio}, cerró {cerro}',
  'caja.enEntregas': 'al entregarla {monto}',

  'caja.cerradaTitulo': 'La caja está cerrada',
  'caja.cerradaExplicacion': 'Para vender, empiece: se cuenta lo que hay en la gaveta, paso a paso.',
  'caja.primerConteoAlAbrir': 'al abrir contó dos veces; la primera, {monto}',
  'caja.primerConteoAlCerrar': 'al cerrar contó dos veces; la primera, {monto}',
  'caja.primerConteoAlRecibir': 'al recibirla contó dos veces; la primera, {monto}',

  // ---------- Empezar y terminar: el día y el turno ----------
  'asistente.paso': '{n} de {total}',
  'asistente.atras': 'Atrás',
  'asistente.siguiente': 'Siguiente',
  'contar.billetesDe': 'Billetes de {billete}',
  'contar.monedas': 'Monedas',
  'contar.monedasEtiqueta': 'Monedas, en córdobas',
  'contar.monedasAyuda': 'Las monedas van todas juntas: súmelas y escriba cuánto dan.',
  'contar.total': 'Total contado',
  'contar.revise': 'Revise lo escrito',
  'turno.empezarDia': 'Empezar el día',
  'turno.empezarTurno': 'Empezar mi turno',
  'turno.terminarTurno': 'Terminar mi turno',
  'turno.terminarDia': 'Terminar el día',
  'turno.subtitulo': 'Un paso a la vez',
  'turno.cajaDe': 'Caja de {nombre}',
  'turno.comenzar': 'Empezar',
  'turno.empezarDiaExplicacion':
    'Antes de vender se cuenta el dinero que hay en la gaveta. Así, al final del día, se sabe si todo cuadró. Son unos pocos pasos, uno por pantalla.',
  'turno.empezarTurnoExplicacion':
    'Antes de atender, cuente el dinero que le dejó el turno anterior. Si falta o sobra algo, se sabe ahora y no se le carga a usted.',
  'turno.pusoTitulo': '¿Puso dinero del efectivo general en la gaveta?',
  'turno.pusoExplicacion': 'Por ejemplo, si faltaba sencillo y trajo más de la caja fuerte. Si no tocó nada, diga que no.',
  'turno.pusoCambioTitulo': '¿Puso dinero para el cambio?',
  'turno.pusoCambioExplicacion':
    'La gaveta empieza sin fondo. Si trajo dinero del efectivo general para dar cambio, diga cuánto; si no trajo nada, diga que no.',
  'turno.pusoNo': 'No, no puse nada',
  'turno.pusoSi': 'Sí, puse dinero',
  'turno.cuantoPuso': '¿Cuántos córdobas puso?',
  'turno.cuantoPusoAyuda': 'Lo que trajo del efectivo general. Va incluido en lo que cuente después.',
  'turno.contarCordobas': 'Cuente los córdobas de la gaveta',
  'turno.contarCordobasExplicacion':
    'Escriba cuántos billetes hay de cada uno, y lo que suman las monedas: el sistema hace la suma. Cuente lo que hay de verdad, no lo que debería haber.',
  'turno.contarCordobasVisible':
    'El turno anterior dejó {monto}. Escriba cuántos billetes hay de cada uno, y lo que suman las monedas.',
  'turno.contarCiego':
    'Escriba cuántos billetes hay de cada uno, y lo que suman las monedas. El sistema no le dice cuánto esperaba hasta el final: así el conteo vale de verdad.',
  'turno.contarDolares': '¿Hay dólares en la gaveta?',
  'turno.contarDolaresAbrir': 'Cuente los billetes de dólar aparte. Si no hay ninguno, toque «No hay dólares».',
  'turno.contarDolaresCerrar': 'Cuente aparte todos los billetes de dólar. Si no hay ninguno, toque «No hay dólares».',
  'turno.sinDolares': 'No hay dólares',
  'turno.sinCordobas': 'No hay córdobas',
  'turno.contarLoPuesto': 'Cuente también los {monto} que puso para el cambio: ya están en la gaveta.',
  'turno.otraVez': 'Algo no cuadra: cuente otra vez',
  'turno.otraVezExplicacion':
    'Cuente otra vez, con calma: billete por billete, y las monedas. No le decimos cuánto ni para dónde: así el conteo vale. Lo que cuente ahora es lo que queda.',
  'turno.revise': 'Revise antes de seguir',
  'turno.reviseAbrir': 'Si algo está mal, toque «Atrás» y corríjalo. Con el botón de abajo, la caja queda abierta.',
  'turno.reviseCerrar': 'Si algo está mal, toque «Atrás» y corríjalo. Con el botón de abajo se hace el corte y la caja queda cerrada.',
  'turno.reviseRecibir': 'Si algo está mal, toque «Atrás» y corríjalo. Al recibirla, la caja de {nombre} pasa a su nombre.',
  'turno.loQueDejo': 'Lo que dejó el turno anterior',
  'turno.loQueEncontro': 'Lo que encontró el conteo',
  'turno.pedidosHoy': 'Pedidos para entregar hoy',
  'turno.pedidosHoyExplicacion':
    'Estos clientes esperan su pedido hoy. Si alguno ya debía haberse entregado, dice desde cuándo.',
  'turno.pedidoAtrasado': 'Atrasado: era para el {fecha}',
  'turno.avisosTitulo': 'Antes de vender, fíjese en esto',
  'turno.avisosExplicacion':
    'Productos que se acaban, que vencen o que hay que contar. Toque uno para verlo, o siga: también están en el inicio.',
  'turno.abiertaTitulo': '¡Listo! La caja está abierta',
  'turno.abiertaExplicacion': 'Ya puede vender. Al final de su turno, toque «Terminar mi turno» en el inicio y siga los pasos.',
  'turno.irAlInicio': 'Ir al inicio',
  'turno.yaAbierta': 'Ya hay una caja abierta en este aparato. Para empezar otra, primero termine ese turno.',
  'turno.verCaja': 'Ver la caja',
  'turno.noHayCaja': 'No hay una caja abierta en este aparato: no hay turno que terminar.',
  'turno.nadaQueRecibir': 'No hay una caja de otra persona abierta en este aparato.',
  'turno.quienSigue': '¿Alguien más atiende después de usted hoy?',
  'turno.quienSigueExplicacion':
    'Al terminar su turno se cuenta la gaveta y se entrega el dinero. Si se cierra la tienda, además se repasa el día.',
  'turno.sigueOtra': 'Sí, sigue otra persona',
  'turno.sigueOtraDetalle': 'Se deja el vuelto para quien sigue, y lo demás se entrega.',
  'turno.seCierra': 'No, se cierra la tienda',
  'turno.seCierraDetalle': 'Se deja el vuelto para mañana, se entrega lo demás y se repasa el día.',
  'turno.quedaTitulo': '¿Cuánto deja en la gaveta para dar vuelto?',
  'turno.quedaExplicacion':
    'Es el fondo para dar vuelto, y se queda en la gaveta {para}. Ya viene puesto: cámbielo solo si deja otra cantidad. Lo demás, y todos los dólares, se le entregan al dueño.',
  'turno.quedaExplicacionCero':
    'Lo que deje para dar vuelto se queda en la gaveta {para}. Viene en 0: escriba cuánto deja, si deja algo. Lo demás, y todos los dólares, se le entregan al dueño.',
  'turno.paraManana': 'hasta mañana',
  'turno.paraElSiguiente': 'para la persona que sigue',
  'turno.quedaCampo': 'Se queda en la gaveta',
  'turno.quedaAyuda': 'En córdobas. No puede ser más de lo que contó.',
  'turno.saleCordobas': 'Sale para el dueño',
  'turno.saleDolares': 'Dólares para el dueño',
  'turno.quienRecibe': '¿Quién recibe el dinero?',
  'turno.quienRecibeExplicacion':
    'Lo que sale de la gaveta va al efectivo general. Si el dueño está, lo recibe ya, con su PIN; si no, se lo entrega después y él lo cuenta.',
  'turno.recibeAhora': 'El dueño lo recibe ahora',
  'turno.recibeDespues': 'Se lo entrego después',
  'turno.contoCordobas': 'Córdobas contados',
  'turno.contoDolares': 'Dólares contados',
  'turno.loRecibe': 'Lo recibe',
  'turno.recibeUsted': 'Usted',
  'turno.recibeElDueno': 'El dueño, ahora',
  'turno.quedaPorRecibir': 'El dueño, después',
  'turno.notas': 'Algo que el dueño deba saber (si hay)',
  'turno.notasAyuda': 'Por ejemplo: «se pagó el agua de la gaveta» o «un billete de 500 venía roto».',
  'turno.resultadoTitulo': 'Lo que encontró el corte',
  'turno.resumenTitulo': 'El resumen del día',
  'turno.resumenExplicacion': 'Todo lo de hoy en esta caja, turno por turno. Mándeselo al dueño por WhatsApp, o imprímalo.',
  'turno.enviarWhatsapp': 'Mandar por WhatsApp',
  'turno.pendientesTitulo': 'Lo que queda pendiente',
  'turno.pendientesExplicacion': 'Esto espera al dueño. Toque uno para verlo ahora, o siga: también está en el inicio.',
  'turno.mananaTitulo': 'Pedidos para mañana',
  'turno.mananaExplicacion': 'Estos clientes esperan su pedido mañana. Si hay que alistar algo, este es el momento.',
  'turno.guardadoTitulo': '¿Ya está todo en el servidor?',
  'turno.guardadoExplicacion':
    'Antes de apagar, revise que lo de hoy se haya subido. Lo que no se ha subido está solo en este aparato.',
  'turno.guardadoTodo': 'Todo lo de hoy está guardado en el servidor.',
  'turno.guardando': 'Subiendo lo de hoy al servidor… Faltan {n}.',
  'turno.guardadoSinConexion':
    'No hay internet. Hay {n} registro(s) guardados solo en este aparato: se suben solos cuando vuelva la señal. No borre la app ni sus datos.',
  'turno.guardadoError': 'No se pudo subir: {error}. Se vuelve a intentar solo.',
  'turno.guardadoNoSube': 'Este aparato no está subiendo nada al servidor. Avísele al dueño.',
  'turno.guardadoPractica': 'La tienda de práctica no guarda nada en el servidor: aquí no hay nada que subir.',
  'turno.reintentar': 'Intentar otra vez',
  'turno.hastaManana': '¡Listo! Hasta mañana',
  'turno.hastaMananaExplicacion': 'La caja quedó cerrada y el día está repasado. Mañana, toque «Empezar el día» en el inicio.',
  'turno.turnoTerminado': 'Su turno terminó',
  'turno.turnoTerminadoExplicacion':
    'Ahora la persona que sigue entra con su PIN y toca «Empezar mi turno»: cuenta lo que usted dejó en la gaveta.',
  'turno.pasarALaSiguiente': 'Pasar a la persona que sigue',
  'turno.aContar': 'Empezar a contar',
  'turno.primerConteo': 'Primer conteo',
  'turno.segundoConteo': 'Segundo conteo',
  'turno.r.titulo': 'Resumen del día {fecha}',
  'turno.r.vendido': 'Vendido',
  'turno.r.enEfectivo': 'En efectivo',
  'turno.r.otros': 'Transf./tarjeta',
  'turno.r.fiado': 'Fiado',
  'turno.r.dolares': 'Dólares recibidos',
  'turno.r.abonos': 'Abonos',
  'turno.r.devoluciones': 'Devoluciones',
  'turno.r.retiros': 'Retiros',
  'turno.r.pagado': 'Pagado de gaveta',
  'turno.r.alAbrir': 'Al abrir',
  'turno.r.primerConteo': '1.er conteo',
  'turno.r.entregas': 'Al entregarla',
  'turno.r.corte': 'Corte',
  'turno.r.corteDolares': 'Corte en dólares',
  'turno.r.cuadro': 'Cuadró',
  'turno.r.sobro': 'Sobró {monto}',
  'turno.r.falto': 'Faltó {monto}',
  'turno.r.queda': 'Quedó en gaveta',
  'turno.r.saco': 'Se sacó',
  'turno.r.porRecibir': '(El dueño aún no lo recibe)',
  'turno.r.totalDia': 'Total del día',
  'turno.r.diferencias': 'Diferencias',

  // ---------- Ventas ----------
  'ventas.titulo': 'Ventas',
  'ventas.registradas': '{n} registradas',
  'ventas.registradasHoy': '{n} registradas · {total}',
  'ventas.sinVentas': 'Todavía no hay ventas.',
  'ventas.rapidasRecientes': '{n} venta(s) rápida(s) en los últimos {dias} días',
  'ventas.rapidasTitulo': 'Ventas rápidas',
  'ventas.rapidasSubtitulo': '{n} en los últimos {dias} días · {total}',
  'ventas.rapidasAyuda': 'Lo que se cobró sin producto: sin costo, sin mover inventario y sin revisar el margen. Un mismo nombre o una misma persona que se repite merece una pregunta; lo que se vende seguido conviene crearlo como producto.',
  'ventas.sinRapidas': 'Ninguna venta rápida en los últimos {dias} días.',
  'ventas.rapidaMeta': '{fecha} · {ticket} · {quien}',
  'ventas.autorizo': 'autorizó {nombre}',
  'ventas.alguien': 'alguien',
  'ventas.crearProducto': 'Crear producto',
  'ventas.sinVentasHoy': 'Todavía no hay ventas hoy.',
  'ventas.lineas': '{fecha} · {n} línea(s)',
  'ventas.transferenciaSinConfirmar': 'transferencia sin confirmar',
  'ventas.anulada': 'anulada',
  'ventas.noSePudoAnular': 'No se pudo anular esta venta.',
  'ventas.descuento': 'Descuento',
  'ventas.envio': 'Envío',
  'ventas.redondeo': 'Redondeo',
  'ventas.pendiente': ' (pendiente)',
  'ventas.utilidadBruta': 'Utilidad bruta',
  'ventas.motivoAnulacion': 'Anulada: {motivo}',
  'ventas.anularVenta': 'Anular esta venta',
  'ventas.anularDeCaja':
    'Esta venta es de un turno ya cerrado: los {monto} en efectivo salen de la caja abierta de este equipo, para devolvérselos al cliente.',
  'ventas.anularSinCaja':
    'Esta venta es de un turno ya cerrado. Para devolver los {monto} en efectivo, primero abra la caja en este equipo.',
  'ventas.pinParaAnular':
    'La anulación de {ticket} queda a nombre de {nombre}. Escriba el PIN de {nombre} para confirmar.',
  'ventas.regresaInventario': 'El producto regresa al inventario',
  'ventas.regresaInventarioDesc':
    'Desmárquelo si volvió dañado: el costo pasa a merma en vez de a inventario.',

  // ---------- Transferencias ----------
  'transf.titulo': 'Transferencias sin confirmar',
  'transf.abono': 'Abono a la cuenta',
  'transf.recarga': 'Recarga {operadora} {telefono}',
  'transf.deHoy': 'de hoy',
  'transf.deAyer': 'esperando desde ayer',
  'transf.haceDias': 'esperando desde hace {n} días',
  'transf.referenciaRepetida': 'Referencia repetida: también pagó la venta {ticket}',
  'transf.referenciaEnRecarga': 'Referencia repetida: también pagó una recarga',
  'transf.referenciaEnAbono': 'Referencia repetida: también pagó un abono',
  'transf.pasarAFiado': 'Pasarlo a la cuenta de {nombre}',
  'transf.referenciaAlConfirmar': 'Referencia que aparece en el banco',
  'transf.enQueCuenta': '¿En qué cuenta llegó?',
  'transf.porVerificar': '{monto} por verificar',
  'transf.ninguna': 'No hay transferencias pendientes. Todo el dinero cobrado está verificado.',
  'transf.quePaso': '¿Qué pasó?',
  'transf.ejemplo': 'El dinero nunca llegó',
  'transf.registrarPerdida': 'Registrar pérdida',
  'transf.noLlego': 'No llegó',
  'transf.noLlegoTitulo': 'El pago no llegó',
  'transf.confirmar': 'Confirmar',
  'transf.referencia': 'ref. {ref}',

  // ---------- Vencimientos ----------
  'venc.titulo': 'Vencimientos',
  'venc.subtitulo': '{n} lote(s) · {monto} en riesgo',
  'venc.lotes': '{n} lote(s)',
  'venc.yaVencidos':
    '{n} lote(s) ya vencidos siguen contados como existencia. Darlos de baja los saca del inventario y los registra como pérdida.',
  'venc.ninguno': 'Ningún lote vence en los próximos {dias} días.',
  'venc.lote': 'Lote {numero} · {cantidad} {unidad}',
  'venc.vence': 'Vence {fecha}',
  'venc.enDias': ' · en {n} día(s)',
  'venc.haceDias': ' · hace {n} día(s)',
  'venc.darDeBaja': 'Dar de baja este lote',
  'venc.registrando': 'Registrando…',
  'venc.notaBaja': 'Lote {numero}, venció {fecha}',
  'venc.estado.vencido': 'Vencido',
  'venc.estado.critico': 'Vence esta semana',
  'venc.estado.proximo': 'Por vencer',
  'venc.estado.ok': 'Vigente',

  // ---------- Productos ----------
  'productos.titulo': 'Productos',
  'productos.subtitulo': '{activos} activos',
  'productos.subtituloConInactivos': '{activos} activos · {inactivos} desactivados',
  'productos.cargaRapida': 'Carga rápida',
  'productos.buscar': 'Buscar por nombre o código…',
  'productos.ninguno': 'Ningún producto coincide',
  'productos.sinProductos': 'Todavía no hay productos',
  'productos.empezarCatalogo': 'Empezar con un catálogo básico',
  'productos.cargarAMano': 'O cargar varios a mano',
  'productos.medicamento': 'Medicamento',
  'productos.perecedero': 'Perecedero',
  'productos.escanearTitulo': 'Buscar producto',
  'productos.verProducto': 'Ver el producto',
  'productos.crearConCodigo': 'Crear producto',
  'productos.vistaActivos': 'Activos',
  'productos.vistaDesactivados': 'Desactivados',
  'productos.sinDesactivados': 'No hay productos desactivados',
  'productos.seleccionar': 'Seleccionar',
  'productos.todos': 'Todos',
  'productos.elegidos': '{n} seleccionado(s)',
  'productos.desactivarVarios': 'Desactivar {n}',
  'productos.reactivarVarios': 'Reactivar {n}',
  'productos.desactivando': 'Desactivando {n} de {total}…',
  'productos.reactivando': 'Reactivando {n} de {total}…',
  'productos.desactivarVariosTitulo': '¿Desactivar {n} producto(s)?',
  'productos.desactivarVariosMensaje':
    'Dejan de aparecer al vender, en los precios y en esta lista, y sus códigos ya no los encuentran. No se borran: lo que ya se vendió o compró con ellos sigue a su nombre, y se pueden reactivar desde «Desactivados».',
  'productos.catalogo': 'Catálogo de precios',

  // ---------- Catálogo de precios ----------
  'catalogo.titulo': 'Catálogo de precios',
  'catalogo.tituloDe': 'Catálogo de precios de {negocio}',
  'catalogo.explicacion':
    'Un PDF con lo que vale cada producto en las listas marcadas, por categoría y con su foto, para mandarlo o imprimirlo. Sin costos ni existencias.',
  'catalogo.listas': 'Listas de precios',
  'catalogo.cuantos': '{n} producto(s) · {paginas} página(s)',
  'catalogo.conFotos': 'Con la foto de {n} de ellos.',
  'catalogo.ofertas': 'Ofertas',
  'catalogo.ofertaAntes': 'Antes {antes} · hasta el {hasta}',
  'catalogo.ofertaHasta': 'Hasta el {hasta}',
  'catalogo.ofertaLleva': '{nombre}: lleva {lleva} por {monto} · hasta el {hasta}',
  'catalogo.conOfertas': 'En oferta, al principio: {n}, con su precio de antes y hasta cuándo.',
  'catalogo.preparandoFotos': 'Preparando las fotos: {n} de {de}…',
  'catalogo.eligeUna': 'Marque al menos una lista.',
  'catalogo.ninguno': 'Ningún producto tiene precio en esas listas.',
  'catalogo.descargar': 'Descargar PDF',
  'catalogo.mandar': 'Mandar PDF',
  'catalogo.error': 'No se pudo hacer el PDF. Intente otra vez.',
  'catalogo.producto': 'Producto',
  'catalogo.presentacion': 'Presentación',
  'catalogo.continua': '{categoria} (continúa)',
  'catalogo.pagina': 'Página {n} de {de}',
  'catalogo.archivo': 'catalogo-de-precios_{fecha}.pdf',

  // ---------- Proveedores ----------
  'prov.titulo': 'Proveedores',
  'prov.activos': '{n} activo(s)',
  'prov.contacto': 'Contacto',
  'prov.guardar': 'Guardar proveedor',
  'prov.ninguno': 'Todavía no hay proveedores. Se necesita al menos uno para registrar una compra.',
  'prov.compras': '{n} compra(s)',
  'prov.nuevo': 'Proveedor nuevo',
  'prov.yaExiste': 'Ya tiene un proveedor llamado «{nombre}».',
  'prov.elegirEse': 'Elegir «{nombre}»',
  // Un proveedor, abierto desde la lista (2026-10-16).
  'prov.editar': 'Editar',
  'prov.editarTitulo': 'Editar proveedor',
  'prov.guardarCambios': 'Guardar cambios',
  'prov.sinNombre': 'Un proveedor necesita un nombre.',
  'prov.noEsta': 'Ese proveedor no está en este equipo.',
  'prov.desactivado': 'Desactivado',
  'prov.sinAnotar': 'Sin anotar',
  'prov.llamar': 'Llamar',
  'prov.seLeDebe': 'Se le debe',
  'prov.noSeLeDebe': 'No se le debe nada.',
  'prov.verPorPagar': 'Se paga en «Cuentas por pagar»',
  'prov.comprasTitulo': 'Compras',
  'prov.comprado': '{n} compra(s) por {monto}',
  'prov.ultima': 'la última, {fecha}',
  'prov.ningunaCompra': 'Todavía no se le ha comprado nada.',
  'prov.debeDeEsta': 'Se debe {monto}',
  'prov.pagos': 'Pagos',
  'prov.ningunPago': 'Todavía no se le ha pagado nada.',

  // ---------- Listas de precios ----------
  'listas.titulo': 'Listas de precios',
  'listas.subtitulo': 'El cliente se asigna a una lista; el cajero puede cambiar el precio con motivo.',
  'listas.preciosDefinidos': '{n} precio(s) definidos',
  'listas.predeterminada': 'Predeterminada',
  'listas.hacerPredeterminada': 'Hacer predeterminada',
  'listas.nueva': 'Nueva lista',
  'listas.ejemplo': 'Especial',
  'listas.explicacion':
    'Las listas no se borran, se desactivan: una venta vieja tiene que poder decir en qué lista se cobró.',

  // ---------- Períodos ----------
  'periodo.hoy': 'Hoy',
  'periodo.ayer': 'Ayer',
  'periodo.ultimos30': 'Últimos 30 días',
  'periodo.esteMes': 'Este mes',
  'periodo.mesPasado': 'Mes pasado',
  'periodo.esteAnio': 'Este año',
  'periodo.todo': 'Todo',

  // ---------- Errores ----------
  'error.pantallaTitulo': 'Esta pantalla no se pudo mostrar',
  'error.pantallaTexto': 'Lo que ya se guardó sigue guardado. Vuelva al inicio y ábrala otra vez.',
  'error.volverAlInicio': 'Volver al inicio',
  'error.sinRegistrar': 'Este dispositivo todavía no está registrado',
  'error.sinSesion': 'No hay una sesión abierta',
  'error.textoLargo': '«{campo}» es demasiado largo: lleva {maximo} caracteres como máximo. Acórtelo y vuelva a intentarlo.',
  'error.dispositivoNoRegistrado': 'Este dispositivo no está registrado',
  'error.sinCodigo': 'Este dispositivo no tiene código asignado',

  // ---------- Clientes ----------
  'clientes.titulo': 'Clientes',
  'clientes.activos': '{n} activo(s)',
  'clientes.tipo': 'Tipo',
  'clientes.mostrador': 'De mostrador',
  'clientes.mayorista': 'Mayorista / de ruta',
  'clientes.etiquetaMostrador': 'Mostrador',
  'clientes.desactivado': 'Desactivado',
  'clientes.etiquetaMayorista': 'Mayorista',
  'clientes.listaPrecios': 'Lista de precios',
  'clientes.ayudaLista': 'Es el precio que este cliente ve siempre, sin que nadie tenga que acordarse.',
  'clientes.listaDelDueno': 'La lista de precios de un cliente la pone el dueño.',
  'clientes.laPredeterminada': 'La predeterminada',
  'clientes.yaExiste': 'Ya tiene un cliente llamado «{nombre}».',
  'clientes.elegirEse': 'Elegir «{nombre}»',
  'clientes.ayudaDireccion': 'Como se dice aquí: de la iglesia 2 cuadras al sur.',
  'clientes.diaVisita': 'Día de visita',
  'clientes.sinDiaFijo': 'Sin día fijo',
  'clientes.notas': 'Notas',
  'clientes.desactivar': 'Desactivar',
  'clientes.editarTitulo': 'Editar cliente',
  'clientes.confirmarDesactivar': '¿Desactivar este cliente? Su historial se conserva.',
  'clientes.ninguno': 'Todavía no hay clientes. Se necesitan para fiar y para tomar pedidos de ruta.',
  'clientes.pedido': 'Pedido',
  'dia.0': 'Domingo',
  'dia.1': 'Lunes',
  'dia.2': 'Martes',
  'dia.3': 'Miércoles',
  'dia.4': 'Jueves',
  'dia.5': 'Viernes',
  'dia.6': 'Sábado',

  // ---------- Preventa ----------
  'pedidos.titulo': 'Pedidos',
  'pedidos.pendientes': '{n} pedido(s) pendiente(s)',
  'pedidos.preciosDeLista': 'Con los precios de este cliente: {lista}.',
  'pedidos.seEntregaEl': 'Se entrega el',
  'pedidos.agregarProducto': 'Agregar producto',
  'pedidos.explicacion':
    'Un pedido no aparta mercadería ni mueve nada todavía: es un compromiso, y se cumple cuando se entrega y se cobra.',
  'pedidos.explicacionApartado':
    'Este pedido aparta lo que lleva: lo apartado ya no se le promete a nadie más, y la caja pide el PIN del dueño para venderlo. Se guarda solo con conexión, para que ningún otro teléfono prometa lo mismo.',
  'pedidos.lineaNoAlcanza': 'Quedan {libre} sin apartar',
  'pedidos.noAlcanza': '{producto}: quedan {libre} sin apartar y el pedido pide {pide}.',
  'pedidos.noAlcanzaQue': 'Baje la cantidad o quite el producto: lo apartado es de otros pedidos.',
  'pedidos.sinConexion':
    'Sin conexión: un pedido que aparta mercadería se guarda solo cuando el servidor lo confirma. Conéctese y vuelva a intentar.',
  'pedidos.confirmando': 'Confirmando con el servidor…',
  'pedidos.noSeConfirmo': 'El servidor no contestó a tiempo y el pedido no se guardó. Revise la conexión y vuelva a intentar.',
  'pedidos.motivoSinConfirmar': 'El servidor no lo confirmó a tiempo',
  'pedidos.noQuedo': 'El servidor no lo aceptó y el pedido no se guardó. Revise lo que queda sin apartar y vuelva a intentar.',
  'pedidos.guardar': 'Guardar pedido',
  'pedidos.guardarCambios': 'Guardar cambios',
  'pedidos.editar': 'Editar',
  'pedidos.editarTitulo': 'Editar pedido',
  'pedidos.cambiadoPara': 'Pedido de {cliente} cambiado',
  'pedidos.cambioNoSeConfirmo': 'El servidor no contestó a tiempo y el cambio no se guardó: el pedido sigue como estaba. Revise la conexión y vuelva a intentar.',
  'pedidos.cambioNoQuedo': 'El servidor no lo aceptó y el cambio no se guardó. Revise lo que queda sin apartar y vuelva a intentar.',
  'pedidos.cambiarEntregado': 'Este pedido ya se entregó: lo que se cobró se corrige en la venta.',
  'pedidos.cambiarCancelado': 'Este pedido fue cancelado.',
  'pedidos.cambiarNoEsta': 'Ese pedido no está en este equipo.',
  'pedidos.cambiarSinProducto': 'Una línea de este pedido es de un producto o una presentación que ya no está. Cancélelo y tome otro.',
  'pedidos.ninguno': 'No hay pedidos pendientes.',
  'pedidos.clienteDesconocido': 'Cliente desconocido',
  'pedidos.productoNoEncontrado': 'Producto no encontrado',
  'pedidos.cancelar': 'Cancelar pedido',
  'pedidos.porQueCancela': '¿Por qué se cancela el pedido?',
  'pedidos.noSeCancelo': 'El pedido no se canceló: {motivo}',
  'pedidos.nuevo': 'Nuevo pedido',
  'pedidos.nuevoCliente': 'Agregar cliente nuevo',
  'pedidos.clienteNuevoAyuda': 'Se guarda con sus clientes y queda elegido en este pedido.',
  'pedidos.busqueEmpezar': 'Busque o escanee lo que encargó el cliente',
  'pedidos.enElPedido': '{n} en el pedido',
  'pedidos.faltaPrecio':
    '{producto} no tiene precio en la lista de este pedido. Escríbalo aquí, o póngaselo en Productos para que quede guardado.',
  'pedidos.faltaPrecioSoloAqui':
    '{producto} no tiene precio en la lista de este pedido. Escríbalo aquí para este pedido; el precio de siempre se lo pone el dueño en Productos.',
  'pedidos.hayLineasSinPrecio': 'Hay {n} producto(s) sin precio. Toque cada uno y escríbalo: el pedido no se guarda en cero.',
  'pedidos.faltaPrecioPida':
    '{producto} no tiene precio en la lista de este pedido. Pídale al dueño que se lo ponga en Productos, o quítelo del pedido.',
  'pedidos.hayLineasSinPrecioPida':
    'Hay {n} producto(s) sin precio: el dueño se los pone en Productos, o quítelos del pedido. El pedido no se guarda en cero.',
  'pedidos.faltaCliente': 'Elija de quién es el pedido.',
  'pedidos.quitarLinea': 'Quitar {producto} del pedido',
  'pedidos.confirmarQuitar': '{producto} ({total}) se quita de este pedido.',
  'pedidos.vistaPendientes': 'Pendientes',
  'pedidos.vistaEntregados': 'Entregados',
  'pedidos.vistaCancelados': 'Cancelados',
  'pedidos.atrasado': 'Atrasado',
  'pedidos.hoy': 'Hoy',
  'pedidos.cobrar': 'Cobrar',
  'pedidos.recibo': 'Recibo',
  'pedidos.reciboTitulo': 'Recibo del pedido',
  'pedidos.reciboSinCobrar': 'Todavía no se ha cobrado. Cuando se cobre, la caja da el recibo de la venta.',
  'pedidos.ningunoEntregado': 'Todavía no se ha entregado ningún pedido.',
  'pedidos.ningunoCancelado': 'No hay pedidos cancelados.',
  'pedidos.entregadoEn': 'Ticket {ticket} · {fecha}',
  'pedidos.entregadoSinVenta': 'Entregado. La venta todavía no llega a este teléfono.',
  'pedidos.cobroQuien': 'Cobró {quien} · {como}',
  'pedidos.canceladoPor': 'Se canceló: {motivo}',
  'pedidos.noSeCarga': 'Ese pedido no se puede cobrar',
  'pedidos.noEsta': 'Ese pedido no está en este teléfono.',
  'pedidos.yaEntregado': 'El pedido de {cliente} ya se entregó: es el ticket {ticket}.',
  'pedidos.fueCancelado': 'El pedido de {cliente} se canceló: {motivo}.',
  'pedidos.verLista': 'Ver los pedidos',
  'pedidos.tomadoPara': 'Pedido de {cliente} guardado',
  'pedidos.apartado': 'Apartado',
  'pedidos.corto': 'Falta mercadería',
  'pedidos.faltaDe': 'Faltan {cantidad} de {producto}',
  // Un entregado, abierto (2026-10-14).
  'pedidos.detalleTitulo': 'Pedido entregado',
  'pedidos.elPedido': 'El pedido',
  'pedidos.tomado': 'Tomado',
  'pedidos.cambiado': 'Cambiado',
  'pedidos.paraEl': 'Entrega acordada',
  'pedidos.lista': 'Lista de precios',
  'pedidos.autorizo': 'autorizó {nombre}',
  'pedidos.totalDelPedido': 'Total del pedido',
  'pedidos.laEntrega': 'La entrega',
  'pedidos.ticket': 'Ticket',
  'pedidos.cobrado': 'Cobrado',
  'pedidos.donde': 'Dónde',
  'pedidos.atraso': '{n} día(s) después de la entrega acordada',
  'pedidos.comoSePidio': 'Se cobró tal como se pidió.',
  'pedidos.distintoDeLoPedido': 'Se cobró distinto de lo pedido:',
  'pedidos.totalCobrado': 'Total cobrado',
  'pedidos.noLlego': 'no llegó',
  'pedidos.devoluciones': 'Devoluciones',
  'pedidos.reembolsoEn': 'se le devolvió en {como}',
  'pedidos.reembolsoACuenta': 'se rebajó de lo que debe',
  'pedidos.verVenta': 'Ver la venta',

  // ---------- Liquidar una ruta de antes ----------
  // «Reparto» se quitó (el dueño, 2026-10-04); queda liquidar una ruta que ya estaba afuera.
  'reparto.camion': 'Camión',
  'reparto.desdeEl': 'desde el {fecha}',
  'reparto.deAntes':
    'Esta caja es de una ruta que salió antes de que se quitara el reparto. Se cierra liquidando la ruta: se cuenta la plata y lo que quedó en el camión, que vuelve a la tienda.',
  'reparto.loLiquidaElDueno':
    'La liquida el dueño, aquí en este teléfono, contando con usted la plata y lo que quedó en el camión. Páseselo para que entre con su PIN.',
  'reparto.pasarAlDueno': 'Pasárselo al dueño',
  'reparto.vaEnElCamion': 'Lo que quedó en el camión',
  'reparto.camionVacio': 'En el camión no quedó nada: solo falta la plata.',
  'reparto.explicacionLiquidacion': 'Cuente cada cosa. Lo que no aparezca queda como faltante de reparto.',
  'reparto.contadoEn': 'Lo que cuente en el camión',
  'reparto.sistemaTiene': 'El sistema tiene {cantidad}',
  'reparto.fiadoEnRuta': 'Fiado en la ruta',
  'reparto.fiadoEnRutaAyuda': 'Cada cliente lo debe ahora. Pregunte por lo que no reconozca.',
  'reparto.abonosEnRuta': 'Abonos en efectivo en la ruta',
  'reparto.pagadoEnRutaTotal': 'Pagado en la ruta: {monto}',
  'reparto.efectivoContado': 'Efectivo contado (C$)',
  'reparto.incluyaFondo': 'Incluya el fondo con que salió.',
  'reparto.deberiaHaber': 'Debería haber {monto}',
  'reparto.dolaresContados': 'Dólares contados (US$)',
  'reparto.conteoIlegible': 'No se entiende lo contado de {producto}: escriba solo el número, o déjelo vacío si no volvió nada.',
  'reparto.dolaresIlegibles': 'No se entienden los dólares: escriba solo el número, o déjelo vacío si no hay.',
  'reparto.cuenteEfectivo': 'Cuente el efectivo antes de liquidar.',
  'reparto.noSePudoLiquidar': 'No se pudo liquidar',
  'reparto.liquidando': 'Liquidando…',
  'reparto.explicacionCierre':
    'Se cierran juntas a propósito: una liquidación que cuadra el dinero y deja la mercadería sin contar no es una liquidación.',
  'reparto.liquidada': 'Ruta liquidada',
  'reparto.liquidadaExplicacion':
    'La caja de la ruta quedó cerrada y su plata pasó al efectivo general. Ya no sale ninguna ruta: para vender, empiece una caja como cualquier día.',
  'reparto.devuelto': 'Volvió del camión',
  'reparto.faltanteMercaderia': 'Faltó del camión',

  // ---------- Gastos ----------
  'gastos.titulo': 'Gastos y pagos',
  'gastos.registrados': '{n} gasto(s) registrado(s)',
  'gastos.nuevo': 'Nuevo gasto',
  'fijos.titulo': 'Gastos fijos',
  'fijos.ayuda': 'Lo que se paga cada mes o cada tantos meses, como el alquiler o el internet. Cuando le toca, sale en «Toca pagar».',
  'fijos.ninguno': 'Todavía no hay gastos fijos.',
  'fijos.nuevo': 'Nuevo gasto fijo',
  'fijos.editarTitulo': 'Gasto fijo',
  'fijos.tocaPagar': 'Toca pagar',
  'fijos.tocaPagarAyuda': 'Los gastos fijos que vencieron o vencen esta semana.',
  'fijos.vencio': 'Venció el {fecha}',
  'fijos.venceHoy': 'Vence hoy',
  'fijos.vence': 'Vence el {fecha}',
  'fijos.registrar': 'Registrar',
  'fijos.esteMesNo': 'Este mes no',
  'fijos.omitirTitulo': '¿Saltar «{descripcion}» de {mes}?',
  'fijos.omitirMensaje': 'No se vuelve a pedir ese mes. Los demás meses siguen igual.',
  'fijos.varia': 'Varía',
  'fijos.cadaMes': 'Cada mes, el día {dia}',
  'fijos.cadaMeses': 'Cada {n} meses, el día {dia}',
  'fijos.cadaAnio': 'Cada año, el {dia} de {mes}',
  'fijos.enPausa': 'En pausa',
  'fijos.seRepite': 'Se repite',
  'fijos.seRepiteAyuda': 'Queda como gasto fijo: cada vez que le toque, el día {dia}, aparece en «Por pagar» listo para registrar.',
  'fijos.cada': 'Cada cuánto',
  'fijos.cada1': 'Cada mes',
  'fijos.cada2': 'Cada 2 meses',
  'fijos.cada3': 'Cada 3 meses',
  'fijos.cada6': 'Cada 6 meses',
  'fijos.cada12': 'Cada año',
  'fijos.montoVaria': 'El monto cambia cada vez',
  'fijos.montoVariaAyuda': 'Como la luz o el agua: se escribe al registrarlo.',
  'fijos.monto': 'Monto',
  'fijos.montoAyuda': 'Vacío si cambia cada vez, como la luz o el agua.',
  'fijos.montoInvalido': 'Un monto mayor que cero, o vacío si cambia cada vez.',
  'fijos.dia': 'Día del mes',
  'fijos.diaAyuda': 'En los meses más cortos, el último día.',
  'fijos.formaPago': 'Cómo se paga normalmente',
  'fijos.activo': 'Activo',
  'fijos.activoAyuda': 'Apagado, no se pide hasta que lo vuelva a encender.',
  'fijos.guardar': 'Guardar gasto fijo',
  'fijos.quitar': 'Quitar este gasto fijo',
  'fijos.quitarTitulo': '¿Quitar «{descripcion}»?',
  'fijos.quitarMensaje': 'Ya no se pide. Lo que ya se registró queda en los gastos.',
  'fijos.quitarConfirmar': 'Quitar',
  'fijos.descripcionMes': '{descripcion} · {mes}',
  'fijos.cambiaDesde': 'Cambiar el día mueve el día de cada mes que falta; cambiar cada cuánto empieza a contar desde la próxima vez que le toque.',
  'fijos.antesLoVencido': 'Antes de cambiar cada cuánto se paga, registre o pase por alto lo que ya venció: {meses}.',
  'fijos.hayVencidos': 'Un gasto fijo ya venció',
  'fijos.hayHoy': 'Hoy toca pagar un gasto fijo',
  'fijos.yaRegistrado': 'Este mes ya está registrado, quizás desde otro teléfono. No se registró dos veces.',
  'inicio.tocaPagar': 'Toca pagar: {lista}',
  'inicio.tocaPagarMas': '{lista} y {n} más',
  'inicio.tocaPagarMeses': '{descripcion} ({n} meses)',
  'gastos.vistas': 'Partes de gastos y pagos',
  'gastos.vistaGastos': 'Gastos',
  'gastos.vistaPorPagar': 'Por pagar',
  'gastos.vistaPagos': 'Pagos',
  'gastos.vistaDueno': 'Dueño',
  'gastos.hayPorPagar': 'Se le debe a un proveedor',
  'gastos.hayVencidas': 'Hay una cuenta vencida',
  'gastos.categoria': 'Categoría',
  'gastos.deQueFue': '¿De qué fue?',
  'gastos.ayudaDescripcion':
    'Escríbalo como se lo diría a alguien: «recibo de luz de septiembre».',
  'gastos.montoCordobas': 'Monto (C$)',
  'gastos.montoDolares': 'Monto (US$)',
  'gastos.moneda': 'Moneda',
  'gastos.aTasa': 'A C${tasa}',
  'gastos.cordobas': 'Córdobas',
  'gastos.dolares': 'Dólares',
  'gastos.comoSePago': '¿Cómo se pagó?',
  'gastos.ayudaPago': 'El efectivo sale de la caja fuerte, no de la gaveta del turno.',
  // De la gaveta, y en partes (2026-10-16).
  'gastos.ayudaPagoSinCaja': 'Ninguna caja está abierta: el efectivo sale de la caja fuerte. Lo que sale de una gaveta se anota mientras su caja está abierta.',
  'gastos.ayudaPagoOtroDia': 'De otro día, el efectivo sale de la caja fuerte: de una gaveta abierta sale solo lo que se paga hoy.',
  'gastos.nadaQueda': 'Las partes pagan todo el gasto.',
  'gastos.partesDeMas': 'Las partes suman {monto} más que el gasto.',
  'gastos.enPartes': ' · en partes',
  'gastos.formaEnPartes': 'En partes',
  'gastos.conElGasto': '{fecha} · con el gasto',
  'gastos.proveedorOpcional': 'Proveedor (opcional)',
  'gastos.nadieEnParticular': 'Nadie en particular',
  'gastos.fotoRecibo': 'Foto del recibo',
  'gastos.ayudaFotoRecibo': 'Opcional. Queda con el gasto, para saber después en qué se fue el dinero.',
  'gastos.tomarFotoRecibo': 'Tomar foto del recibo',
  'gastos.cambiarFotoRecibo': 'Cambiar la foto',
  'gastos.recibo': 'Recibo',
  'gastos.parecido': 'Ya hay un gasto igual ese día: {monto} por «{descripcion}». ¿No es el mismo?',
  'gastos.guardar': 'Guardar gasto',
  'gastos.movimiento': 'Movimiento',
  'gastos.duenoSaca': 'El dueño saca dinero',
  'gastos.duenoMete': 'El dueño mete dinero',
  'gastos.deDondeSale': '¿De dónde sale?',
  'gastos.aDondeEntra': '¿A dónde entra?',
  'gastos.explicacionDueno':
    'Esto no es un gasto del negocio y no baja la utilidad: baja el patrimonio, que es exactamente lo que pasa en la realidad.',
  'gastos.dineroDelDueno': 'Dinero del dueño',
  'gastos.cuentasPorPagar': 'Cuentas por pagar',
  'gastos.proveedor': 'Proveedor',
  'gastos.vence': 'Vence {fecha}',
  'gastos.sinFecha': 'Sin fecha',
  'gastos.abonado': ' · abonado {monto}',
  'gastos.deAntes': ' · de antes',
  'gastos.nadaPorPagar': 'No se le debe nada a ningún proveedor.',
  'gastos.deudaAnterior': 'Deuda anterior con un proveedor',
  'deudaAnterior.titulo': 'Deuda anterior',
  'deudaAnterior.corregir': 'Corregir la deuda',
  'deudaAnterior.explicacion':
    'Una factura que la tienda ya debía antes de usar la app. Queda en cuentas por pagar y se abona como una compra al crédito, sin meter mercadería: esa ya está en el inventario inicial.',
  'deudaAnterior.sinProveedores': 'Primero agregue al proveedor en',
  'deudaAnterior.cuanto': 'Cuánto se le debe todavía (C$)',
  'deudaAnterior.ayudaCuanto': 'Lo que falta pagar de esa factura, en córdobas.',
  'deudaAnterior.bajoLoPagado': 'Ya se le abonó {monto}: no puede quedar en menos.',
  'deudaAnterior.factura': 'Número de factura (opcional)',
  'deudaAnterior.fechaFactura': 'Fecha de la factura',
  'deudaAnterior.vence': 'Vence (opcional)',
  'gastos.ninguno': 'Todavía no hay gastos registrados.',
  'gastos.quedaDebiendo': ' · queda debiendo',
  'gastos.yaPagado': ' · ya pagado',
  'gastos.porQueAnula': '¿Por qué se anula este gasto?',
  'gastos.retiro': 'Retiro',
  'gastos.aporte': 'Aporte',
  'gastos.efectivoUsd': 'Efectivo US$',
  'gastos.billeteraMovil': 'Billetera móvil',
  'gastos.credito': 'Queda debiendo',
  'gastos.listaTitulo': 'Lo que se gastó',
  'gastos.buscar': 'Buscar: de qué fue, proveedor, número…',
  'gastos.todasCategorias': 'Todas',
  'gastos.orden': 'Orden',
  'gastos.ordenFecha': 'Recientes',
  'gastos.ordenMonto': 'Más caros',
  'gastos.verAnulados': 'Ver también los anulados',
  'gastos.suma': '{total} en {n} gasto(s)',
  'gastos.ningunoAsi': 'Ningún gasto con estos filtros.',
  'gastos.anulado': 'Anulado',
  'gastos.corregido': 'Corregido',
  'gastos.formaPago': 'Cómo se pagó',
  'gastos.deLaGaveta': ' · de la gaveta',
  'gastos.enDolares': 'US$ {monto} a C$ {tasa}',
  'gastos.registradoPor': 'Registrado por',
  'gastos.pagos': 'Pagos',
  'gastos.pagado': 'Pagado',
  'gastos.falta': 'Falta',
  'gastos.anuladoPor': 'Anulado por {nombre}, {cuando}.',
  'gastos.corregidoPor': 'Corregido por {nombre}, {cuando}.',
  'gastos.motivo': 'Motivo: {motivo}',
  'gastos.verCorreccion': 'Ver cómo quedó',
  'gastos.corrigeA': 'Corrige un gasto registrado antes.',
  'gastos.verAnterior': 'Ver el anterior',
  'gastos.conPagos': 'Tiene pagos: ya no se puede corregir ni anular.',
  'gastos.corregirTitulo': 'Corregir gasto',
  'gastos.corregirExplicacion':
    'El gasto no se borra: queda anulado, con lo que estaba mal, y este queda en su lugar. Pide el PIN del dueño.',
  'gastos.queEstabaMal': '¿Qué estaba mal?',
  'gastos.guardarCorreccion': 'Guardar corrección',
  'gastos.correccionDeGaveta': 'Salió de la gaveta abierta: la corrección también, y la gaveta espera solo la diferencia.',
  'gastos.correccionDeCajaContada': 'Salió de una caja que ya se contó: la corrección pasa por el efectivo general.',
  'gastos.pinCorregir': 'Corregir el gasto «{descripcion}».',
  'gastos.pinAnular': 'Anular el gasto «{descripcion}».',
  'gastos.noSeCorrigio': 'No se pudo corregir: {motivo}',
  'gastos.noSeAnulo': 'No se pudo anular: {motivo}',
  'gastos.correccionNoAlcanza': 'En la gaveta se esperan {monto}, contando lo que vuelve del gasto anterior: no alcanza.',
  'gastos.correccionContada': '{motivo}. Se puede corregir de qué fue el gasto, no el monto, cómo se pagó ni la fecha.',
  'gastos.correccionMueveDinero': 'Así se movería dinero que ese conteo ya encontró: deje el monto, cómo se pagó y la fecha como estaban.',
  'gastos.anuladoSinCorreccion': 'Se anuló el gasto, pero el corregido no quedó registrado: {motivo}. Regístrelo con «Nuevo gasto».',

  // ---------- Contabilidad ----------
  'conta.titulo': 'Contabilidad',
  'conta.resultados': 'Resultados',
  'conta.balance': 'Balance',
  'conta.caja': 'Caja',
  'conta.utilidad': 'Utilidad',
  'conta.utilidadBruta': 'Utilidad bruta',
  'conta.gastos': 'Gastos',
  'conta.utilidadNeta': 'Utilidad neta',
  'conta.ingresos': 'Ingresos',
  'conta.costoVentas': 'Costo de ventas',
  'conta.explicacionRetiros':
    'El dinero que saca el dueño no aparece aquí: no es un gasto, es una reducción del patrimonio. Contarlo como gasto es la manera más común de que una utilidad quede mal.',
  'conta.activo': 'Activo',
  'conta.pasivo': 'Pasivo',
  'conta.patrimonio': 'Patrimonio',
  'conta.utilidadEjercicio': 'Utilidad del ejercicio',
  'conta.balanceCuadra': 'El balance cuadra: activo = pasivo + patrimonio.',
  'conta.descuadre': 'Descuadre de {monto}. Esto no debería pasar nunca: avise.',
  'conta.fiadoSubio': 'Lo que le deben los clientes subió {monto} en el período: esa parte de la utilidad todavía no es plata en la mano.',
  'conta.fiadoBajo': 'Lo que le deben los clientes bajó {monto} en el período.',
  'conta.fiadoTotal': 'Al cierre del período le deben {monto} en fiado.',
  'conta.cuadres': 'Cada cuenta con su detalle',
  'conta.cuadresAyuda': 'Lo que dicen los libros contra lo que suman los clientes, las compras, los estantes… Al día de hoy, y todo cuadra.',
  'conta.cuadresNo': '{n} cuenta(s) no cuadran con su detalle. Esto no debería pasar nunca: avise.',
  'conta.cuadra': 'Cuadra',
  'conta.redondeo': '{monto} de redondeo',
  'conta.noCuadra': 'No cuadra: el detalle suma {monto}',
  'conta.detalle.gaveta': 'Lo que esperan las cajas abiertas y lo que dejó cada corte',
  'conta.detalle.clientes': 'Lo que deben los clientes',
  'conta.detalle.proveedores': 'Lo que se debe de compras y gastos',
  'conta.detalle.inventario': 'La mercadería, a su costo promedio',
  'conta.detalle.camion': 'Lo que va en los camiones',
  'conta.detalle.transformacion': 'Lo que se está reempacando',
  'conta.detalle.porRecibir': 'Lo que entregaron las cajas y falta recibir',
  'conta.detalle.dolares': 'Los dólares de las cajas abiertas',
  'conta.detalle.transferencias': 'Los pagos que esperan en la cola',
  'conta.detalle.saldoTelefonico': 'El saldo para recargas, a su costo',
  'conta.detalle.adelantos': 'Los adelantos sin descontar',
  'conta.detalle.aguinaldo': 'El aguinaldo acumulado de cada empleado',
  'conta.detalle.vacaciones': 'Las vacaciones acumuladas de cada empleado',
  'conta.detalle.sueldos': 'Las planillas sin pagar',
  'conta.detalle.inss': 'El INSS de las planillas, sin pagar',
  'conta.detalle.inatec': 'El INATEC de las planillas, sin pagar',
  'conta.detalle.ir': 'El IR retenido en las planillas, sin pagar',
  'conta.resumenCaja': 'Saldo inicial {inicial} · entradas {entradas} · salidas {salidas}',
  'conta.sinMovimientos': 'Sin movimientos en el período.',
  'conta.concepto': 'Concepto',
  'conta.entra': 'Entra',
  'conta.sale': 'Sale',
  'conta.saldo': 'Saldo',
  'conta.porProducto': 'Por producto',
  'conta.porCliente': 'Por cliente',
  'utilidad.sinCatalogo': 'Ventas rápidas (fuera de catálogo)',
  'utilidad.mostrador': 'Mostrador (sin cliente)',
  'utilidad.clienteEliminado': 'Cliente eliminado',
  'conta.sinVentasPeriodo': 'Sin ventas en el período.',
  'conta.cantidadCorta': 'Cant.',
  'conta.venta': 'Venta',
  'conta.totalDe': 'Total {que}',
  'conta.sinMovimiento': 'Sin movimiento',
  'conta.moneda': 'Ver las cifras en',
  'conta.enDolares': 'En dólares a la tasa oficial, C$ {tasa} por dólar. Por el redondeo, un total puede variar un centavo de la suma de sus líneas.',
  // Lo que quiere decir cada línea y cómo sale, en un globo sobre ella (2026-10-17). Las de cada
  // cuenta, en `cuentaAyuda.*`.
  'conta.ayuda.cuenta': '{nombre} · cuenta {codigo}',
  'conta.ayuda.ingresos':
    'Lo que el negocio vendió en el período, y lo demás que le entra (envíos, comisiones de recargas, sobrantes), antes de restar lo que costó la mercadería y los gastos. Una venta al fiado cuenta el día en que se vende, no el día en que la pagan. Es la suma de las líneas de «Ingresos».',
  'conta.ayuda.costos':
    'Lo que costó la mercadería vendida, cada producto al costo promedio que tenía cuando se vendió, y lo demás que se resta directo de lo vendido: lo que devolvieron los clientes y los ajustes al costo de la mercadería. Es la suma de estas líneas.',
  'conta.ayuda.utilidadBruta':
    'Ingresos menos costo de ventas: lo que dejan las ventas antes de los gastos del negocio.',
  'conta.ayuda.margen':
    'El {margen} es el margen bruto: la utilidad bruta dividida entre los ingresos. De cada 100 que entran, lo que queda después de pagar la mercadería.',
  'conta.ayuda.gastos':
    'Lo que costó tener el negocio abierto en el período: la planilla y lo que se paga por ella, el alquiler, la luz, el agua, el transporte, los empaques, y lo que se perdió en mermas, vencidos y faltantes. Cada gasto cuenta el día en que se hizo, esté pagado o se deba todavía. Es la suma de las líneas de «Gastos».',
  'conta.ayuda.utilidadNeta':
    'Utilidad bruta menos gastos: lo que el negocio ganó en el período, o lo que perdió si sale en negativo. No es el dinero que entró: un fiado cuenta el día en que se vende aunque se cobre después, y lo que saca el dueño no es un gasto.',
  'conta.ayuda.total': 'La suma de las líneas de «{grupo}».',
  'conta.ayuda.activo':
    'Lo que el negocio tiene al cierre del período: el dinero (gavetas, caja fuerte, bancos y billetera), la mercadería a lo que costó, y lo que le deben los clientes y los empleados. Cada línea es el saldo de su cuenta: todo lo que le entró desde el primer día menos todo lo que le salió.',
  'conta.ayuda.pasivo':
    'Lo que el negocio debe al cierre del período: a los proveedores, por lo comprado o gastado al crédito, y de la planilla lo que se debe a los empleados y lo que hay que pagar al INSS, al INATEC y a la DGI. Cada línea es lo que se llegó a deber menos lo que ya se pagó.',
  'conta.ayuda.patrimonio':
    'La parte del negocio que es del dueño: lo que puso y lo que el negocio ya tenía al empezar a usar la app (capital), menos lo que sacó para él (retiros), más lo que el negocio ha ganado desde el primer día (utilidad del ejercicio). Es lo que queda del activo después de restarle el pasivo.',
  'conta.ayuda.utilidadEjercicio':
    'La utilidad neta de todo el tiempo hasta el cierre del período, no sólo la de este período: todos los ingresos menos todos los costos y gastos desde el primer día. No se pasa a «Resultados acumulados»: los libros la sacan cada vez de los asientos.',
  'conta.ayuda.totalPatrimonio':
    'La suma de las líneas de «Patrimonio», con la utilidad del ejercicio. Tiene que ser igual al activo menos el pasivo.',
  'conta.ayuda.caja':
    'Todo el dinero del negocio en un solo libro: las gavetas (córdobas y dólares), el efectivo general, lo que una caja entregó y falta recibir, los bancos y la billetera, los dólares a la tasa oficial del día en que entraron. Las transferencias que esperan en la cola todavía no cuentan. Saldo inicial: lo que había en todo eso al empezar el período. Entradas y salidas: lo que entró y lo que salió en el período; pasar dinero de una cuenta a otra, de la gaveta a la caja fuerte o al banco, es una salida de una y una entrada de la otra. La columna «Saldo» lo va llevando movimiento a movimiento.',
  // La cuenta de la caja, un renglón cada paso, bajo las palabras de su globo.
  'conta.ayuda.saldoInicial': 'Saldo inicial',
  'conta.ayuda.entradas': 'Entradas',
  'conta.ayuda.salidas': 'Salidas',
  'conta.ayuda.saldoFinal': 'Saldo final',
  'conta.ayuda.porProducto':
    'Cada producto vendido en el período, del que más dejó al que menos. Venta: lo que se cobró por él menos lo que devolvieron, sin el redondeo del efectivo ni el envío. Costo: lo que costó lo vendido, al costo promedio que tenía el producto cuando se vendió. Utilidad: venta menos costo. Margen: la utilidad dividida entre la venta. La cantidad va en la unidad del producto. Lo vendido fuera del catálogo va junto en «Ventas rápidas», sin costo. Arriba, la utilidad y el margen de todo.',
  'conta.ayuda.porCliente':
    'Cada cliente que compró en el período, del que más dejó al que menos, con la venta, el costo, la utilidad y el margen contados como por producto. Lo vendido sin cliente va junto en «Mostrador (sin cliente)». Las dos tablas suman lo mismo. Arriba, la utilidad y el margen de todo.',
  'conta.ayuda.cuadre':
    'Lo que dicen los libros contra lo que suma el detalle de esta cuenta. Se escriben juntos, en el mismo paso, así que tienen que dar lo mismo: si no, la app tiene una falla y hay que avisar.',
  'conta.ayuda.cuadreInventario':
    'Lo que dicen los libros contra la mercadería, contada a su costo promedio. Se escriben juntos, en el mismo paso, así que tienen que dar lo mismo salvo unos centavos: cada movimiento se redondea al centavo y el promedio se lleva más fino. Más que eso es una falla de la app, y hay que avisar.',
  'conta.ayuda.losLibros': 'Los libros',
  // Lo que quiere decir cada cuenta del catálogo y qué la mueve, en el globo de su línea: una por
  // cuenta, o `explicacionCuenta` (i18n/dominio.ts) no compila.
  'cuentaAyuda.CAJA_CORDOBAS':
    'Los córdobas de las gavetas: lo que esperan las cajas abiertas y lo que dejó cada corte para el vuelto. Sube con lo que se cobra en efectivo y lo que se pone en la gaveta; baja con el vuelto, lo que se paga de la gaveta, los retiros y lo que se lleva el corte.',
  'cuentaAyuda.CAJA_DOLARES':
    'Los dólares de las gavetas abiertas, en córdobas a la tasa oficial. Sube con lo que se cobra en dólares y lo que se pone al abrir; el corte se los lleva todos, así que entre turnos queda en cero. El vuelto siempre se da en córdobas.',
  'cuentaAyuda.BANCOS':
    'La cuenta del banco en córdobas. Sube con los pagos con tarjeta, las transferencias ya confirmadas, los depósitos y lo que entra de otra cuenta; baja con lo que se paga por transferencia, el efectivo que se saca y lo que sale a otra cuenta. Una transferencia cobrada en la caja espera en «Transferencias sin confirmar» hasta que se confirma.',
  'cuentaAyuda.BANCOS_2': 'Otra cuenta del banco en córdobas, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCOS_3': 'Otra cuenta del banco en córdobas, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCOS_4': 'Otra cuenta del banco en córdobas, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCOS_5': 'Otra cuenta del banco en córdobas, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCO_DOLARES':
    'La cuenta del banco en dólares, llevada en córdobas a la tasa oficial de cada movimiento, sin revaluarse; su estado de cuenta se compara en dólares. Sube con los dólares que se depositan y lo que entra de otra cuenta; baja con lo que se saca y lo que se paga desde ella. Los clientes no pagan a esta cuenta.',
  'cuentaAyuda.BANCO_DOLARES_2': 'Otra cuenta del banco en dólares, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCO_DOLARES_3': 'Otra cuenta del banco en dólares, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCO_DOLARES_4': 'Otra cuenta del banco en dólares, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.BANCO_DOLARES_5': 'Otra cuenta del banco en dólares, abierta y nombrada por el dueño: se mueve como la primera, con su propio estado de cuenta.',
  'cuentaAyuda.CAJA_FUERTE':
    'El efectivo fuera de las gavetas, el de la caja fuerte. Sube cuando el dueño recibe lo de un corte o un retiro, con lo que se saca del banco y lo que pone el dueño; baja con lo que se paga en efectivo fuera de la gaveta, el fondo para abrir una caja, los depósitos y los retiros del dueño. Sus dólares, a la tasa oficial del día en que entraron.',
  'cuentaAyuda.EFECTIVO_POR_RECIBIR':
    'Lo que una caja entregó y nadie ha contado todavía: el dinero de un corte o de un retiro sin el dueño presente, como un sobre en la caja fuerte. Baja cuando el dueño lo recibe y lo cuenta; lo que falte o sobre entonces es de esa caja.',
  'cuentaAyuda.BILLETERA_MOVIL':
    'La billetera móvil. Sube con los pagos de clientes por billetera ya confirmados y lo que pone el dueño; baja con lo que se paga por billetera: compras, gastos, planilla y saldo para recargas.',
  'cuentaAyuda.INVENTARIO':
    'La mercadería de la tienda y la bodega, a lo que costó. Sube con las compras, con su parte del flete y del IVA de la factura, con lo que vuelve por una devolución y con lo que aparece al contar; baja con lo que se vende, a su costo promedio, y con lo que se da de baja o falta al contar.',
  'cuentaAyuda.INVENTARIO_CAMION':
    'La mercadería que va en los camiones de reparto, a lo que costó: sube al cargarla y baja con lo que se vende en la ruta y al liquidarla.',
  'cuentaAyuda.INVENTARIO_TRANSFORMACION':
    'La mercadería puesta en el lugar «En reempaque», a lo que costó: sube y baja con los traslados a ese lugar y desde él. Reempacar trabaja con la mercadería de la tienda y no pasa por aquí.',
  'cuentaAyuda.CUENTAS_POR_COBRAR':
    'El fiado: lo que deben los clientes, la suma de sus saldos. Sube con la parte al fiado de cada venta y con los saldos anteriores; baja con los abonos, lo devuelto a la cuenta del cliente y lo que se da por incobrable. Un cliente que pagó de más cuenta en negativo.',
  'cuentaAyuda.ADELANTOS_EMPLEADOS':
    'El salario adelantado a los empleados que todavía no se ha descontado. Sube con cada adelanto; baja cuando una planilla o una liquidación lo descuenta, nunca más que el neto: lo que no alcanza espera a la siguiente.',
  'cuentaAyuda.TRANSFERENCIAS_PENDIENTES':
    'Los pagos por transferencia o billetera que se cobraron y esperan en la cola a que el dueño los vea en el banco. Al confirmarse pasan al banco o a la billetera; si nunca llegaron, a «Transferencias no cobradas» o a la cuenta del cliente. Todavía no cuentan como dinero en «Caja».',
  'cuentaAyuda.SALDO_TELEFONICO':
    'El saldo comprado para vender recargas, a lo que costó. Sube con cada compra de saldo; cada recarga vendida lo baja a su costo promedio, y lo que se cobró de más es la comisión.',
  'cuentaAyuda.CUENTAS_POR_PAGAR':
    'Lo que se debe a los proveedores: compras y gastos al crédito, y las deudas que venían de antes de usar la app. Sube con cada uno; baja con lo que se les paga y con lo devuelto que se descuenta de la deuda.',
  'cuentaAyuda.AGUINALDO_POR_PAGAR':
    'El aguinaldo que se va juntando: cada planilla aparta la doceava parte del salario de quien tiene prestaciones. Baja cuando se paga el aguinaldo o una liquidación paga lo juntado.',
  'cuentaAyuda.VACACIONES_POR_PAGAR':
    'Las vacaciones que se van juntando: cada planilla aparta la doceava parte del salario de quien tiene prestaciones. Baja cuando se pagan vacaciones o una liquidación paga lo juntado.',
  'cuentaAyuda.INSS_POR_PAGAR':
    'El INSS de las planillas que falta pagar: lo retenido a los empleados y lo que pone el negocio, sobre el salario que cotiza, de quien está en el INSS. Baja cuando se paga la factura del INSS.',
  'cuentaAyuda.INATEC_POR_PAGAR':
    'El INATEC de las planillas que falta pagar: el porcentaje de la configuración, 2% si nadie lo cambió, del salario que cotiza de quien está en el INSS. Baja cuando se paga.',
  'cuentaAyuda.IR_RETENIDO_POR_PAGAR':
    'El IR retenido a los empleados que falta entregar a la DGI: la tabla progresiva sobre el salario que cotiza menos su INSS, calculada sobre el año y repartida en cada planilla. Baja cuando se paga.',
  'cuentaAyuda.SUELDOS_POR_PAGAR':
    'El neto de las planillas que todavía no se ha entregado: sube al correr una planilla o una liquidación y baja cuando se paga, con los adelantos ya descontados.',
  'cuentaAyuda.IVA_POR_PAGAR':
    'El IVA que se cobraría a los clientes. El negocio no está inscrito en la DGI, así que no se usa: el IVA de las facturas de compra va al costo de la mercadería.',
  'cuentaAyuda.CAPITAL':
    'Lo que el dueño puso en el negocio y lo que el negocio ya tenía al empezar a usar la app: la mercadería y los saldos de los clientes de antes y el primer conteo del efectivo general, menos las deudas con proveedores que venían de antes.',
  'cuentaAyuda.RETIROS_DUENO':
    'El dinero que el dueño sacó para él. Resta del patrimonio, por eso sale en negativo, y no es un gasto del negocio. Sólo lo mueve «Dinero del dueño»: un retiro de la gaveta es otra cosa.',
  'cuentaAyuda.RESULTADOS_ACUMULADOS':
    'Las utilidades de antes, si se pasaran aparte. Los libros no la usan: lo ganado desde el primer día se calcula cada vez y sale como «Utilidad del ejercicio».',
  'cuentaAyuda.VENTAS':
    'Lo vendido: en cada línea, la cantidad por el precio que de verdad se cobró, sin el envío ni el redondeo del efectivo. Cuenta el día de la venta, sea en efectivo, por banco o al fiado. Sólo baja si se anula la venta: lo devuelto va a «Devoluciones de clientes».',
  'cuentaAyuda.COMISIONES': 'Lo que dejan las recargas de saldo: lo que se cobró por cada una menos lo que costó ese saldo.',
  'cuentaAyuda.ENVIOS':
    'Lo que pagan los clientes por llevarles el pedido, aparte de las ventas para que el margen de la mercadería siga siendo el suyo. Sólo baja si se anula la venta.',
  'cuentaAyuda.GANANCIA_CAMBIARIA':
    'Lo que se gana con los dólares: un pago en dólares que a la tasa oficial vale más de lo que se le abonó al cliente a la tasa de la tienda, los dólares de un corte que valen más a la tasa del día, o un traslado entre cuentas de distinta moneda. Con las dos tasas iguales no aparece.',
  'cuentaAyuda.SOBRANTE_CAJA':
    'Lo que sobró al contar una caja: al abrirla, en el corte, al pasarla a otro turno o cuando el dueño recibe lo que entregó.',
  'cuentaAyuda.SOBRANTE_INVENTARIO': 'La mercadería que apareció de más al contar, a su costo promedio, y el saldo de recargas que apareció de más.',
  'cuentaAyuda.SOBRANTE_GENERAL': 'Lo que sobró al contar el efectivo general contra lo que dicen los libros. El primer conteo no va aquí: va al capital.',
  'cuentaAyuda.COSTO_VENTAS':
    'Lo que costó la mercadería vendida: en cada venta, la cantidad por el costo promedio que tenía el producto en ese momento. Baja con las devoluciones y las anulaciones, al costo con que salió, y se ajusta si se corrige el costo o la cantidad de una compra ya vendida.',
  'cuentaAyuda.DESCUENTOS':
    'Los descuentos sobre el total de un tiquete. La caja no los da: una rebaja se hace bajando el precio de la línea, y entonces baja «Ventas».',
  'cuentaAyuda.DEVOLUCIONES_VENTAS':
    'Lo que devolvieron los clientes, a lo que se les había cobrado: aparte de las ventas, para ver si sube. El envío y el redondeo no se devuelven.',
  'cuentaAyuda.AJUSTE_COSTO_INVENTARIO':
    'Lo que cambió el valor de la mercadería cuando el dueño corrigió el costo de un producto: la cantidad en existencia por la diferencia. Bajar el costo lo sube; subirlo lo baja, y puede quedar en negativo.',
  'cuentaAyuda.SUELDOS': 'El salario de las planillas y liquidaciones, con los demás ingresos que cotizan, y los gastos registrados como sueldos.',
  'cuentaAyuda.INSS_PATRONAL':
    'La parte del INSS que pone el negocio: el porcentaje de la configuración, 21.5% si nadie lo cambió, del salario que cotiza de quien está en el INSS.',
  'cuentaAyuda.INATEC_GASTO':
    'El INATEC de cada planilla: el porcentaje de la configuración, 2% si nadie lo cambió, del salario que cotiza de quien está en el INSS.',
  'cuentaAyuda.AGUINALDO_GASTO': 'Lo que va costando el aguinaldo: la doceava parte que aparta cada planilla, y lo que se pagó por encima de lo juntado.',
  'cuentaAyuda.VACACIONES_GASTO': 'Lo que van costando las vacaciones: la doceava parte que aparta cada planilla, y lo que se pagó por encima de lo juntado.',
  'cuentaAyuda.INDEMNIZACION_GASTO':
    'La indemnización por antigüedad al terminar un contrato (Art. 45): 30 días de salario por año los primeros tres años y 20 después, hasta 150 días. Sólo por renuncia, despido sin causa o mutuo acuerdo, y a quien tiene prestaciones.',
  'cuentaAyuda.MERMA':
    'Mercadería dañada o perdida, a su costo: lo que se da de baja por daño, lo que se pierde al reempacar y lo que vuelve sin poder venderse.',
  'cuentaAyuda.VENCIDOS': 'Mercadería que se venció y se dio de baja, a su costo promedio.',
  'cuentaAyuda.CONSUMO_INTERNO': 'Mercadería que se sacó para la casa, a su costo promedio.',
  'cuentaAyuda.ALQUILER': 'El alquiler: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.ENERGIA': 'La luz: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.AGUA': 'El agua: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.TRANSPORTE':
    'El transporte y el combustible: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.TELEFONO_INTERNET':
    'El teléfono y el internet: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.MANTENIMIENTO':
    'El mantenimiento y las reparaciones: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.IMPUESTOS_MUNICIPALES':
    'La matrícula y la basura de la alcaldía: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.EMPAQUES':
    'Los empaques y las bolsas: los gastos registrados en esa categoría, el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así. Las bolsas de un reempaque no van aquí: van al costo de lo empacado.',
  'cuentaAyuda.OTROS_GASTOS':
    'Los gastos de ninguna otra categoría: los registrados como «Otros gastos», el día del gasto, pagados o al crédito, y lo que faltó al contar y se explicó así.',
  'cuentaAyuda.FALTANTE_CAJA':
    'Lo que faltó al contar una caja: al abrirla, en el corte, al pasarla a otro turno o cuando el dueño recibe lo que entregó. Baja cuando se explica en qué se fue.',
  'cuentaAyuda.FALTANTE_INVENTARIO':
    'Mercadería que no aparece, a su costo: lo que faltó al contar, lo dado de baja por robo y el saldo de recargas que faltó. También lo que se movió antes de un conteo y llegó a los libros después.',
  'cuentaAyuda.FALTANTE_REPARTO': 'La mercadería que no volvió del camión al liquidar la ruta, a su costo promedio.',
  'cuentaAyuda.REDONDEO':
    'Los centavos que no circulan: cuando se paga todo en efectivo, el total se redondea a la moneda más cercana. Sube cuando el negocio pierde los centavos y baja cuando el cliente paga de más, así que en el período puede quedar en negativo.',
  'cuentaAyuda.PERDIDA_CAMBIARIA': 'Lo que se pierde con los dólares: lo contrario de «Ganancia cambiaria».',
  'cuentaAyuda.TRANSFERENCIAS_PERDIDAS':
    'Los pagos por transferencia o billetera de una venta o una recarga que nunca llegaron al banco y no se pasaron a la cuenta del cliente.',
  'cuentaAyuda.FALTANTE_GENERAL': 'Lo que faltó al contar el efectivo general contra lo que dicen los libros. Baja cuando se explica en qué se fue.',
  'cuentaAyuda.DIFERENCIAS_CONCILIACION':
    'Lo que el estado de cuenta del banco o de la billetera dice de menos contra los libros, como las comisiones; si dice de más, baja.',
  'cuentaAyuda.FIADO_INCOBRABLE': 'El fiado que un cliente debía y el dueño dio por perdido. Baja si se deshace o si el cliente termina pagándolo.',

  // ---------- Planilla ----------
  'planilla.montoInvalido': 'Escriba solo el número, por ejemplo 2500 o 2500.50.',
  'planilla.noSeGuardo': 'No se pudo guardar. Intente otra vez.',
  'planilla.titulo': 'Planilla',
  'planilla.personas': '{n} persona(s) en planilla',
  'planilla.correr': 'Correr planilla',
  'planilla.costoMensual': 'Costo mensual',
  'planilla.pieCosto': 'salarios + patronal + provisiones',
  'planilla.aguinaldoAcumulado': 'Aguinaldo acumulado',
  'planilla.vacacionesAcumuladas': 'Vacaciones acumuladas',
  'planilla.loQueSeDebe': 'lo que ya se debe',
  'planilla.sinPagar': 'Planillas sin pagar',
  'planilla.personal': 'Personal',
  'planilla.corridas': 'Corridas',
  'planilla.contratar': 'Contratar a alguien',
  'planilla.cargo': 'Cargo',
  'planilla.salarioMensual': 'Salario mensual (C$)',
  'planilla.leCuesta': 'Le cuesta al negocio {costo}',
  'planilla.ayudaSalario': 'El costo real es este número más el {tasa} patronal y las provisiones.',
  'planilla.fechaIngreso': 'Fecha de ingreso',
  'planilla.ayudaIngreso': 'De aquí sale la antigüedad, y de la antigüedad sale la indemnización.',
  'planilla.ayudaIngresoEditar': 'El día que empezó a trabajar, aunque haya sido antes de tenerlo aquí: de ahí salen la antigüedad y los días que paga cada planilla.',
  'planilla.cedula': 'Cédula',
  'planilla.inssNumero': 'Nº INSS',
  'planilla.nadie': 'Todavía no hay nadie en planilla.',
  'planilla.desdeAnios': '{cargo} · desde {fecha} · {anios} año(s)',
  'planilla.acumulado': 'Acumulado: aguinaldo {aguinaldo} · vacaciones {vacaciones} ({dias} días)',
  'planilla.liquidar': 'Liquidar',
  'planilla.adelanto': 'Adelanto',
  'planilla.debeAdelantos': 'Debe {monto} en adelantos',
  'planilla.adelantoA': 'Adelanto a {nombre}',
  'planilla.adelantoAyuda':
    'Lo debe {nombre}: la próxima planilla lo descuenta de lo que se le entrega, y lo que no alcance sigue en la otra.',
  'planilla.montoAdelanto': 'Cuánto se le adelanta (C$)',
  'planilla.entregarAdelanto': 'Entregar el adelanto',
  'planilla.adelantosDescontados': 'Adelantos descontados: {monto} · a entregar {entregar}',
  'planilla.menosAdelanto': '− adelanto {monto}',
  'planilla.entregar': 'Entregar {monto}',
  'planilla.menosAdelantos': 'Menos adelantos',
  'planilla.yaNoEstan': 'Ya no están',
  'planilla.sinCorridas': 'Todavía no se ha corrido ninguna planilla.',
  'planilla.liquidacionDe': 'Liquidación — {nombre}',
  'planilla.delPeriodo': 'Planilla de {periodo}',
  'planilla.resumenCorrida': '{fecha} · {n} persona(s) · costo {costo}',
  'planilla.pagadaEl': 'Pagada {fecha}',
  'planilla.marcarPagada': 'Marcar pagada',
  'planilla.cotizaciones': 'INSS {inss} · INATEC {inatec} · IR {ir}',
  'planilla.netoYCosto': 'Neto a entregar · costo total {costo}',
  'planilla.corriendo': 'Corriendo…',
  'planilla.cerrarCorrida': 'Cerrar la corrida',
  // The aguinaldo, paid on its own (2026-10-31).
  'planilla.aguinaldo.pagar': 'Pagar aguinaldo',
  'planilla.aguinaldo.pagando': 'Pagando…',
  'planilla.aguinaldo.cuando': 'El aguinaldo se paga en los primeros diez días de diciembre, sin INSS ni IR.',
  'planilla.aguinaldo.explica':
    'Un mes de salario por año trabajado, del 1 de diciembre al 30 de noviembre, o la parte que toca a quien lleva menos. Sale de lo que las planillas apartaron para cada quien; lo que pase de eso es un gasto de este pago.',
  'planilla.aguinaldo.nadie': 'Nadie tiene aguinaldo: lo va juntando cada planilla de quien tiene prestaciones.',
  'planilla.aguinaldo.apartado': 'Apartado: {monto} · sin INSS ni IR',
  'planilla.aguinaldo.enElPago': 'En el pago: {monto} · apartado entonces: {apartado}',
  'planilla.aguinaldo.deMas': '{monto} más de lo apartado: es un gasto de este pago.',
  'planilla.aguinaldo.noEstaba': 'No estaba en el pago: se agrega.',
  'planilla.aguinaldo.noSeEntiende': 'Falta el monto de {nombres}, o no se entiende.',
  'planilla.aguinaldo.total': 'Se entrega, sin INSS ni IR',
  'planilla.aguinaldo.totalDeMas': 'De eso, {monto} más de lo apartado: gasto de aguinaldo.',
  'planilla.aguinaldo.corregirTitulo': 'Corregir el pago de aguinaldo',
  'planilla.aguinaldo.pagado': 'Pagado el {fecha}, de {cuenta}. Lo que cambie lo entregado sale de ahí, o vuelve, ese mismo día.',
  'planilla.aguinaldo.liquidados': 'Ya se liquidó a {nombres}: este pago ya no se corrige.',
  'planilla.aguinaldo.antes': 'Antes: {monto}',
  'planilla.aguinaldo.sale': '{monto} más salen de {cuenta}, el {fecha}.',
  'planilla.aguinaldo.vuelve': '{monto} vuelven a {cuenta}, el {fecha}.',
  'planilla.aguinaldo.anular': 'Anular el pago',
  'planilla.aguinaldo.anulando': 'Nadie queda en el pago: se anula, y lo pagado vuelve a {cuenta}.',
  'planilla.aguinaldo.titulo': 'Aguinaldo',
  'planilla.aguinaldo.resumen': '{fecha} · {n} persona(s) · de {cuenta}',
  'planilla.aguinaldo.anulado': 'Anulado',
  'planilla.aguinaldo.sinInss': 'Sin INSS ni IR.',
  'planilla.aguinaldo.deAntes': 'Esta planilla pagó {monto} de aguinaldo, de cuando se pagaba con la planilla: se queda como está.',
  // Each person's pay stub of a run, a settlement or an aguinaldo payment (2026-11-01).
  'planilla.colillas.boton': 'Colillas',
  'planilla.colillas.botonUna': 'Colilla',
  'planilla.colillas.titulo': 'Colillas de pago',
  'planilla.colillas.explica':
    'Una para cada quien: lo que ganó, lo que se le descontó y lo que recibe. Impresa o en PDF lleva una línea para que firme que la recibió; por WhatsApp va sin ella.',
  'planilla.colillas.recibe': 'Recibe {monto}',
  'planilla.colillas.imprimirTodas': 'Imprimir todas ({n})',
  // The same stubs as a PDF to download, a page of US Letter each (2026-11-01).
  'planilla.colillas.pdf': 'Descargar PDF',
  'planilla.colillas.pdfTodas': 'Descargar todas en PDF',
  'planilla.colillas.archivo': 'colilla_{nombre}_{fecha}.pdf',
  'planilla.colillas.archivoTodas': 'colillas_{fecha}.pdf',
  'planilla.colillas.error': 'No se pudo hacer el PDF. Intente otra vez.',
  // A run set right, or voided (2026-10-31).
  'planilla.corregir.boton': 'Corregir',
  'planilla.corregir.titulo': 'Corregir la planilla',
  'planilla.corregir.liquidados': 'Ya se liquidó a {nombres}: esta planilla ya no se corrige.',
  'planilla.corregir.antes': 'Antes: neto {neto} · costo {costo}',
  'planilla.corregir.pagoSale': 'Ya se pagó: {monto} más salen de {cuenta}, el {fecha}.',
  'planilla.corregir.pagoVuelve': 'Ya se pagó: {monto} vuelven a {cuenta}, el {fecha}.',
  'planilla.corregir.guardar': 'Guardar la corrección',
  'planilla.corregir.guardando': 'Guardando…',
  'planilla.corregir.sinCambios': 'Sin cambios',
  'planilla.corregir.anular': 'Anular la planilla',
  'planilla.corregir.anulando': 'Nadie queda en la planilla: se anula, y lo que asentó se devuelve.',
  'planilla.corregir.pagada': 'Pagada el {fecha}, de {cuenta}. Lo que cambie lo entregado sale de ahí, o vuelve, ese mismo día.',
  'planilla.corregir.loQueLaPago': 'lo que la pagó',
  'planilla.corregir.sinPagar': 'Todavía sin pagar.',
  'planilla.corregir.porQue': 'Por qué se corrige (opcional)',
  'planilla.corregir.porQueEjemplo': 'Ej.: se le pagó de menos',
  'planilla.corregir.tenia': 'En la planilla: {bruto} de pago, {neto} neto',
  'planilla.corregir.noEstaba': 'No estaba en la planilla: se agrega.',
  'planilla.anulada': 'Anulada',
  'planilla.corregidaEl': 'Corregida el {fecha}',
  'planilla.periodo': 'Período',
  'planilla.ayudaPeriodo': 'Nadie se paga dos veces el mismo día: quien ya está en otra planilla de estos días queda fuera.',
  'planilla.salarioDelMes': 'Salario del mes',
  'planilla.desdeIngreso': 'Entró el {fecha}: {dias} días de esta planilla, el mes contado de treinta',
  'planilla.desdeIngresoSemana': 'Entró el {fecha}: {dias} días de esta semana',
  'planilla.ayudaSalarioMes': 'Vacío = el salario completo',
  'planilla.extrasGravables': 'Extras gravables',
  'planilla.vacacionesPagadas': 'Vacaciones pagadas',
  'planilla.tieneVacaciones': 'Tiene {monto} · paga INSS e IR',
  'planilla.diasVacaciones': 'Días de vacaciones',
  'planilla.diasAcumulados': '{dias} acumulados',
  'planilla.aguinaldo': 'Aguinaldo',
  'planilla.liquidarA': 'Liquidar a {nombre}',
  'planilla.ultimoDia': 'Último día',
  'planilla.salarioPendiente': 'Salario pendiente (C$)',
  'planilla.ayudaPendiente': 'Días ya trabajados este mes que no entraron en ninguna corrida.',
  'planilla.seLeVaAPagar': 'Se le va a pagar',
  'planilla.indemnizacion': 'Indemnización ({anios} años)',
  'planilla.salarioPendienteCorto': 'Salario pendiente',
  'planilla.menosInss': 'Menos su INSS',
  'planilla.menosIr': 'Menos IR',
  'planilla.aEntregar': 'A entregar',
  'planilla.explicacionLiquidacion':
    'El sistema calcula la indemnización del Art. 45 con la fecha de ingreso, no la escribe nadie. El despido con causa justa no la paga, pero el aguinaldo y las vacaciones ya ganadas se pagan igual.',
  'planilla.liquidando': 'Liquidando…',
  'planilla.liquidarYCerrar': 'Liquidar y cerrar el contrato',
  'planilla.editar': 'Editar',
  'planilla.editarA': 'Editar a {nombre}',
  'planilla.comoSePaga': 'Cómo se le paga',
  'planilla.sueldoFijo': 'Sueldo fijo',
  'planilla.porDia': 'Por día trabajado',
  'planilla.cadaCuanto': 'Cada cuánto se le paga',
  'planilla.frecuencia.semanal': 'Semanal',
  'planilla.frecuencia.quincenal': 'Quincenal',
  'planilla.frecuencia.mensual': 'Mensual',
  'planilla.cada.dia': 'por día',
  'planilla.cada.semanal': 'por semana',
  'planilla.cada.quincenal': 'por quincena',
  'planilla.cada.mensual': 'al mes',
  'planilla.pagoPorDia': 'Pago por día (C$)',
  'planilla.sueldoPorSemana': 'Sueldo por semana (C$)',
  'planilla.sueldoPorQuincena': 'Sueldo por quincena (C$)',
  'planilla.ayudaPorDia': 'Lo de un día de trabajo. En cada planilla se ponen los días que trabajó, medios días también.',
  'planilla.ayudaSalarioSinInss': 'El costo real es este número más las provisiones de aguinaldo y vacaciones.',
  'planilla.ayudaDosCampos': 'Escriba el salario del mes o lo que se le paga {cada}: lo otro se calcula solo.',
  'planilla.pagarCorrida': 'Pagar la planilla',
  'planilla.pagarLiquidacion': 'Pagar la liquidación',
  'planilla.pagoDeEfectivoGeneral': 'En efectivo sale del efectivo general, no de la gaveta.',
  'planilla.pagoAnterior': 'Registrar un pago anterior',
  'planilla.yaSePago': 'Ya se pagó',
  'planilla.yaSePagoAyuda': 'Para días que ya se pagaron: la planilla queda registrada y pagada, el día y de la forma en que se pagó.',
  'planilla.sePagoEl': 'Se pagó el',
  'planilla.fechaPagoFuera': 'Un día entre el {desde} y hoy',
  'planilla.antesDelAdelanto': 'Esta planilla le descontó a {nombre} un adelanto que se le dio el {fecha}: se pagó ese día o después',
  'planilla.cotizacionesPorPagar': 'Por pagar al INSS, al INATEC y a la DGI',
  'planilla.ultimoPagoCotizaciones': 'Último pago: {periodo}, el {fecha}',
  'planilla.pagarCotizacionesCorto': 'Pagar',
  'planilla.pagarCotizaciones': 'Pagar al INSS, al INATEC y a la DGI',
  'planilla.mesQueSePaga': 'Mes que se paga',
  'planilla.cotizacionesAyuda': 'Cada monto es lo que deben las planillas hasta ese mes. Si la factura dice otra cosa, escriba lo que dice.',
  'planilla.cotizacion.inss': 'INSS (laboral y patronal)',
  'planilla.cotizacion.inatec': 'INATEC',
  'planilla.cotizacion.ir': 'IR retenido',
  'planilla.seDebe': 'Se debe {monto}',
  'planilla.registrarCotizaciones': 'Registrar el pago',
  'planilla.vacaciones': 'Vacaciones',
  'planilla.vacacionesApuntadas': 'Ya se apuntaron {dias} días de vacaciones ({lista}): ya salieron de lo ganado, no los ponga otra vez en «Días de vacaciones».',
  'vacaciones.titulo': 'Vacaciones de {nombre}',
  'vacaciones.tiene': 'Tiene {dias} días de vacaciones ganados, {monto} apartados para pagarlos.',
  'vacaciones.desde': 'Desde',
  'vacaciones.hasta': 'Hasta',
  'vacaciones.hastaAntes': 'No puede terminar antes de empezar',
  'vacaciones.antesDeEntrar': 'Entró el {fecha}: no pudo descansar antes',
  'vacaciones.dias': 'Días que descansó',
  'vacaciones.diasAyuda': 'Son {n} días: escriba menos si trabajó alguno. Medio día: 0.5.',
  'vacaciones.diasFuera': 'Entre 0.5 y {n} días',
  'vacaciones.efecto': 'Salen {monto} de lo apartado y le quedan {dias} días.',
  'vacaciones.sinGanar': 'Tiene {ganados} días ganados: los otros {sinGanar} son permiso con goce de salario y no salen de sus vacaciones.',
  'vacaciones.sinDinero': 'Su salario de esos días se le paga como siempre, en la planilla: aquí no se entrega dinero.',
  'vacaciones.registrar': 'Registrar las vacaciones',
  'planilla.ayuda.costoMensual': 'Lo que la gente con un pago fijo le cuesta al negocio en un mes: su salario del mes; el INSS patronal ({inss}) y el INATEC ({inatec}) de quienes pagan INSS; y lo que se aparta para su aguinaldo y sus vacaciones, un doceavo del salario cada uno. Esos dos no se entregan cada mes: se deben, y se pagan en diciembre, cuando descansan o cuando se van. Quien cobra por día no entra: cuesta lo que trabaje.',
  'planilla.ayuda.aguinaldo': 'El aguinaldo que la gente ya ganó y todavía no se le ha pagado: cada planilla aparta un doceavo de lo que gana. Se paga con «Pagar aguinaldo» en los primeros diez días de diciembre, un mes de salario por año trabajado, o al liquidar a quien se va.',
  'planilla.ayuda.vacaciones': 'Lo apartado para las vacaciones de la gente, todavía sin usar: cada planilla aparta 2.5 días por mes, un doceavo del salario. Sale de aquí cuando descansan («Vacaciones» en su tarjeta, o en la planilla) o cuando se les pagan, y lo que quede se paga al irse.',
  'planilla.ayuda.sinPagar': 'El neto de las planillas y liquidaciones ya corridas que todavía no se ha entregado, menos los adelantos que descontaron. Se paga con «Marcar pagada» en «Corridas».',
  'planilla.calc.salarios': 'Salarios del mes',
  'planilla.calc.inssPatronal': 'INSS patronal ({tasa})',
  'planilla.calc.inatec': 'INATEC ({tasa})',
  'planilla.calc.aguinaldo': 'Aguinaldo, un doceavo',
  'planilla.calc.vacaciones': 'Vacaciones, un doceavo',
  'planilla.calc.diasDe': '{nombre} · {dias} días',
  'planilla.acumuladoAguinaldo': 'Acumulado: aguinaldo {aguinaldo}',
  'planilla.ayudaSalarioSinInssSinVacaciones': 'El costo real es este número más la provisión del aguinaldo.',
  'planilla.prestacionesSinVacaciones': 'Aguinaldo e indemnización',
  'planilla.ayuda.costoMensualSinVacaciones':
    'Lo que la gente con un pago fijo le cuesta al negocio en un mes: su salario del mes; el INSS patronal ({inss}) y el INATEC ({inatec}) de quienes pagan INSS; y lo que se aparta para su aguinaldo, un doceavo del salario. Ese no se entrega cada mes: se debe, y se paga en diciembre o cuando se van. Las vacaciones no se acumulan en esta tienda («Configuración»). Quien cobra por día no entra: cuesta lo que trabaje.',
  'planilla.desglose.aguinaldoDespues': '{monto} apartado para el aguinaldo no se les entrega ahora: se paga en diciembre o cuando se van.',
  'planilla.desglose.titulo': 'Cálculo de la planilla',
  'planilla.desglose.sueldoDias': 'Salario de {dias} de {de} días (entró el {fecha})',
  'planilla.desglose.porDia': '{dias} días a {tarifa}',
  'planilla.desglose.inss': 'Su INSS ({tasa})',
  'planilla.desglose.ir': 'Impuesto sobre la renta (IR)',
  'planilla.desglose.neto': 'Neto',
  'planilla.desglose.adelantos': 'Adelantos que se descuentan',
  'planilla.desglose.entregado': 'Se le entregó',
  'planilla.desglose.aEntregarTodos': 'A entregar entre todos',
  'planilla.desglose.entregadoTodos': 'Se entregó entre todos',
  'planilla.desglose.costo': 'Lo que le cuesta al negocio',
  'planilla.desglose.suPago': 'Lo que se les paga',
  'planilla.desglose.yaApartado': 'Ya apartado en planillas anteriores',
  'planilla.desglose.costoTotal': 'Costo total',
  'planilla.desglose.cotizacionesDespues':
    '{monto} de INSS, INATEC e IR no se les entrega: se le paga al INSS, al INATEC y a la DGI con «Pagar» en «Corridas».',
  'planilla.desglose.apartadoDespues':
    '{monto} apartado para el aguinaldo y las vacaciones no se les entrega ahora: se paga en diciembre, cuando descansan o cuando se van.',
  'planilla.registrarPagada': 'Registrar pagada',
  'planilla.netoPagadoYCosto': 'Neto que se entregó · costo total {costo}',
  'planilla.sueldosEnGastos': 'En «Gastos» hay sueldos registrados desde el {desde}: {lista}. Si son de estos días, anúlelos allá: si no, se cuentan dos veces.',
  'planilla.yNMas': 'y {n} más',
  'planilla.pagaInss': 'Paga INSS',
  'planilla.pagaInssAyuda': 'Se le rebaja su INSS, y el negocio paga el suyo y el INATEC. Apagado, nada de eso.',
  'planilla.prestaciones': 'Aguinaldo, vacaciones e indemnización',
  'planilla.prestacionesAyuda': 'Se le van juntando en cada planilla, y la indemnización se le paga al salir. Apagado, no se le junta nada.',
  'planilla.sigueDebiendose': 'Lo que ya juntó se le sigue debiendo y se le paga al salir: aguinaldo {aguinaldo}, vacaciones {vacaciones}.',
  'planilla.desdeLaProxima': 'Lo que cambie aquí vale desde la próxima planilla; las que ya se corrieron se quedan como se pagaron.',
  'planilla.sinInss': 'Sin INSS',
  'planilla.sinPrestaciones': 'Sin prestaciones',
  'planilla.pieCostoSinDia': 'salarios + patronal + provisiones; sin {n} persona(s) pagada(s) por día',
  'planilla.deLaSemana': 'Planilla de la semana {rango}',
  'planilla.deLaQuincena': 'Planilla de la quincena {rango}',
  'planilla.aQuienes': 'A quiénes se les paga',
  'planilla.semanaTermina': 'La semana termina el',
  'planilla.queMitad': 'Qué mitad del mes',
  'planilla.primeraQuincena': 'Del 1 al 15',
  'planilla.segundaQuincena': 'Del 16 al {fin}',
  'planilla.yaEsta': 'Ya se le pagó en: {planilla}',
  'planilla.salarioDeLaSemana': 'Salario de la semana',
  'planilla.salarioDeLaQuincena': 'Salario de la quincena',
  'planilla.diasTrabajados': 'Días trabajados',
  'planilla.diasPorTarifa': '× {tarifa} = {monto}',
  'planilla.ayudaDias': '{tarifa}; medio día es 0.5',
  'planilla.noSeEntiende': 'No se entiende un número escrito en la línea de: {nombres}',
  'planilla.faltanDias': 'Faltan los días que trabajó: {nombres}',
  'planilla.tieneVacacionesSinInss': 'Tiene {monto} · paga IR',
  'planilla.diasN': '{n} día(s)',
  'planilla.explicacionSinPrestaciones': 'Se le contrató sin aguinaldo, vacaciones ni indemnización: se le paga lo que tenga pendiente y lo que haya juntado antes.',
  'salida.despido_sin_causa': 'Despido sin causa justa',
  'salida.renuncia': 'Renuncia',
  'salida.mutuo_acuerdo': 'Mutuo acuerdo',
  'salida.despido_con_causa': 'Despido con causa justa',

  // ---------- Compras ----------
  'compra.nueva': 'Mercadería comprada',
  'compra.proveedor': 'Proveedor',
  'compra.factura': 'Factura',
  'compra.facturaRepetida': 'Ya hay una compra de este proveedor con esa factura ({fecha}, {monto}). ¿La está registrando dos veces?',
  'compra.costoPorUnidad': '{monto} por {unidad}',
  'compra.costoMasAlto': 'Es {pct}% más de lo que venía costando ({antes} por {unidad}). Revise la cantidad y la unidad antes de guardar.',
  'compra.costoMasBajo': 'Es {pct}% menos de lo que venía costando ({antes} por {unidad}). Revise la cantidad y la unidad antes de guardar.',
  'compra.costoMasAltoSinMonto': 'Es mucho más de lo que venía costando. Revise la cantidad y la unidad antes de guardar.',
  'compra.costoMasBajoSinMonto': 'Es mucho menos de lo que venía costando. Revise la cantidad y la unidad antes de guardar.',
  'compra.opcional': 'Opcional',
  'compra.tasaDelDia': 'Tasa del día',
  'compra.ayudaTasa': 'La tasa de la fecha de la compra, no la de hoy.',
  'compra.ayudaTasaDolares': 'Paga con dólares del efectivo general: salen a la tasa oficial, que es a la que están guardados.',
  'compra.ayudaTasaCuentaDolares': 'Paga desde una cuenta en dólares: salen a la tasa oficial, que es a la que la cuenta los lleva.',
  'compra.formaPago': 'Forma de pago',
  'compra.alCredito': 'Al crédito',
  'compra.vence': 'Vence',
  'compra.flete': 'Flete {moneda}',
  'compra.ayudaFlete': 'Se reparte entre las líneas según su valor. ¿Lo pagó a otra persona, como el camionero? Agréguelo como un pago aparte.',
  'compra.iva': 'IVA {moneda}',
  'compra.ayudaIva': 'El que trae la factura, si trae. Es parte de lo que cuesta la mercadería: se reparte entre las líneas según su valor, como el flete.',
  'compra.ivaCorto': 'IVA',
  'compra.ivaInvalido': 'Revise el IVA: escríbalo como un monto, como 150.00, o déjelo vacío.',
  'compra.nuevoProveedor': 'Agregar proveedor nuevo',
  'compra.agregarComo': 'Agregar «{nombre}» como proveedor',
  'compra.proveedorNuevoAyuda': 'Se guarda con sus proveedores y queda elegido en esta compra.',
  'compra.pagarParte': 'Pagar una parte de otra forma',
  'compra.otroPago': 'Agregar otro pago',
  'compra.partes': 'Pagado en partes',
  'compra.parteForma': 'Forma',
  'compra.parteMonto': 'Monto {moneda}',
  'compra.elResto': 'El resto',
  'compra.restoAyuda': 'Lo que las partes dejan: {monto}',
  'compra.nadaQueda': 'Las partes pagan toda la compra.',
  'compra.partesDeMas': 'Las partes suman {monto} más que la compra.',
  'compra.faltaMontoParte': 'Escriba cuánto se pagó en cada parte.',
  'compra.unidad': 'Unidad',
  'compra.costoTotal': 'Costo total {moneda}',
  'compra.ayudaCosto': 'Lo que dice la factura por esta línea.',
  'compra.lote': 'Lote',
  'compra.subtotal': 'Subtotal',
  'compra.fleteCorto': 'Flete',
  'compra.totalMoneda': 'Total {moneda}',
  'compra.equivaleA': 'Equivale a',
  'compra.registrando': 'Registrando…',
  'compra.registrar': 'Registrar compra',
  'compra.registradaDe': 'Compra registrada: {proveedor}, {total}',
  'compra.elijaProveedor': 'Elija un proveedor',
  'compra.agregueProducto': 'Agregue al menos un producto',
  'compra.tasaInvalida': 'Revise la tasa: escríbala como 36.62 o 36,62.',
  'compra.fleteInvalido': 'Revise el flete: escríbalo como un monto, como 150.00, o déjelo vacío.',
  'compra.faltaTasa': 'Una compra en dólares necesita la tasa del día',
  'compra.faltaVencimiento': 'Una compra al crédito necesita fecha de vencimiento',
  'compra.faltaCantidad': 'Falta la cantidad de {producto}',
  'compra.faltaCosto': 'Falta el costo de {producto}',
  'gastos.demasiado': 'Ese gasto pasa de lo que el sistema puede llevar, C$ 100,000,000: revise el monto',
  'compra.demasiado': 'Esa compra pasa de lo que el sistema puede llevar, C$ 100,000,000: revise los costos',
  'compra.faltaLote': '{producto} necesita lote y vencimiento',
  'compra.noSePudo': 'No se pudo registrar la compra',
  'compra.productoNuevoAyuda': 'Al guardarlo queda en el catálogo y entra a esta compra, que sigue como la dejó.',

  // ---------- Recargas ----------
  'recargas.titulo': 'Recargas',
  'recargas.volver': 'Volver a las recargas',
  'recargas.ayudaReferencia': 'La recarga se manda ya, pero el pago queda por confirmar hasta que alguien vea el dinero, como el de una venta.',
  'recargas.porConfirmar': 'por confirmar',
  'recargas.noLlego': 'no llegó',
  'recargas.necesitaCaja':
    'Las recargas cobran efectivo, así que necesitan una caja abierta para que cuadre el corte.',
  'recargas.comisionHoy': '{monto} de comisión hoy',
  'recargas.comprarSaldo': 'Comprar saldo',
  'recargas.operadora': 'Operadora',
  'recargas.monto': 'Monto de la recarga',
  'recargas.comoPaga': 'Cómo paga',
  'recargas.efectivo': 'Efectivo',
  'recargas.registrar': 'Registrar recarga',
  'recargas.noSePudo': 'No se pudo registrar',
  'recargas.saldoDisponible': 'Saldo disponible',
  'recargas.sinSaldo':
    'No hay saldo registrado. Se pueden hacer recargas igual, pero sin saber cuánto se gana en cada una — registre la compra de saldo para que aparezca la comisión.',
  'recargas.saldoNegativo':
    'El saldo de {operadora} está en negativo: se vendieron recargas sin haber registrado la compra.',
  'recargas.ultimas': 'Últimas recargas',
  'recargas.explicacionCompra':
    'El saldo se compra por debajo del valor facial. Esa diferencia es la ganancia, y se realiza cuando se vende cada recarga.',
  'recargas.valorFacial': 'Valor facial',
  'recargas.loQuePago': 'Lo que pagó',
  'recargas.descuentoDel': 'Descuento del {pct}%',
  'recargas.comoPago': 'Cómo pagó',
  'recargas.registrarCompra': 'Registrar compra',
  'recargas.costoMayor': 'Lo pagado no puede pasar del valor facial: nadie vende saldo por más de lo que vale.',
  'recargas.contarSaldo': 'Contar saldo',
  'recargas.contarExplicacion':
    'Escriba el saldo que muestra la operadora ahora, en su portal o en su mensaje. La diferencia con los libros se registra: si falta, salieron recargas que nadie registró, o se regalaron.',
  'recargas.saldoReal': 'Saldo real en {operadora}',
  'recargas.registrarConteo': 'Registrar el conteo',
  'recargas.resultadoConteo': 'En libros {libros} · real {real}',
  'recargas.faltaSaldo': 'Faltan {monto} de saldo',
  'recargas.sobraSaldo': 'Sobran {monto} de saldo',
  'recargas.cuadraSaldo': 'Cuadra',

  // ---------- Carga rápida ----------
  'carga.yaVende':
    'La tienda ya vende: aquí se crea el producto con sus precios, y su existencia entra con una compra, que dice lo que costó y cómo se pagó.',
  'carga.yaVendeSinPrecios':
    'La tienda ya vende: aquí se crea el producto, y su existencia entra con una compra, que dice lo que costó y cómo se pagó.',
  'carga.titulo': 'Carga rápida',
  'carga.sinListas':
    'Primero cree al menos una lista de precios. Abra Productos una vez y el sistema crea la de precio al público y la de precio mayorista.',
  'carga.cargadosSesion': '{n} producto(s) cargados en esta sesión',
  'carga.margenPublico': '% público',
  'carga.margenMayorista': '% mayorista',
  'carga.ejemploNombre': 'Arroz 80/20',
  'carga.costoPor': 'Costo / {unidad}',
  'carga.existencia': 'Existencia',
  'carga.atajos': 'Enter guarda · Esc limpia',
  'carga.enEstaSesion': 'Cargados en esta sesión',
  'carga.sinPrecio': 'sin precio',
  'carga.costoResumen': 'costo {monto}',

  // ---------- Producto nuevo ----------
  'producto.creado': 'Producto creado: {nombre}',
  'producto.nuevo': 'Nuevo producto',
  'producto.categoria': 'Categoría',
  'producto.unidadBase': 'Unidad base',
  'producto.unidad': 'Unidad',
  'producto.ayudaUnidad':
    'Cómo se guarda la existencia. Las presentaciones de venta (bolsa, quintal, caja) se agregan después.',
  'producto.codigoBarras': 'Código de barras',
  'producto.ayudaCodigo':
    'Opcional. Escanéelo con la cámara o escríbalo. Se pueden agregar más después: la misma mercadería en otra presentación escanea distinto.',
  'producto.precios': 'Precios',
  'producto.preciosDelDueno': 'Los precios los pone el dueño.',
  'producto.esMedicamento': 'Es medicamento',
  'producto.descMedicamento':
    'Solo la lista de venta libre del MINSA. Obliga a registrar lote y vencimiento al recibir.',
  'producto.esPerecedero': 'Es perecedero',
  'producto.descPerecedero': 'También obliga a registrar vencimiento al recibir.',
  'producto.registroSanitario': 'Registro sanitario',
  'producto.guardar': 'Guardar producto',
  'producto.noSePudoGuardar': 'No se pudo guardar',
  'producto.sugerirMargen': 'Sugerir precio con {margen}% de margen',
  'producto.nombre': 'Nombre',
  'producto.nombreEn': 'Nombre en inglés',
  'producto.ayudaNombreEn':
    'Opcional. Es lo que se ve cuando la app está en inglés; el recibo siempre lleva el nombre de arriba.',

  // ---------- Foto del producto ----------
  'foto.tomar': 'Tomar foto',
  'foto.cambiar': 'Cambiar foto',
  'foto.quitar': 'Quitar foto',
  'foto.preparando': 'Preparando la foto…',
  'foto.galeria': 'Galería',
  'foto.internet': 'Buscar en internet',
  'foto.camara.titulo': 'Foto de {producto}',
  'foto.camara.ayuda': 'La foto es lo que se ve en el cuadro.',
  'foto.camara.asiQueda': 'Así queda la foto.',
  'foto.camara.usar': 'Usar foto',
  'foto.camara.otraVez': 'Otra vez',
  'foto.camara.sinCamaraAyuda':
    'Este aparato no tiene cámara, o el navegador no deja usarla. Cierre esto y use «Galería» para elegir un archivo.',
  'foto.ayuda': 'Con foto se encuentra de un vistazo al vender.',
  'foto.noSePudo': 'No se pudo usar esa imagen. Pruebe con otra foto.',

  // ---------- Escáner ----------
  'escaner.abrir': 'Escanear con la cámara',
  'escaner.titulo': 'Escanear producto',
  'escaner.tituloCodigo': 'Escanear el código',
  'escaner.abriendo': 'Abriendo la cámara…',
  'escaner.preparando': 'Preparando el lector…',
  'escaner.ayuda': 'Ponga el código de barras dentro del recuadro',
  'escaner.linterna': 'Linterna',
  'escaner.listo': 'Listo',
  'escaner.seguir': 'Seguir escaneando',
  'escaner.continuoAyuda': 'Pase un producto tras otro: cada uno suena cuando se lee.',
  'escaner.codigoGuardado': 'Código guardado en este producto',
  'escaner.noEsta': 'Este código no está en el catálogo',
  'escaner.noEstaAyuda':
    'Si es de un producto que ya tiene, dígale cuál: el código queda guardado y la próxima vez lo reconoce solo.',
  'escaner.esDeUnProducto': 'Elegir el producto',
  'escaner.pidaAlDueno': 'Para guardarlo en un producto hace falta alguien que pueda editar productos.',
  'escaner.cualProducto': '¿Qué producto es?',
  'escaner.cualProductoAyuda': 'El código {codigo} queda guardado en el producto que elija.',
  'escaner.buscarProducto': 'Buscar por nombre',
  'escaner.cualPresentacion': '¿En cuál viene impreso el código {codigo}? Así, al escanearlo, se cobra esa.',
  'escaner.otroProducto': 'Era otro producto',
  'escaner.varios': 'Este código está en {n} productos',
  'escaner.variosAyuda':
    'Toque el que tiene en la mano, o marque su número. Si es el mismo producto anotado dos veces, quítele el código a uno en Productos.',
  'cualEs.titulo': '¿Cuál es?',
  'escaner.reintentar': 'Reintentar',
  'escaner.falla.permiso': 'La app no tiene permiso para usar la cámara',
  'escaner.falla.permisoAyuda':
    'Permita la cámara para esta página en los ajustes del navegador —el candado junto a la dirección— y toque «Reintentar».',
  'escaner.falla.sinCamara': 'No se encontró una cámara',
  'escaner.falla.sinCamaraAyuda':
    'Este aparato no tiene cámara, o el navegador no deja usarla. El código también se puede escribir a mano.',
  'escaner.falla.ocupada': 'La cámara está ocupada',
  'escaner.falla.ocupadaAyuda': 'Otra app la está usando. Ciérrela y toque «Reintentar».',
  'escaner.falla.lector': 'No se pudo preparar el lector',
  'escaner.falla.lectorAyuda':
    'Abra la app una vez con señal para que quede guardado en el teléfono, y vuelva a intentar.',
  'escaner.falla.otra': 'No se pudo abrir la cámara',
  'escaner.falla.otraAyuda': 'Toque «Reintentar». Si sigue igual, cierre la app y vuelva a abrirla.',

  'codigo.yaEsDe': 'Ese código ya es de «{producto}».',
  'codigo.yaEsDeDesactivado': 'Ese código es de «{producto}», que está desactivado.',
  'codigo.verlo': 'Ver ese producto',
  'codigo.yaEstaTitulo': 'Ya está en la tienda',
  'codigo.nuevoTitulo': 'Código nuevo',
  'codigo.mismoUOtro':
    'Algunas fábricas ponen el mismo código a dos productos distintos. Si este es otro, siga: al escanearlo, la app preguntará cuál es.',
  'codigo.esElMismo': 'Es el mismo producto',
  'codigo.esOtro': 'Es otro producto con el mismo código',
  'codigo.yaLoLlevan': 'Ese código ya lo llevan {n} productos.',
  'codigo.esUnoDeEstos': 'Si es uno de estos, tóquelo para abrirlo.',
  'codigo.compartido': 'También lo lleva «{producto}»: al escanearlo, la app preguntará cuál es.',
  'codigo.compartidoDesactivado': 'También lo lleva «{producto}», que está desactivado.',
  'codigo.tambienLoLleva': 'También lo lleva «{producto}»',
  'codigo.tambienLoLlevaDesactivado': 'También lo lleva «{producto}», que está desactivado',
  'codigo.sePreguntaCual': 'Al escanear un código que llevan dos productos, la app pregunta cuál es.',
  'codigo.loLlenoYo': 'Lo lleno yo',
  'codigo.muyLargo': 'Un código de barras no puede pasar de {max} caracteres.',

  // ---------- Lista de compras ----------
  'compras.titulo': 'Compras',
  'compras.registradas': '{n} registrada(s)',
  'compras.ninguna': 'Todavía no se ha registrado ninguna compra.',
  'compras.registrarPrimera': 'Registrar la primera',
  'compras.resumen': '{fecha} · {n} línea(s) · {pago}',
  'compras.tasaUsd': ' · US$ a {tasa}',
  'compras.anulada': 'Anulada: {motivo}',
  'compras.vence': 'Vence {fecha}',
  'compras.flete': 'flete {monto}',
  'compras.iva': 'IVA {monto}',
  'compras.enPartes': 'en partes',
  'compras.parteEfectivo': 'Efectivo',
  'compras.conLaCompra': '{fecha} · con la compra',
  'compras.motivoAnulacion': 'Motivo de la anulación',
  'compras.anularEsta': 'Anular esta compra',
  'compras.noSePudoAnular':
    'No se pudo anular: ya hay movimientos posteriores sobre estos productos. Si lo equivocado es el costo, corríjalo; si es la cantidad, registre un ajuste de inventario.',
  'compras.anteriores': 'Compras anteriores',
  'compras.pagado': 'Pagado',
  'compras.porPagar': 'Por pagar',
  'corregir.boton': 'Corregir un costo',
  'corregir.titulo': 'Corregir un costo · {proveedor}',
  'corregir.explicacion':
    'Para cuando el costo de una línea se escribió mal y la mercadería ya se movió. Lo que queda cambia de valor, lo ya vendido pasa al costo de ventas, y lo pagado o lo que se debe cambia con él. La compra del {fecha} queda con el costo correcto.',
  'corregir.conDevolucion': 'Ya volvió algo al proveedor: esta línea no se corrige.',
  'corregir.costoCorrecto': 'Costo correcto de la línea ({moneda}), sin flete',
  'corregir.antes': 'Ahora: {costo}',
  'corregir.bajoLoAbonado':
    'A ese proveedor ya se le abonó más de lo que costaría la compra: él le debe la diferencia.',
  'corregir.debeMas': 'Al proveedor se le debe {monto} más.',
  'corregir.debeMenos': 'Al proveedor se le debe {monto} menos.',
  'corregir.gavetaMas': 'Se pagó de la gaveta, que sigue abierta: su corte espera {monto} menos.',
  'corregir.gavetaMenos': 'Se pagó de la gaveta, que sigue abierta: su corte espera {monto} más.',
  'corregir.corte': 'Se pagó de una gaveta ya contada.',
  'corregir.conteo': 'Se pagó {cuenta}, y ya se contó después.',
  'encontrado.enEse': 'En ese conteo: {antes}; corregido, {despues}.',
  'encontrado.capitalSube': 'Fue su primer conteo, que puso el capital: el capital sube {monto}.',
  'encontrado.capitalBaja': 'Fue su primer conteo, que puso el capital: el capital baja {monto}.',
  'encontrado.cuadre': 'Lo que encontró al cuadrarse cambia {monto}.',
  'corregir.cuentaMas': 'Se pagó {cuenta}: en libros queda {monto} menos.',
  'corregir.cuentaMenos': 'Se pagó {cuenta}: en libros queda {monto} más.',
  'corregir.deEfectivo': 'del efectivo general',
  'corregir.deBanco': 'del banco',
  'corregir.deBilletera': 'de la billetera',
  'corregir.guardar': 'Corregir el costo',
  'corregir.noSePudo': 'No se pudo corregir el costo. Revise la línea y vuelva a intentarlo.',

  // ---------- Corregir una cantidad (2026-10-13) ----------
  'cantidad.boton': 'Corregir una cantidad',
  'cantidad.titulo': 'Corregir una cantidad · {proveedor}',
  'cantidad.explicacion':
    'Para cuando la cantidad de una línea se escribió mal: un saco anotado como una unidad. Lo que costó la línea no cambia; cambia lo que costó cada unidad, en el inventario y en las ventas que la llevaron, que pasan a mostrar lo que de verdad ganaron. La compra del {fecha} queda con la cantidad correcta.',
  'cantidad.correcta': 'Lo que de verdad llegó',
  'cantidad.ahora': 'La línea dice {cantidad}: {costo} cada {unidad}',
  'cantidad.misma': 'Esa ya es la cantidad de la línea.',
  'cantidad.otraAlMismoCosto':
    'Después de esta compra entró otra de este producto al mismo costo, la del {fecha}: corrija primero esa, y después esta.',
  'cantidad.cadaUnidad': 'Cada {unidad}: {antes} → {despues}',
  'cantidad.ventasBajan': '{n} venta(s) la llevaron a ese costo: cuestan {monto} menos, y ganan eso más.',
  'cantidad.ventasSuben': '{n} venta(s) la llevaron a ese costo: cuestan {monto} más, y ganan eso menos.',
  'cantidad.estante': 'En existencia: {antes} → {despues} {unidad}, que valen {valorAntes} → {valorDespues}.',
  'cantidad.contado':
    'Se contó después de la compra: quedan las {cantidad} {unidad} que encontró el conteo, que valen {valorAntes} → {valorDespues}.',
  'cantidad.sobranteBaja': 'Lo que el conteo anotó de más baja {monto}.',
  'cantidad.sobranteSube': 'Lo que el conteo anotó de más sube {monto}.',
  'cantidad.faltanteBaja': 'Lo que el conteo anotó como faltante baja {monto}.',
  'cantidad.faltanteSube': 'Lo que el conteo anotó como faltante sube {monto}.',
  'cantidad.mezclado':
    'Después de esa compra entró más de este producto a otro costo: el inventario queda a {costo} cada {unidad}. Si no es lo correcto, corríjalo en el producto, con «Corregir el costo».',
  'cantidad.sinDinero': 'No se mueve dinero: lo pagado y lo que se debe quedan igual.',
  'cantidad.guardar': 'Corregir la cantidad',
  'cantidad.noSePudo': 'No se pudo corregir la cantidad. Revise la línea y vuelva a intentarlo.',
  'pagoCorregido.boton': 'Corregir la forma de pago',
  'pagoCorregido.titulo': 'Corregir la forma de pago · {proveedor}',
  'pagoCorregido.explicacion':
    'Diga cómo se pagó de verdad la compra del {fecha}, de {monto}: el dinero vuelve adonde la compra dice que salió, y sale de donde de verdad salió. Lo que costó la mercadería no cambia.',
  'pagoCorregido.dice': 'La compra dice: {forma}',
  'pagoCorregido.deVerdad': 'Cómo se pagó de verdad',
  'pagoCorregido.deGaveta': 'de la gaveta',
  'pagoCorregido.deCuenta': 'de {nombre}',
  'pagoCorregido.vuelveDeuda': 'Al proveedor ya no se le debe {monto}.',
  'pagoCorregido.vuelveGaveta': 'Decía que salió de la gaveta, que sigue abierta: su corte espera {monto} más.',
  'pagoCorregido.vuelveCorte': 'Decía que salió de una gaveta ya contada.',
  'pagoCorregido.vuelveConteo': 'Decía que se pagó {cuenta}, y ya se contó después.',
  'pagoCorregido.vuelveCuenta': 'Decía que se pagó {cuenta}: en libros vuelven {monto} ahí.',
  'pagoCorregido.saleDeuda': 'Al proveedor se le debe {monto}, para el {fecha}.',
  'pagoCorregido.saleGaveta': 'Sale de la gaveta, que sigue abierta: su corte espera {monto} menos.',
  'pagoCorregido.saleCorte': 'Salió de una gaveta ya contada.',
  'pagoCorregido.saleConteo': 'Se pagó {cuenta}, y ya se contó después.',
  'pagoCorregido.saleCuenta': 'Se pagó {cuenta}: en libros quedan {monto} menos ahí.',
  'pagoCorregido.mismaPlata': 'Las dos son la misma plata: cambia lo que dice la compra, y en libros no se mueve nada.',
  'pagoCorregido.enDolares': 'Una compra en dólares entró a la tasa que tomó su forma de pago: esa no se corrige aquí.',
  'pagoCorregido.enPartes': 'Esa compra se pagó en partes: cada parte es su propio pago, y no se corrige aquí.',
  'pagoCorregido.conDevoluciones': 'Esa compra ya tiene devoluciones al proveedor, que se liquidaron como se pagó: no se corrige aquí.',
  'pagoCorregido.conAbonos': 'Esa compra ya tiene abonos al proveedor: anúlelos primero, y después corrija cómo se pagó.',
  'pagoCorregido.guardar': 'Corregir la forma de pago',
  'pagoCorregido.noSePudo': 'No se pudo corregir la forma de pago. Revise y vuelva a intentarlo.',

  // ---------- Corregir el conteo de una caja (2026-10-14) ----------
  'conteoCaja.boton': 'Corregir el conteo',
  'conteoCaja.tituloApertura': 'Corregir la apertura',
  'conteoCaja.tituloCorte': 'Corregir el corte',
  'conteoCaja.ayudaApertura': 'Escriba lo que de verdad había en la gaveta al abrir. La apertura queda en el registro como se escribió, y la corrección al lado.',
  'conteoCaja.ayudaCorte': 'Escriba lo que de verdad se contó al cerrar y lo que de verdad se dejó en la gaveta. El corte queda en el registro como se escribió, y la corrección al lado.',
  'conteoCaja.seAnoto': 'Lo que se anotó',
  'conteoCaja.seConto': 'Se contó',
  'conteoCaja.seEsperaba': 'Se esperaba',
  'conteoCaja.delGeneral': 'Salió del efectivo general',
  'conteoCaja.puesto': 'Traído del efectivo general',
  'conteoCaja.alAbrirFue': 'Al abrir',
  'conteoCaja.resultado': 'Resultado',
  'conteoCaja.seDejo': 'Se dejó en la gaveta',
  'conteoCaja.seEntrego': 'Se entregó',
  'conteoCaja.alDueno': '{monto}, al dueño',
  'conteoCaja.porRecibir': '{monto}, por recibir',
  'conteoCaja.faltaron': 'Faltaron {monto}',
  'conteoCaja.sobraron': 'Sobraron {monto}',
  'conteoCaja.cuadro': 'Cuadró',
  'conteoCaja.cordobasHabia': 'Córdobas que de verdad había',
  'conteoCaja.dolaresHabia': 'Dólares que de verdad había',
  'conteoCaja.cordobasContados': 'Córdobas que de verdad se contaron',
  'conteoCaja.dolaresContados': 'Dólares que de verdad se contaron',
  'conteoCaja.yaSeAbrio': 'La gaveta ya se abrió otra vez: lo que se dejó cambia también lo que esperaba la apertura siguiente.',
  'conteoCaja.laSiguiente': 'En la apertura siguiente',
  'conteoCaja.ultimoCorteAyuda': 'Lo que dejó el último corte se corrige en ese corte, y esta apertura se corrige con él.',
  'conteoCaja.corregirUltimoCorte': 'Corregir el último corte',
  'conteoCaja.libros': 'Con esta corrección',
  'conteoCaja.alAbrir': 'Al abrir: {antes}; corregido, {despues}.',
  'conteoCaja.enElCorte': 'En el corte: {antes}; corregido, {despues}.',
  'conteoCaja.enLaSiguiente': 'En la apertura siguiente: {antes}; corregido, {despues}.',
  'conteoCaja.faltaban': 'faltaban {monto}',
  'conteoCaja.sobraban': 'sobraban {monto}',
  'conteoCaja.cuadraba': 'cuadraba',
  'conteoCaja.faltan': 'faltan {monto}',
  'conteoCaja.sobran': 'sobran {monto}',
  'conteoCaja.cuadra': 'cuadra',
  'conteoCaja.vuelveAlGeneral': 'Vuelven {monto} al efectivo general.',
  'conteoCaja.saleDelGeneral': 'Salen {monto} más del efectivo general.',
  'conteoCaja.generalContado': 'El efectivo general ya se contó después, y su saldo queda como se contó.',
  'conteoCaja.masPorRecibir': 'Por recibir de esta caja: {monto} más.',
  'conteoCaja.menosPorRecibir': 'Por recibir de esta caja: {monto} menos.',
  'conteoCaja.quedaraEnGaveta': 'Queda en la gaveta: {monto}.',
  'conteoCaja.esperara': 'Al cerrar, la caja esperará {monto}.',
  'conteoCaja.guardar': 'Corregir',
  'conteoCaja.noSePudo': 'No se pudo corregir el conteo. Revise y vuelva a intentarlo.',
  'conteoCaja.no.deRuta': 'La caja de una ruta se cuadra al liquidarla.',
  'conteoCaja.no.antigua': 'Esta caja se abrió antes de que el fondo se llevara en los libros: su apertura no se corrige.',
  'conteoCaja.no.entregada': 'Esta caja cambió de manos después de abrirse: quien la recibió la contó, y ese conteo ya encontró lo que había.',
  'conteoCaja.no.sinCorte': 'Esta caja todavía no se ha cerrado.',
  'conteoCaja.no.quedaDeMas': 'No se puede dejar en la gaveta más de lo que se contó.',
  'conteoCaja.no.relevada': 'La gaveta ya se abrió otra vez, y la apertura siguiente no está en este equipo: lo que se dejó no se corrige desde aquí.',
  'conteoCaja.no.recibida': 'El dueño ya recibió y contó lo que entregó esta caja: lo entregado ya no se corrige.',
  'conteoCaja.no.explicada': 'Ya se explicaron {explicado} de lo que faltó; corregido, faltarían {faltaria}. Anule esa explicación en «Gastos y pagos» primero.',

  // ---------- Corregir el costo del inventario (2026-10-13) ----------
  'costoInv.boton': 'Corregir el costo',
  'costoInv.titulo': 'Corregir el costo · {producto}',
  'costoInv.explicacion':
    'Lo que cuesta cada {unidad} en el inventario, de aquí en adelante: lo que queda pasa a valer eso, y lo que se venda sale a ese costo. Las ventas ya hechas se quedan como están, y la diferencia va a «Ajuste del costo de inventario». Si el costo salió mal por una compra con la cantidad equivocada, corrija mejor esa cantidad en «Mercadería comprada»: así se corrigen también las ventas.',
  'costoInv.lugar': 'Dónde',
  'costoInv.ahora': 'Ahora: {costo} cada {unidad} · {cantidad} {unidad} · {valor}',
  'costoInv.costo': 'Costo (C$)',
  'costoInv.cuantas': 'Por cuántas ({unidad})',
  'costoInv.ayuda': 'Por ejemplo, un saco de 100 libras que costó C$ 1,250: C$ 1,250 por 100.',
  'costoInv.valor': 'Lo que hay aquí vale {antes} → {despues}: {diferencia} a «Ajuste del costo de inventario».',
  'costoInv.sinExistencia': 'No hay nada en existencia aquí: el costo nuevo es para lo que se venda antes de la próxima compra.',
  'costoInv.mismo': 'Ese ya es su costo.',
  'costoInv.guardar': 'Corregir el costo',
  'costoInv.noSePudo': 'No se pudo corregir el costo. Vuelva a intentarlo.',
  'costoInv.motivoSinCosto': 'No tenía costo',
  'costoInv.motivoRecienPuesto': 'Corrige el costo que se acaba de poner',

  // ---------- Catálogo inicial ----------
  'semilla.titulo': 'Catálogo inicial',
  'semilla.sinPermiso': 'Hace falta permiso para editar productos.',
  'semilla.agregados': 'Se agregaron {n} producto(s).',
  'semilla.sinPreciosAun':
    'Ninguno tiene precio ni costo todavía: el costo sale de la primera compra y el precio lo pone usted. Un precio que venga de fábrica es un precio equivocado que alguien va a creer.',
  'semilla.sinPreciosDelDueno':
    'Ninguno tiene precio ni costo todavía: el costo sale de la primera compra y el precio lo pone el dueño.',
  'semilla.verCatalogo': 'Ver el catálogo',
  'semilla.porAgregar': '{n} producto(s) por agregar',
  'semilla.explicacion':
    'Una lista de lo que vende casi cualquier pulpería, para no empezar con la pantalla en blanco. Elija lo que le sirva; lo demás se borra o se edita después.',
  'semilla.yaEstan': 'Ya están los {total}',
  'semilla.pendientes': '{n} de {total} por agregar',
  'semilla.agregando': 'Agregando {n} de {total}…',
  'semilla.todoCargado': 'Ya está todo cargado',
  'semilla.agregar': 'Agregar {n} producto(s)',
  'semilla.notaFinal':
    'Sin precios y sin costos, a propósito. Los precios son locales y se mueven; el costo sale de la primera compra, que es de donde tiene que salir.',

  // ---------- Inventario ----------
  'inv.titulo': 'Inventario',
  'inv.enExistencia': '{monto} en existencia',
  'inv.contar': 'Contar',
  'inv.reempaque': 'Reempaque',
  'inv.traslado': 'Traslado',
  'inv.buscar': 'Buscar producto…',
  'inv.negativos':
    '{n} producto(s) con existencia negativa: se vendió más de lo registrado. Un conteo los corrige.',
  'inv.verNegativos': 'Ver cuáles',
  'inv.verTodo': 'Ver todo',
  'inv.sinNegativos': 'Ya ningún producto tiene existencia negativa.',
  'inv.sinExistencias': 'Sin existencias que mostrar.',
  'inv.aCero': 'Dejar en 0',
  'inv.contarProducto': 'Contar {producto}',
  'inv.aCeroAyuda':
    'Existencia: {cantidad}. Se vendió más de lo registrado. Si no queda nada, regístrelo en 0; si queda, escriba cuánto hay.',
  'inv.sacar': 'Sacar',
  'inv.sacarProducto': 'Sacar {producto}',
  'inv.registrarSalida': 'Registrar salida',
  'inv.cantidadEn': 'Cantidad en {unidad}',
  'inv.ayudaMotivo': 'Cada motivo va a su propia cuenta: dañado y robado no son lo mismo.',
  'inv.escaneado': 'Existencia',
  'inv.hay': 'Hay {cantidad}',
  'inv.noHay': 'No hay en el inventario',
  'inv.hayNegativo': 'Negativa: {cantidad}. Un conteo la corrige.',
  'inv.productoNuevoAyuda': 'Al guardarlo queda en el catálogo, todavía sin existencia: entra con una compra o un conteo.',
  'salidaInv.merma': 'Dañado o derramado',
  'salidaInv.vencido': 'Vencido',
  'salidaInv.consumo_interno': 'Consumo de la casa',
  'salidaInv.robo': 'Robo o no aparece',

  // ---------- Traslado ----------
  'traslado.titulo': 'Traslado',
  'traslado.saleDe': 'Sale de',
  'traslado.entraA': 'Entra a',
  'traslado.distintos': 'El origen y el destino tienen que ser distintos.',
  'traslado.hay': 'Hay {cantidad} {unidad}',
  'traslado.excede': ' — está trasladando más de lo registrado',
  'traslado.sinExistencia': 'Sin existencia registrada en el origen',
  'traslado.seMueven': 'Se mueven {monto} al costo con que están registrados.',
  'traslado.registrar': 'Registrar traslado',
  'traslado.registrado': 'Traslado registrado',

  // ---------- Detalle de producto ----------
  'detalle.producto': 'Producto',
  'detalle.noEncontrado': 'No se encontró este producto.',
  'detalle.subtitulo': '{categoria} · se guarda en {unidad}',
  'detalle.existencia': 'Existencia',
  'detalle.sinExistencia': 'Sin existencia registrada.',
  'detalle.valorTotal': 'Valor total',
  'detalle.negativa':
    'La existencia está en negativo. Se vendió más de lo que el sistema tenía registrado — revise con un conteo.',
  'detalle.presentaciones': 'Presentaciones y precios',
  'detalle.presentacion': 'Presentación',
  'detalle.aCosto': 'a {monto}',
  'detalle.costoUnidad': ' · costo {monto}',
  'detalle.nuevaPresentacion': 'Nueva presentación',
  'detalle.ejemploPresentacion': 'bolsa 5 lb',
  'detalle.precioDeLaNueva': 'Se agrega con su precio: {precios}, {n} × el de «{unidad}». Se cambia en la tabla.',
  'detalle.enUnidad': 'En {unidad}',
  'detalle.lotes': 'Lotes recibidos',
  'detalle.vence': 'vence {fecha} · {cantidad} {unidad}',
  'detalle.codigos': 'Códigos de barras',
  'detalle.sinCodigos':
    'Todavía no tiene ninguno. Con uno, este producto se encuentra al vender con solo escanearlo.',
  'detalle.nuevoCodigo': 'Agregar un código',
  'detalle.yaLoTiene': 'Este producto ya tiene ese código.',
  'detalle.suenaComo': 'Al escanearlo, se vende',
  'detalle.elijaPresentacion': 'Elija la presentación',
  'detalle.deCualEs': '¿De cuál presentación es este código? Elíjala y queda guardado: el de la caja viene impreso en la caja.',
  'detalle.desactivado':
    'Desactivado. No aparece al vender ni en los precios, y su código no lo encuentra. Lo vendido y comprado sigue a su nombre.',
  'detalle.reactivar': 'Reactivar',
  'detalle.desactivar': 'Desactivar producto',
  'detalle.ayudaDesactivar':
    'Para lo que el negocio ya no vende. No se borra: lo vendido y comprado sigue a su nombre, y se puede reactivar.',
  'detalle.desactivarTitulo': '¿Desactivar «{nombre}»?',
  'detalle.desactivarMensaje':
    'Deja de aparecer al vender, en los precios y en la lista de productos, y su código ya no lo encuentra. No se borra: lo que ya se vendió o compró sigue a su nombre, y se puede reactivar desde «Desactivados», en Productos.',

  // ---------- Reempaque ----------
  'reempaque.titulo': 'Reempaque',
  'reempaque.cambiar': 'Cambiar',
  'reempaque.queSeAbre': '¿Qué se abre?',
  'reempaque.disponible': '{cantidad} {unidad} · {costo}/{unidad}',
  'reempaque.sinExistencia': 'sin existencia registrada',
  'reempaque.hay': '{cantidad} {unidad}',
  'reempaque.seConsume': 'Se consume ({unidad})',
  'reempaque.sePierde': 'Se pierde',
  'reempaque.loDerramado': 'Lo derramado',
  'reempaque.queSale': '¿Qué sale?',
  'reempaque.lleva': 'Cuánto de {origen} lleva, en {unidad}',
  'reempaque.llevaNoSuma': 'Lo que lleva cada uno suma {suma} {unidad}; se consumieron {bueno} {unidad} sin lo que se perdió.',
  'reempaque.enUnidad': 'en {unidad}',
  'reempaque.costoEmpaque': 'Costo de empaque y mano de obra',
  'reempaque.ayudaEmpaque': 'Bolsas, etiquetas, tiempo. Se suma al costo del producto empacado.',
  'reempaque.comoQueda': 'Cómo queda el costo',
  'reempaque.valorConsumido': 'Valor que se consume',
  'reempaque.valorMerma': 'Se pierde (a merma)',
  'reempaque.empaque': 'Empaque',
  'reempaque.vaAlEmpacado': 'Va al producto empacado',
  'reempaque.costoDe': 'Costo de {producto}',
  'reempaque.registrar': 'Registrar reempaque',
  'reempaque.registrado': 'Reempaque registrado',
  'reempaque.noSePudo': 'No se pudo registrar el reempaque',

  // ---------- Conteo ----------
  'conteo.resultado': 'Resultado del conteo',
  'conteo.cuadraron': '{n} de {total} productos cuadraron.',
  'conteo.detalle': 'sistema {sistema} · contado {contado}',
  'conteo.cuadro': 'cuadró',
  'conteo.titulo': 'Conteo físico',
  'conteo.conCantidad': '{n} producto(s) con cantidad',
  'conteo.agregarProducto': 'Agregar producto al conteo',
  'conteo.explicacion':
    'No se muestra lo que dice el sistema mientras cuenta. Un conteo hecho mirando la respuesta no mide nada. Se puede seguir vendiendo: cada producto se compara con lo que decía el sistema al anotarlo. Los productos desactivados también se cuentan.',
  'conteo.registrar': 'Registrar conteo',
  'conteo.malas': 'Revise lo contado de {lista}: una cantidad no puede ser negativa ni llevar letras.',
  'conteo.productoNuevoAyuda': 'Al guardarlo queda en el catálogo y entra a este conteo, que sigue como lo dejó.',

  // ---------- Bitácora ----------
  'bitacora.titulo': 'Bitácora',
  'bitacora.registros': '{n} registro(s) en este equipo',
  'bitacora.movimientos': 'Movimientos',
  'bitacora.rechazos': 'Rechazos',
  'bitacora.grupo.todo': 'Todo',
  'bitacora.grupo.ventas': 'Ventas y caja',
  'bitacora.grupo.inventario': 'Inventario',
  'bitacora.grupo.clientes': 'Clientes y ruta',
  'bitacora.grupo.dinero': 'Dinero y planilla',
  'bitacora.grupo.sistema': 'Sistema',
  'bitacora.sinMovimientos': 'No hay movimientos de ese tipo en este equipo.',
  'bitacora.desconocido': 'Desconocido',
  'bitacora.sinSincronizar': ' · sin sincronizar',
  'bitacora.explicacion':
    'La bitácora no es una función aparte: es el registro mismo del que sale todo lo demás. No se puede editar ni borrar, porque nada se guarda dos veces.',
  'bitacora.errorServidor':
    'No se pudo consultar al servidor ({error}). Abajo van solo los de este equipo.',
  'bitacora.sinRechazos': 'Ningún registro fue rechazado. Así debería ser siempre.',
  'bitacora.revisado': 'Revisado',
  'bitacora.explicacionRechazos':
    'Un registro rechazado nunca se borra. Marcarlo como revisado solo dice que alguien ya lo vio; lo que pasó sigue guardado.',

  // ---------- Precios rápidos ----------
  'precios.titulo': 'Precios/Costos',
  'precios.subtitulo': '{hechos} de {total} con todos sus precios',
  'precios.todosListos': 'Ya todos tienen precio en cada lista.',
  'precios.todosConCosto': 'Ya todos tienen costo.',
  'precios.nadaQueMostrar': 'No hay productos todavía.',
  'precios.soloFaltantes': 'Sin precio',
  'precios.soloSinCosto': 'Sin costo',
  'precios.todos': 'Todos',
  'precios.campo': '{lista} de {producto}',
  'precios.buscar': 'Buscar producto…',
  'precios.porUnidad': 'por {unidad}',
  'precios.costo': 'costo {monto}',
  'precios.sinCosto': 'sin costo todavía',
  'precios.guardado': 'Guardado',
  'precios.ponerCosto': 'Costo',
  'precios.ponerCostoDe': 'Corregir el costo de {producto}',
  'precios.sugerido': 'Sugerido {monto}',
  'precios.usarSugerido': 'Usar {monto}',
  'precios.margen': 'Margen',
  'precios.explicacion':
    'Escriba el precio y toque «Guardar» en su renglón. Lo que guarde se queda en la lista hasta que cambie de vista, por si hay que corregir algo. Si ya compró el producto, el sistema le sugiere un precio que le deja {margen}% de ganancia. Bajo cada precio va el margen que deja: en amarillo bajo el mínimo de {minimo}, en rojo si no gana nada.',
  'precios.explicacionSinCosto':
    'Escriba el precio y toque «Guardar» en su renglón. Lo que guarde se queda en la lista hasta que cambie de vista, por si hay que corregir algo.',
  'precios.seguir': 'Seguir',

  // ---------- Fotos de los productos ----------
  'fotos.titulo': 'Fotos',
  'fotos.subtitulo': '{hechos} de {total} con foto',
  'fotos.sinFoto': 'Sin foto',
  'fotos.todos': 'Todos',
  'fotos.buscar': 'Buscar por nombre o código…',
  'fotos.explicacion':
    'Toque «Tomar foto» en un producto: se abre la cámara, y la foto queda puesta en cuanto la acepta. «Galería» es para una foto que ya tenga, como la que mandó el proveedor, y «Buscar en internet» le muestra fotos de ese producto halladas en catálogos abiertos y en Wikipedia. El producto se queda en la lista hasta que cambie de vista, por si hay que tomarla otra vez.',
  'fotos.tomarDe': 'Tomar foto de {producto}',
  'fotos.cambiarDe': 'Cambiar foto de {producto}',
  'fotos.galeriaDe': 'Galería: una foto de {producto} que ya está en el teléfono',
  'fotos.internetDe': 'Buscar en internet una foto de {producto}',
  'fotos.guardada': 'Foto guardada',
  'fotos.todosConFoto': 'Ya todos tienen foto.',
  'fotos.ningunoSinFoto': 'Ningún producto sin foto coincide.',
  'fotos.ninguno': 'Ningún producto coincide.',
  'fotos.nadaQueMostrar': 'No hay productos todavía.',
  'fotos.seguir': 'Seguir',
  'sugeridas.titulo': 'Fotos de internet',
  'sugeridas.explicacion': 'Fotos de «{producto}» que se encontraron en catálogos abiertos de productos y en Wikipedia. Elija la que sea su producto, en su presentación.',
  'sugeridas.buscando': 'Buscando fotos…',
  'sugeridas.sinConexion': 'Para buscar fotos en internet hace falta conexión con el servidor.',
  'sugeridas.error': 'No se pudo buscar. Intente otra vez.',
  'sugeridas.ninguna': 'No se encontró ninguna foto de este producto. Tómele una con «Tomar foto».',
  'sugeridas.ocupado': 'Se buscó mucho seguido. Intente otra vez en un minuto.',
  'sugeridas.ocupadoAlgo': 'No se pudo buscar en todos lados: en un minuto, «Buscar otra vez» puede encontrar más.',
  'sugeridas.noLlegaron': 'Se encontraron fotos, pero no se pudieron traer. Intente otra vez.',
  'sugeridas.otraVez': 'Buscar otra vez',
  'sugeridas.porSuCodigo': 'Por su código',
  'sugeridas.elegir': 'Elegir la foto de {fuente}: {titulo}',
  'sugeridas.de': 'De {fuente}',
  'sugeridas.verPagina': 'Ver su página',
  'sugeridas.usar': 'Usar esta foto',

  // ---------- Paquetes que piden las ventas ----------
  'paquetes.titulo': 'Paquetes',
  'paquetes.subtitulo': 'De las ventas de los últimos {dias} días',
  'paquetes.sugeridos': 'Sin paquete',
  'paquetes.todos': 'Todos',
  'paquetes.buscar': 'Buscar por nombre o código…',
  'paquetes.explicacion':
    'Lo que se vende una y otra vez en una misma cantidad grande, como 12 bolsitas juntas, se cobra más rápido en un paquete: en la caja se toca «Paquete (12)» en vez de contar 12. Aquí está cada producto que se vendió así en los últimos {dias} días: la misma cantidad en {veces} ventas o más, en días distintos, y mucho más que las cantidades de al lado. Toque «Agregar»: el paquete ya viene con su nombre, lo que trae y su precio, que empieza en lo que trae × el de la unidad, y se cambia lo que haga falta antes de agregarlo. «No» lo quita de la lista en este equipo.',
  'paquetes.porque': '{cantidad} de una vez en {veces} de sus {de} ventas, en {dias} días distintos',
  'paquetes.porqueTodas': '{cantidad} de una vez en todas sus {de} ventas, en {dias} días distintos',
  'paquetes.agregar': 'Agregar {paquete}',
  'paquetes.agregarDe': 'Agregar {paquete} a {producto}',
  'paquetes.agregado': 'Se agregó {paquete}',
  'paquetes.yaNo': 'Ya no se sugiere {paquete} en este equipo.',
  'paquetes.deshacer': 'Deshacer',
  'paquetes.noDe': 'No sugerir {paquete} de {producto}',
  'paquetes.noExplicado': 'No es un paquete: no sugerirlo más en este equipo',
  'paquetes.nuevo': 'Nuevo paquete',
  'paquetes.nuevoDe': 'Nuevo paquete de {producto}',
  'paquetes.ningunoSugerido': 'Ningún producto sin paquete coincide.',
  'paquetes.ninguno': 'Ningún producto coincide.',
  'paquetes.nadaQueSugerir': 'Nada que sugerir: ningún producto se ha vendido una y otra vez en una cantidad grande de la que no tenga paquete.',
  'paquetes.nadaQueMostrar': 'No hay productos todavía.',
  'paquetes.seguir': 'Seguir',
  'paquetes.hoja.cantidadMal': 'Escriba cuánto trae, en número.',
  'paquetes.hoja.yaTiene': 'Ya tiene {paquete}.',
  'pos.enOferta': 'Oferta',
  'pos.llevaGratis': '{nombre} · {n} gratis',
  'pos.llevaFalta': '{nombre} · lleve {n}',
  'pos.ofertaTermino': 'La oferta de {producto} terminó: va a su precio de lista. Revise el total y cobre otra vez.',
  'ofertas.titulo': 'Ofertas',
  'ofertas.subtitulo': 'Qué poner en oferta, cuánto quitarle y hasta cuándo',
  'ofertas.explicacion':
    'Se sugiere lo que se vence antes de venderse a su ritmo, y lo que se mueve poco: más de ocho semanas de lo que hay, o nada vendido en {dias} días. Cuanto más cerca la fecha, o más parado, más se le quita, sin bajar de lo que cuesta salvo lo que se vence. Una oferta va en la lista de la tienda: la caja la cobra sola entre sus fechas, y lo vendido en oferta no cuenta en «Por comprar».',
  'ofertas.enOferta': 'En oferta ({n})',
  'ofertas.empieza': 'Del {desde} al {hasta}: todavía no empieza',
  'ofertas.terminaHoy': 'Termina hoy',
  'ofertas.hasta': 'Hasta el {hasta} · quedan {n} días',
  'ofertas.motivo.vence': 'Se vence',
  'ofertas.motivo.lento': 'Se mueve poco',
  'ofertas.motivo.otro': 'Puesta a mano',
  'ofertas.terminar': 'Terminar',
  'ofertas.terminarDe': 'Terminar la oferta de {producto}',
  'ofertas.terminarTitulo': '¿Terminar la oferta?',
  'ofertas.terminarMensaje': '{producto} vuelve hoy a su precio de lista, en todas las cajas.',
  'ofertas.terminarProgramada': 'La oferta de {producto} ya no va a empezar.',
  'ofertas.noSePudo': 'No se pudo terminar la oferta.',
  'ofertas.buscar': 'Buscar por nombre o código…',
  'ofertas.sugeridas': 'Sugeridas',
  'ofertas.todos': 'Todos',
  'ofertas.ningunoCoincide': 'Ningún producto coincide.',
  'ofertas.nadaQueSugerir': 'Nada que sugerir: nada se vence antes de venderse y nada lleva más de ocho semanas en el estante.',
  'ofertas.nadaQueMostrar': 'No hay productos todavía.',
  'ofertas.porqueVence': '{cantidad} se vencen el {fecha} sin venderse a su ritmo, en {dias} días',
  'ofertas.porqueVenceManana': '{cantidad} se vencen mañana sin venderse a su ritmo',
  'ofertas.porqueVenceHoy': '{cantidad} se vencen hoy sin venderse',
  'ofertas.porqueLento': 'Hay {cantidad}: {semanas} semanas a su ritmo',
  'ofertas.porqueParado': 'Hay {cantidad} y no se vendió nada en {dias} días',
  'ofertas.seVencen': '{monto} que se perderían',
  'ofertas.parados': '{monto} parados',
  'ofertas.sugerido': 'Sugerido',
  'ofertas.duracion': '{n} días, hasta el {hasta}',
  'ofertas.duracionHoy': 'Solo hoy',
  'ofertas.tabla.antes': 'Antes',
  'ofertas.tabla.enOferta': 'En oferta',
  'ofertas.tabla.precio': 'Precio',
  'ofertas.tabla.precioDe': 'Precio de {n}',
  'ofertas.tabla.margen': 'Margen',
  'ofertas.tabla.ganancia': 'Ganancia',
  'ofertas.cambio.sinEfecto': 'No baja del precio de lista, {monto}: la caja cobra ese.',
  'ofertas.bajoCostoAviso': 'Bajo el costo: aun así, mejor que botarlo vencido.',
  'ofertas.sinPrecio': 'Sin precio en la lista de la tienda',
  'ofertas.yaEnOferta': 'En oferta hasta el {hasta}',
  'ofertas.puesta': 'Puesta en oferta',
  'ofertas.yaNo': 'No se sugiere en este equipo por {dias} días.',
  'ofertas.deshacer': 'Deshacer',
  'ofertas.poner': 'Poner en oferta',
  'ofertas.ponerDe': 'Poner {producto} en oferta',
  'ofertas.noDe': 'No sugerir {producto}',
  'ofertas.noExplicado': 'No ponerlo en oferta: no sugerirlo en este equipo por {dias} días',
  'ofertas.hoja.titulo': 'Oferta de {producto}',
  'ofertas.hoja.tipo': 'Qué clase de oferta',
  'ofertas.hoja.tipoPrecio': 'Bajar el precio',
  'ofertas.hoja.tipoLleva': 'Lleva y paga',
  'ofertas.hoja.llevaCual': 'Cuántos lleva y cuántos paga',
  'ofertas.hoja.lleva': 'Lleva',
  'ofertas.hoja.paga': 'Paga',
  'ofertas.hoja.llevaMal': 'Se llevan de 2 a 50, y se paga al menos uno menos de lo que se lleva.',
  'ofertas.hoja.llevaPierde': '{presentacion}: cada {n} que se llevan pierden {pierde}.',
  'ofertas.hoja.descuento': 'Cuánto quitarle a todas',
  'ofertas.hoja.sinPrecio': 'No tiene precio en la lista de la tienda: póngale uno en «Precios/Costos» primero.',
  'ofertas.hoja.precioDe': 'Precio en oferta de {presentacion}',
  'ofertas.hoja.sinOferta': 'Sin oferta',
  'ofertas.hoja.ahorra': 'El cliente ahorra {monto}',
  'ofertas.hoja.sugeridoEra': 'Sugerido: {monto}',
  'ofertas.hoja.noBaja': 'La oferta tiene que ser menos que el precio de lista.',
  'ofertas.hoja.cuesta': 'Cuesta {monto}',
  'ofertas.hoja.bajoMinimo': 'Bajo el mínimo de {minimo}',
  'ofertas.hoja.sinCosto': 'Sin costo todavía: no se sabe qué margen deja.',
  'ofertas.hoja.bajoCosto': '{presentacion}: bajo lo que cuesta, cada una vendida pierde {pierde}.',
  'ofertas.hoja.mejorQueBotar': 'Aun así, lo que se vence el {fecha} sin venderse se pierde entero: {monto}.',
  'ofertas.hoja.desde': 'Desde',
  'ofertas.hoja.hasta': 'Hasta',
  'ofertas.hoja.dias': '{n} días en oferta, el primero y el último incluidos.',
  'ofertas.hoja.unDia': 'Un solo día en oferta.',
  'ofertas.hoja.desdeHoy': 'Empieza hoy o después.',
  'ofertas.hoja.alReves': 'Termina antes de empezar.',
  'ofertas.hoja.muyLarga': 'Una oferta dura {n} días a lo más.',
  'ofertas.hoja.nota': 'Nota (opcional)',
  'ofertas.hoja.noSePudo': 'No se pudo poner en oferta.',
  'ofertas.resultados': 'Resultados',
  'ofertas.resultadosExplica':
    'Cómo les fue a las ofertas de los últimos {dias} días: el ritmo de su producto en su lista mientras corrieron, contra las cuatro semanas de antes; lo vendido en oferta, lo que ingresó y lo que se descontó; y lo que queda.',
  'ofertas.sinResultados': 'Ninguna oferta ha corrido en los últimos {dias} días.',
  'ofertas.corre': 'Corre',
  'ofertas.termino': 'Terminó',
  'ofertas.r.vendidas': 'Vendidas en oferta',
  'ofertas.r.ritmo': 'Por semana',
  'ofertas.r.ritmoValor': '{durante}, antes {antes}',
  'ofertas.r.ritmoNuevo': '{durante}, antes nada',
  'ofertas.r.ingreso': 'Ingresó',
  'ofertas.r.descuento': 'Se descontó',
  'ofertas.r.ganancia': 'Ganancia',
  'ofertas.r.quedan': 'Quedan hoy',
  'ofertas.r.lote': 'De lo que vencía hasta el {fecha}: quedan {quedan}',
  'ofertas.r.loteCorre': 'De lo que vence hasta el {fecha}: quedan {quedan}',
  'ofertas.r.botadas': 'botadas por vencidas: {n}',
  'ofertas.r.despues': 'Después: {n} por semana',
  'ofertas.van': 'Vendidas: {n} en {dias} días · {semana} por semana, antes {antes}',
  'ofertas.vanNuevo': 'Vendidas: {n} en {dias} días · {semana} por semana, antes nada',
  'ofertas.vanHoy': 'Vendidas hoy: {n}',
  'ofertas.whatsapp': 'Mandar por WhatsApp',
  'ofertas.whatsappExplica': 'Las ofertas que corren y las que vienen, para mandarlas a los clientes',
  'ofertas.personal': 'PDF para el personal',
  'ofertas.personalExplica': 'Las ofertas que corren hoy, como las cobra la caja, en una página para imprimir y dársela al personal: en español y sin costos',
  'ofertas.personalArchivo': 'ofertas-vigentes_{fecha}.pdf',
  'paquetes.hoja.masQue': 'Un paquete trae más que {paquete}.',
  'paquetes.hoja.precio': 'Precio {lista} del paquete',
  'paquetes.hoja.desde': 'Empieza en {n} × el precio de {paquete}',
  'paquetes.hoja.costo': 'Cuesta {monto}',
  'paquetes.hoja.sinPrecio':
    'Se agrega sin precio: quien pone los precios se lo pone en la página del producto, y hasta entonces la caja no lo ofrece.',
  'paquetes.hoja.noSePudo': 'No se pudo agregar el paquete.',

  // ---------- Arranque ----------
  'arranque.paso': 'Paso {n} de {total}',
  'arranque.saltar': 'Saltar por ahora',
  'arranque.pendiente': 'Falta terminar de configurar el negocio',
  'arranque.continuar': 'Continuar',

  'arranque.nombre.titulo': '¿Cómo se llama el negocio?',
  'arranque.nombre.porque': 'Así aparece arriba en la pantalla y en cada recibo que entregue.',
  'arranque.nombre.ejemplo': 'Pulpería La Esperanza',
  'arranque.nombre.accion': 'Guardar el nombre',

  'arranque.productos.titulo': 'Todavía no hay nada que vender',
  'arranque.productos.porque':
    'Puede empezar con una lista de lo que vende casi cualquier pulpería y quitarle lo que no le sirva. Es más rápido que escribirlos uno por uno.',
  'arranque.productos.accion': 'Empezar con la lista básica',
  'arranque.productos.alterna': 'Prefiero escribirlos yo',

  'arranque.precios.titulo': 'Falta ponerles precio',
  'arranque.precios.porque':
    'Sin precio no se puede vender. Faltan {n} — se hace en una sola pantalla, escribiendo el precio al lado de cada uno.',
  'arranque.precios.accion': 'Ponerles precio',

  'arranque.esperando.titulo': 'El negocio todavía no está listo',
  'arranque.esperando.porque':
    'Falta terminar de configurarlo, y eso lo hace el dueño. Avísele y vuelva a entrar.',

  // ---------- Pantalla de inicio ----------
  'inicio.liquidarRuta': 'Liquidar la ruta',
  'inicio.mercaderiaComprada': 'Mercadería comprada',
  'inicio.gastos': 'Gastos',
  'inicio.pedidosDeHoy': 'Pedidos de hoy',
  'inicio.atajos': 'Atajos',
  // Lo que dice cada atajo al pasarle el mouse (`ui/Globo.tsx`).
  'inicio.ayudaCompra': 'Anote lo que le compró a un proveedor: qué llegó, cuánto costó y cómo se pagó. Suma al inventario.',
  'inicio.ayudaGasto': 'Anote algo que se pagó y no es mercadería para vender: alquiler, luz, transporte, una reparación.',
  'inicio.ayudaProductos': 'Todo lo que vende, con sus precios, presentaciones y códigos. Ahí mismo se agrega uno nuevo.',
  'inicio.ayudaClientes': 'Quién le debe y cuánto: el fiado de cada cliente, sus abonos y su estado de cuenta.',
  'inicio.ayudaPedidos': 'Tomar el pedido de un cliente para entregárselo otro día, y ver los que faltan por entregar.',
  'inicio.ayudaPedidosDeHoy': 'Los pedidos que faltan por entregar, por fecha de entrega.',
  'inicio.ayudaInventario': 'Cuánto hay de cada producto y dónde. Para contarlo, trasladarlo, reempacarlo o sacar lo dañado.',
  'inicio.ayudaFiado': 'Todo lo que deben los clientes: cuánto, quién y desde cuándo.',
  'inicio.ayudaContabilidad': '¿Cuánto ganó? Ventas, costos, gastos y ganancia de cada período y el balance; y en su pestaña, la planilla.',
  'inicio.historialVentas': 'Historial de ventas',
  'inicio.ayudaHistorialVentas': 'Todas las ventas: un ticket, un cliente o un producto, por fechas, forma de pago o quién cobró.',
  'inicio.ayudaReponer': 'Lo que se está acabando y cuánto comprar de cada cosa, por categoría o por proveedor, con lo que costó la última vez.',
  'inicio.ayudaControl': 'Lo que cada quien hizo con la plata: ventas anuladas, devoluciones, precios bajados y faltantes de caja, persona por persona.',
  'inicio.ayudaBitacora': 'Todo lo que se anotó, en orden: quién hizo qué, cuándo y en qué equipo. Se busca por lo que se hizo, quién, el día o un ticket.',
  'inicio.contabilidadPlanilla': 'Contabilidad/Planilla',
  'inicio.ayudaCerrarCaja': 'Al final de su turno, paso a paso: contar la gaveta, dejar el vuelto y entregar lo demás. Si se cierra la tienda, también se repasa el día.',
  'inicio.mas': 'Todo lo demás',
  'inicio.cajaCerrada': 'La caja está cerrada — empiece el día para poder vender',
  'inicio.enRuta': 'Sigue abierta una ruta de antes ({camion}, desde el {fecha}): liquídela para cerrar esta caja.',
  'inicio.faltaProveedor': 'Todavía no hay proveedores. Se necesita uno para registrar una compra.',

  // ---------- Menú ----------
  'menu.titulo': 'Todo lo demás',
  'seccion.pestanas': 'Pantallas de esta sección',
  'seccion.precios': 'Precios/Costos',
  'seccion.gastos': 'Gastos',

  // ---------- Datos de prueba (solo en desarrollo) ----------
  'prueba.cargar': 'Llenar con datos de prueba',
  'prueba.explicacion':
    'Crea un negocio completo de una vez — productos con precio, existencia comprada, clientes, ventas, un pedido, gastos y personal — para probar el sistema sin configurar nada. Solo aparece en desarrollo.',
  'prueba.creando': 'Creando… {paso}',
  'prueba.fallo': 'No se pudo: {error}',
  'prueba.borrar': 'Empezar de cero',
  'prueba.confirmarBorrar': 'Se borra todo: el servidor y este dispositivo.',
  'prueba.borrarAviso': '¿Y después, con qué quiere empezar?',
  'prueba.conDatos': 'Con datos de prueba',
  'prueba.vacio': 'Vacío',
  'prueba.yaHay': 'Ya hay datos. No se creó nada nuevo.',

  // ---------- Ajustes ----------
  'ajustes.cambiarNombre': 'Cambiar',
  'inicio.sinPrecio': '{n} producto(s) sin precio — no se pueden vender',
  'ajustes.titulo': 'Ajustes',
  'ajustes.idioma': 'Idioma',
  'ajustes.esteDispositivo': 'Este dispositivo',
  'ajustes.codigo': 'Código',
  'ajustes.ultimoRecibido': 'Último registro recibido',
  'ajustes.proximoLocal': 'Próximo número local',
  'ajustes.configuracion': 'Configuración',
  'ajustes.negocio': 'Negocio',
  'ajustes.tasaTienda': 'Tasa de la tienda',
  'ajustes.tasaOficial': 'Tasa oficial BCN',
  'ajustes.margenMinimo': 'Margen mínimo',
  'ajustes.iva': 'IVA',
  'ajustes.ivaActivo': 'Activo',
  'ajustes.ivaInactivo': 'Inactivo (sin registro DGI)',
  'ajustes.camiones': 'Camiones',
  'ajustes.usuarios': 'Usuarios',
  'ajustes.bitacora': 'Bitácora',
  'ajustes.bitacoraTodo': 'Todo lo que ha pasado',
  'ajustes.ultimaSync': 'Última sincronización',
  'ajustes.nunca': 'Nunca',
  'ajustes.desfaseReloj': 'Desfase de reloj',
  'ajustes.datos': 'Datos en este equipo',
  'ajustes.conservados': 'El navegador los conserva',
  'ajustes.ayudaConservar':
    'Si le falta espacio, el navegador podría borrarlos, con lo que no se haya enviado. Agregue la app a la pantalla de inicio y pídalo de nuevo.',
  'ajustes.pedirConservar': 'Pedir que los conserve',
  'ajustes.explicacionCodigo':
    'El código del dispositivo es el prefijo de cada número de ticket. Por eso dos dispositivos nunca pueden emitir el mismo recibo, aunque estén sin conexión.',
  'ajustes.rechazados': '{n} rechazado(s)',
  'ajustes.salir': 'Cerrar sesión',

  // ---------- Fiado ----------
  'pago.fiado': 'Fiado',
  'fiado.sinCliente': 'Para fiar, primero escoja a quién.',
  'fiado.escogerCliente': 'Escoger el cliente',
  'fiado.debe': 'Debe {monto}',
  'fiado.aFavor': 'A favor {monto}',
  'fiado.quedaria': 'Con esta venta debería',
  'fiado.limite': 'Límite de fiado',
  'fiado.sinFiado': 'Sin fiado',
  'fiado.noTieneFiado': '{nombre} no tiene fiado.',
  'fiado.pasaLimite': 'Se pasa del límite por {monto}.',
  'fiado.ustedAutoriza': 'Usted lo autoriza como dueño.',
  'fiado.pideDueno': 'Necesita el PIN del dueño.',
  'fiado.pinYConfirmar': 'PIN del dueño y confirmar',
  'fiado.motivoPin': 'Fiarle {monto} a {nombre}, pasando su límite.',
  'comun.imprimir': 'Imprimir',
  'comun.listo': 'Listo',
  'clientes.activosYFiado': '{n} activo(s) · le deben {monto}',
  'clientes.todos': 'Todos',
  'clientes.deben': 'Deben ({n})',
  'clientes.ayudaLimite': 'Lo más que puede deber. Vacío: se le fía solo si el dueño lo aprueba.',
  'clientes.limiteInvalido': 'Escriba un monto, o déjelo vacío.',
  'clientes.saldoAnterior': 'Saldo anterior',
  'clientes.ayudaSaldoAnterior':
    'Lo que ya debía antes de usar la app, como dice el cuaderno. Corregirlo después cambia solo la diferencia.',
  'clientes.saldoAnteriorInvalido': 'Escriba un monto, o déjelo vacío.',

  // ---------- La cuenta de un cliente ----------
  'cuenta.noExiste': 'Ese cliente no existe.',
  'cuenta.editar': 'Editar',
  'cuenta.debe': 'Debe',
  'cuenta.noDebe': 'No debe nada',
  'cuenta.aFavor': 'Saldo a favor',
  'cuenta.limite': 'Límite de fiado: {monto}',
  'cuenta.sinFiado': 'No tiene fiado',
  'cuenta.debeDesde': 'Debe desde el {fecha}, hace {n} día(s)',
  'cuenta.debeDesdeHoy': 'Debe desde hoy',
  'cuenta.recordar': 'Recordarle por WhatsApp',
  'cuenta.estado': 'Estado de cuenta',
  'cuenta.movimientos': 'Movimientos',
  'cuenta.sinMovimientos': 'Todavía no se le ha fiado nada.',
  'cuenta.verAnteriores': 'Ver anteriores ({n} más)',
  'cuenta.fiado': 'Fiado · {ticket}',
  'cuenta.devolucion': 'Devolución · {ticket}',
  'cuenta.saldoAnterior': 'Saldo anterior',
  'cuenta.porConfirmar': 'por confirmar',
  'cuenta.abono': 'Abono · {forma}',
  'cuenta.perdido': 'Dado por perdido',
  'cuenta.deshacer': 'Deshacer',
  'cuenta.darPorPerdido': 'No va a pagar: darlo por perdido',
  'perdido.titulo': 'Dar por perdido',
  'perdido.explicacion':
    '{nombre} debe {monto}. Lo que se dé por perdido sale de lo que debe y se apunta como un gasto, «Fiado incobrable»: lo que el fiado le costó a la tienda. La venta sigue siendo venta. Si vuelve y paga, se deshace.',
  'perdido.monto': '¿Cuánto?',
  'perdido.quedaria': 'Seguiría debiendo {monto}',
  'perdido.masDeLoQueDebe': 'Debe {monto}: no más que eso',
  'perdido.motivo': '¿Por qué?',
  'perdido.motivoEjemplo': 'Se fue del barrio, falleció, no va a pagar',
  'perdido.limite': 'Su límite de fiado sigue en {monto}: cámbielo en su ficha si ya no le va a fiar.',
  'perdido.confirmar': 'Dar por perdido',
  'perdido.deshacerTitulo': 'Deshacer lo dado por perdido',
  'perdido.deshacerExplicacion':
    'Vuelve a deber los {monto} que se dieron por perdidos el {fecha}. Si vino a pagar, apunte el abono después.',
  'perdido.deshacerParte':
    'Vuelve a deber {monto} de los {total} que se dieron por perdidos el {fecha}: lo demás ya volvió, con un abono, una anulación o una devolución.',
  'perdido.deshacerEjemplo': 'Volvió y pagó, o fue un error',
  'cuenta.queda': 'Queda {monto}',

  // ---------- Abonos ----------
  'abono.titulo': 'Abono de {nombre}',
  'abono.monto': 'Cuánto abona',
  'abono.forma': 'Cómo paga',
  'abono.quedaria': 'Quedaría debiendo {monto}',
  'abono.quedaAFavor': 'Le quedarían {monto} a favor',
  'abono.aLaGaveta': 'Entra a la gaveta de la caja abierta: el corte lo va a esperar.',
  'abono.sinCaja': 'Para recibir efectivo, abra la caja en este equipo: el abono entra a la gaveta y el corte lo espera.',
  'abono.anularDeCaja':
    'Ese abono entró a un turno ya cerrado: los {monto} salen de la caja abierta de este equipo, para devolvérselos al cliente.',
  'abono.anularSinCaja':
    'Ese abono entró a un turno ya cerrado. Para devolver los {monto}, primero abra la caja en este equipo.',
  'abono.porConfirmar': 'Espera en «Transferencias sin confirmar» hasta que alguien vea el dinero; si no llega, lo vuelve a deber.',
  'abono.alBanco': 'Va a la cuenta del banco.',
  'abono.aLaBilletera': 'Va a la billetera móvil.',
  'abono.registrar': 'Registrar abono',
  'abono.listo': 'Abono registrado',
  'abono.enviar': 'Enviar comprobante por WhatsApp',
  'abono.anular': 'Anular abono',
  'abono.anularExplicacion': 'El abono de {monto} del {fecha} se quita, y lo que debe vuelve a subir.',
  'abono.pinParaAnular': 'Anular el abono de {monto} de {cliente}. Queda a nombre de {nombre}.',
  'caja.abonos': 'Abonos de clientes en efectivo',
  'caja.devoluciones': 'Devoluciones pagadas en efectivo',
  'caja.pagadoDeGaveta': 'Compras, gastos y proveedores pagados de la gaveta',
  'caja.fiado': 'Fiado del turno (no está en la gaveta)',

  // Devoluciones de clientes
  'ventas.fiado': 'fiado',
  'ventas.conDevolucion': 'con devolución',
  'ventas.devueltas': 'devuelto {n}',
  'ventas.devuelto': 'Devuelto',
  'devolucion.devolver': 'Devolver productos',
  'devolucion.devolverMonto': 'Devolver {monto}',
  'devolucion.titulo': 'Devolver {ticket}',
  'devolucion.explicacion': 'Escriba cuánto regresa de cada producto. Lo que se devuelve es lo que se cobró, con su parte del descuento.',
  'devolucion.vendido': 'Vendido: {n}',
  'devolucion.yaDevuelto': 'ya devuelto: {n}',
  'devolucion.cuanto': 'Cuánto regresa',
  'devolucion.todo': 'Todo',
  'devolucion.masDeLoQueQueda': 'Solo quedan {n} por devolver.',
  'devolucion.como': 'Cómo se le devuelve el dinero',
  'devolucion.aSuCuenta': 'Rebajar de su cuenta',
  'devolucion.deLaGaveta': 'Sale de la gaveta de la caja abierta: el corte lo va a descontar.',
  'devolucion.deSuCuenta': 'Se le rebaja de lo que debe {nombre}. Si no debe nada, le queda a favor.',
  'devolucion.delBanco': 'Sale de la cuenta del banco.',
  'devolucion.deLaBilletera': 'Sale de la billetera móvil.',
  'devolucion.sinCaja': 'Para devolver en efectivo, abra la caja en este equipo.',
  'devolucion.pin': 'Devolver {monto} de la venta {ticket}. Queda a nombre de {nombre}.',
  'devolucion.hastaEnDinero': 'En dinero se devuelve a lo más {monto}, lo que esta venta recibió en dinero. Devuelva eso, y lo demás a su cuenta.',
  'devolucion.sinDinero': 'Esta venta no recibió dinero que devolver: su transferencia todavía no se confirma.',
  'devolucion.esperaLaTransferencia':
    'Lo que se pagó con la transferencia todavía no se confirma: vuelve a su cuenta cuando se vea en el banco, o cuando se anote que no llegó.',
  'devolucion.contraLaPerdida': '{monto} se pagaron con una transferencia que no llegó: no pasan a su cuenta, vuelven contra esa pérdida.',
  'devolucion.conElRedondeo': 'Se devuelven {monto}, lo que se cobró: los {redondeo} del redondeo no se cobraron.',
  'devolucion.noSePudo': 'No se pudo registrar la devolución.',
  'abono.noSePudo': 'No se pudo registrar el abono.',

  // Devoluciones a proveedores
  'devolucionCompra.devolver': 'Devolver al proveedor',
  'devolucionCompra.devuelto': 'Devuelto al proveedor: {monto}',
  'devolucionCompra.titulo': 'Devolver a {proveedor}',
  'devolucionCompra.explicacion': 'Compra del {fecha}. Cada producto vale lo que costó en esta compra, con su parte del flete.',
  'devolucionCompra.recibido': 'Recibido: {n} {unidad}',
  'devolucionCompra.masQueExistencia': 'Aquí solo hay {n} en existencia. Revise el conteo.',
  'devolucionCompra.como': 'Cómo lo repone el proveedor',
  'devolucionCompra.descontar': 'Rebajar de lo que se debe',
  'devolucionCompra.deLaCuenta': 'Se rebaja de lo que se le debe por esta compra ({monto}).',
  'devolucionCompra.pasaDeLoQueSeDebe': 'De esta compra solo se deben {monto}. Rebaje menos, o pida el dinero.',
  'devolucionCompra.alEfectivo': 'El proveedor devuelve el efectivo: va al efectivo general, fuera de la gaveta.',
  'devolucionCompra.alBanco': 'El proveedor lo devuelve a la cuenta del banco.',
  'devolucionCompra.aLaBilletera': 'El proveedor lo devuelve a la billetera móvil.',

  // Mínimo en existencia
  'detalle.minimo': 'Mínimo en existencia ({unidad})',
  'detalle.minimoEs': 'Mínimo en existencia: {n} {unidad}',
  'detalle.minimoAutomatico': 'Según lo que se vende',
  'detalle.minimoInvalido': 'Escriba una cantidad, o déjelo vacío.',
  'detalle.ayudaMinimo': 'Cuando quede esto o menos, sale en «Por comprar». Vacío: se calcula por lo que se vende.',

  // Editar producto
  'editarProducto.boton': 'Editar producto',
  'editarProducto.titulo': 'Editar producto',
  'editarProducto.guardar': 'Guardar cambios',
  'editarProducto.faltaNombre': 'Escriba el nombre del producto.',
  'editarProducto.yaExiste': 'Ya hay un producto llamado «{nombre}».',
  'editarProducto.ayudaUnidad': 'En qué se cuenta la existencia.',
  'editarProducto.soloElNombre':
    'Solo cambia el nombre, no se convierte nada: los {cantidad} {antes} en existencia pasan a ser {cantidad} {despues}.',

  // Por comprar
  'reponer.titulo': 'Por comprar',
  'reponer.subtitulo': '{n} producto(s)',
  'reponer.subtituloUrgentes': '{n} producto(s) · {urgentes} no pueden esperar',
  'reponer.unaSemana': '1 semana',
  'reponer.semanas': '{n} semanas',
  'reponer.porProveedor': 'Por proveedor',
  'reponer.porCategoria': 'Por categoría',
  'reponer.explicacion': 'Lo que no alcanza para {n} semana(s) al ritmo de las últimas cuatro, y lo que está en su mínimo, con cuánto comprar. Toque uno para ver sus últimas compras.',
  'reponer.nada': 'Nada se está acabando.',
  'reponer.agotados': 'Agotados',
  'reponer.pronto': 'Se acaban en {n} días',
  'reponer.alUltimoCosto': 'Al último costo',
  'reponer.sinCosto': 'Sin contar {n} que nunca se han comprado en esta app: no tienen costo todavía.',
  'reponer.seReempacan': 'Se reempacan aquí',
  'reponer.sinProveedor': 'Sin proveedor todavía',
  'reponer.sinProveedorAyuda': 'Nunca se han comprado en esta app. Cuando reciba la primera compra, quedan con ese proveedor.',
  'reponer.nProductos': '{n} producto(s)',
  'reponer.nUrgentes': '{n} urgente(s)',
  'reponer.unos': 'unos {monto}',
  'reponer.ultimaCompra': 'última compra {fecha}',
  'reponer.estimado': 'Unos {monto} al último costo',
  'reponer.de': 'De: {producto}',
  'reponer.reempacar': 'Reempacar',
  'reponer.agotado': 'Agotado',
  'reponer.hay': 'Hay {n}',
  'reponer.alDia': '{n} al día',
  'reponer.aLaSemana': '{n} a la semana',
  'reponer.alcanza': 'alcanza {n} día(s)',
  'reponer.seAcabaHoy': 'se acaba hoy',
  'reponer.minimo': 'mínimo {n}',
  'reponer.comprarPara': 'Comprar para {n} semana(s)',
  'reponer.hayAhora': 'Hay ahora',
  'reponer.seVende': 'Se vende',
  'reponer.sinVentas': 'Sin ventas en cuatro semanas',
  'reponer.desdeQueLlego': 'desde el {fecha}',
  'reponer.alcanzaPara': 'Alcanza',
  'reponer.menosDeUnDia': 'Menos de un día',
  'reponer.nDias': '{n} día(s)',
  'reponer.minimoEtiqueta': 'Mínimo',
  'reponer.ultimaVenta': 'Última venta',
  'reponer.ningunaVenta': 'Ninguna en cuatro semanas',
  'reponer.comoLaUltima': 'Sin ventas con qué medir: lo mismo que la última compra.',
  'reponer.ultimasCompras': 'Las últimas compras',
  'reponer.nuncaComprado': 'Nunca se ha comprado en esta app.',
  'reponer.cadaUno': '{monto} c/u',
  'reponer.verProveedor': 'Ver {proveedor}',
  'reponer.colProducto': 'Producto',
  'reponer.colSituacion': 'Hay · alcanza · se vende',
  'reponer.colSituacionProveedor': 'Hay · alcanza · se vende · proveedor',
  'reponer.colUltimaCompra': 'Última compra',
  'reponer.colCantidadCosto': 'Cantidad · costo',
  'reponer.colComprar': 'Comprar',
  'reponer.colCosto': 'Costo aprox.',
  'inicio.seEstanAcabando': '{n} producto(s) se están acabando',

  // Descargar datos
  'comun.si': 'Sí',
  'comun.no': 'No',
  'exportar.titulo': 'Descargar datos',
  'exportar.corto': 'Descargar',
  'exportar.explicacion': 'Archivos que abre Excel o cualquier hoja de cálculo. Los que tienen fecha salen del período escogido; los demás, como están hoy.',
  'exportar.compartirTitulo': 'Datos de {negocio}',
  'exportar.compartirTodo': 'Mandar todo',
  'exportar.descargarTodo': 'Descargar todo',
  'exportar.descargar': 'Descargar',
  'exportar.compartir': 'Mandar',
  'exportar.preparando': 'Preparando…',
  'exportar.error': 'No se pudo preparar el archivo. Intente otra vez.',
  'exportar.comoEstaHoy': 'Como está hoy.',
  'exportar.ventas': 'Ventas',
  'exportar.ventasDesc': 'Una fila por venta: total, cómo se pagó, costo y utilidad.',
  'exportar.detalle': 'Ventas por producto',
  'exportar.detalleDesc': 'Una fila por producto vendido, para sumar por producto.',
  'exportar.inventario': 'Inventario valorizado',
  'exportar.inventarioDesc': 'Cuánto hay de cada producto en cada lugar, y cuánto vale al costo.',
  'exportar.precios': 'Productos y precios',
  'exportar.preciosDesc': 'Cada presentación con su precio en cada lista.',
  'exportar.clientes': 'Clientes y fiado',
  'exportar.clientesDesc': 'Los clientes, su límite y lo que deben.',
  'exportar.abonos': 'Abonos',
  'exportar.abonosDesc': 'Lo que los clientes pagaron de su fiado.',
  'exportar.compras': 'Compras',
  'exportar.comprasDesc': 'Lo que se compró, lo pagado, lo devuelto y lo que se debe.',
  'exportar.gastos': 'Gastos',
  'exportar.gastosDesc': 'Los gastos del negocio, por categoría.',
  'exportar.diario': 'Libro diario',
  'exportar.diarioDesc': 'Cada asiento con sus cuentas, debe y haber: lo que pide el contador.',
  'exportar.col.fecha': 'Fecha',
  'exportar.col.ticket': 'Ticket',
  'exportar.col.cliente': 'Cliente',
  'exportar.col.total': 'Total',
  'exportar.col.iva': 'IVA',
  'exportar.col.descuento': 'Descuento',
  'exportar.col.envio': 'Envío',
  'exportar.col.devuelto': 'Devuelto',
  'exportar.col.costo': 'Costo',
  'exportar.col.utilidad': 'Utilidad',
  'exportar.col.anulada': 'Anulada',
  'exportar.col.anulado': 'Anulado',
  'exportar.col.producto': 'Producto',
  'exportar.col.cantidad': 'Cantidad',
  'exportar.col.precio': 'Precio',
  'exportar.col.subtotal': 'Subtotal',
  'exportar.col.categoria': 'Categoría',
  'exportar.col.lugar': 'Lugar',
  'exportar.col.unidad': 'Unidad',
  'exportar.col.costoUnitario': 'Costo por unidad',
  'exportar.col.valor': 'Valor',
  'exportar.col.minimo': 'Mínimo',
  'exportar.col.activo': 'Activo',
  'exportar.col.presentacion': 'Presentación',
  'exportar.col.contiene': 'Contiene',
  'exportar.col.codigos': 'Códigos de barras',
  'exportar.col.tipo': 'Tipo',
  'exportar.col.telefono': 'Teléfono',
  'exportar.col.direccion': 'Dirección',
  'exportar.col.lista': 'Lista de precios',
  'exportar.col.limite': 'Límite de fiado',
  'exportar.col.debe': 'Debe',
  'exportar.col.haber': 'Haber',
  'exportar.col.monto': 'Monto C$',
  'exportar.col.montoOriginal': 'Monto en su moneda',
  'exportar.col.moneda': 'Moneda',
  'exportar.col.forma': 'Forma de pago',
  'exportar.col.referencia': 'Referencia',
  'exportar.col.nota': 'Nota',
  'exportar.col.descripcion': 'Descripción',
  'exportar.col.proveedor': 'Proveedor',
  'exportar.col.documento': 'Factura',
  'exportar.col.vence': 'Vence',
  'exportar.col.pagado': 'Pagado',
  'exportar.col.pendiente': 'Por pagar',
  'exportar.col.concepto': 'Concepto',
  'exportar.col.codigo': 'Código',
  'exportar.col.cuenta': 'Cuenta',
  'exportar.col.saldo': 'Debe',

  // Impresora
  'ajustes.impresora': 'Impresora de recibos',
  'ajustes.papel': 'Rollo de {mm} mm',
  'ajustes.ayudaImpresora': 'Se imprime por la impresora que tenga conectada este teléfono o computadora. Casi todas las pequeñas son de 58 mm. Lo que escoja aquí vale solo para este equipo.',
  'ajustes.imprimirPrueba': 'Imprimir una prueba',
  'seccion.reponer': 'Reponer',

  // Cliente nuevo y cédula
  'pos.clienteNuevo': 'Cliente nuevo',
  'pos.abonar': 'Abonar a su cuenta',
  'pos.agregarComo': 'Agregar a «{nombre}» como cliente',
  'pos.pantallaCliente': 'Pantalla del cliente',

  // La pantalla del cliente: la segunda ventana, en un monitor que mira al mostrador.
  'pantalla.titulo': 'Pantalla del cliente',
  'pantalla.ayuda': 'Lleve esta ventana a la pantalla que mira al cliente y toque «Pantalla completa».',
  'pantalla.sinCaja': 'Abra «Vender» en la otra ventana y la venta aparece aquí.',
  'pantalla.completa': 'Pantalla completa',
  'pantalla.bienvenido': '¡Bienvenido!',
  'pantalla.aPagar': 'Total a pagar',
  'pantalla.gracias': '¡Gracias por su compra!',
  'pantalla.vuelto': 'Su vuelto',
  'pantalla.oferta': 'Oferta',
  'pantalla.ahorra': 'Usted ahorra',
  'pantalla.ahorro': 'Usted ahorró {monto}',
  'pantalla.llevaGratis': '{nombre} · {n} gratis',
  'clientes.cedula': 'Cédula',
  'clientes.ayudaCedula': 'El número de la cédula, por si algún día hay que dar con esta persona.',
  'clientes.ejemploCedula': '001-010190-0001A',
  'clientes.fotoCedula': 'Foto de la cédula',
  'clientes.tomarFotoCedula': 'Tomar foto de la cédula',
  'clientes.cambiarFotoCedula': 'Tomarla otra vez',
  'clientes.ayudaFotoCedula': 'De cerca, que la cédula llene la foto y se lean el nombre y el número. Después solo la ve el dueño.',
  'cuenta.datos': 'Datos',
  'cuenta.fotoNoLlega': 'La foto todavía no llega a este teléfono. Aparece cuando haya señal.',
  'cuenta.verFotoCedula': 'Ver la foto de la cédula en grande',
  'exportar.col.cedula': 'Cédula',
  'cuenta.acercarFoto': 'Acercar la foto',
  'cuenta.alejarFoto': 'Ver la foto entera',
  'cuenta.tocarParaAcercar': 'Toque la foto para acercarla.',
  'cuenta.tocarParaAlejar': 'Mueva la foto para leerla. Tóquela otra vez para verla entera.',

  // Teléfono estricto
  'clientes.ayudaTelefono': 'Ocho dígitos, sin el 505.',
  'clientes.ayudaTelefonoObligatorio': 'Hace falta: ocho dígitos, sin el 505.',
  'clientes.faltanDigitos': 'Faltan {n} dígito(s).',
  'clientes.telefonoConfirmar': 'Léaselo al cliente en voz alta para confirmarlo.',
  'clientes.telefonoIncompleto': 'Faltan {n} dígito(s): los teléfonos de Nicaragua tienen 8.',
  'clientes.telefonoPrefijo': 'Los teléfonos de Nicaragua empiezan con 2, 5, 7 u 8.',
  'clientes.telefonoLargo': 'Un teléfono tiene 8 dígitos. Si hay dos números, deje solo uno.',
  'clientes.telefonoExtranjeroCorto': 'Muy corto para un número de otro país: lleva el código del país después del +.',
  'clientes.telefonoFalta': 'Escriba el teléfono: es como se le cobra.',

  // Configuración del negocio
  'ajustes.cambiarConfiguracion': 'Cambiar la configuración',
  'baja.titulo': 'Este equipo fue dado de baja',
  'baja.explicacion': 'El dueño lo quitó de la tienda, o el servidor ya no lo reconoce. Lo que se hiciera aquí ya no llegaría a ningún lado, así que la aplicación se detiene. Si el dueño lo vuelve a dar de alta, se abre solo, con todo lo que tenía.',
  'baja.pendientes': '{n} registro(s) de este equipo no alcanzaron a enviarse.',
  'baja.intentar': 'Intentar otra vez',
  'baja.borrar': 'Borrar este equipo y registrarlo de nuevo',
  'baja.borrarTitulo': '¿Borrar lo que hay en este equipo?',
  'baja.borrarMensaje': 'Queda como recién instalado, listo para registrarlo con el PIN del dueño.',
  'baja.borrarConPendientes': 'Queda como recién instalado, listo para registrarlo con el PIN del dueño. Los {n} registro(s) que no se enviaron se pierden.',
  'personal.titulo': 'Personal y equipos',
  'personal.subtitulo': 'Quién entra a la tienda, y desde qué equipo',
  'personal.administrar': 'Administrar el personal y los equipos',
  'personal.personas': 'Personas',
  'personal.personasAyuda': 'Cada quien con su nombre y su PIN: lo que hace queda a su nombre.',
  'personal.usted': '(usted)',
  'personal.desactivada': 'Desactivada',
  'personal.agregar': 'Agregar una persona',
  'personal.rol': 'Qué hace',
  'personal.rolAyuda.cajero':
    'Vende, cobra, abre y cierra la caja; anota la mercadería comprada y lleva el inventario y los productos con sus precios. No ve las ganancias ni lo que vale el inventario.',
  'personal.rolAyuda.repartidor': 'Lleva los pedidos y los cobra en una caja suya, en su teléfono: empieza y termina su turno como un cajero. No ve costos.',
  'personal.rolAyuda.dueno': 'Todo: precios, compras, personal, configuración, y el PIN que autoriza.',
  'personal.agregada': '{nombre} ya puede entrar con su PIN en este equipo, y en los demás después de la próxima sincronización.',
  'personal.agregadaConDueno': '{nombre} ya puede entrar con su PIN. Desde ahora, anular y devolver pide el PIN del dueño; se puede cambiar en «Configuración».',
  'personal.noSeGuardo': 'No se pudo guardar. Intente otra vez.',
  'personal.pinEnUso': 'Ese PIN ya es de otra persona. Elija otro.',
  'personal.pinIgual': 'El PIN nuevo es el mismo de ahora.',
  'personal.desactivarTitulo': '¿Desactivar a {nombre}?',
  'personal.desactivarMensaje': '{nombre} ya no podrá entrar en ningún equipo, desde la próxima sincronización de cada uno. Todo lo que hizo sigue a su nombre, y se puede reactivar.',
  'personal.desactivar': 'Desactivar',
  'personal.reactivar': 'Reactivar',
  'personal.pinNuevo': 'Ponerle un PIN nuevo',
  'personal.pinNuevoDe': 'PIN nuevo de {nombre}',
  'personal.pinNuevoAyuda': 'Para cuando {nombre} olvidó el suyo o alguien más lo sabe. El de ahora deja de servir en cada equipo en cuanto sincronice.',
  'personal.rolPropio': 'Lo que usted hace solo lo cambia otro dueño.',
  'personal.ultimoDueno': 'Es el único dueño activo, y la tienda siempre necesita uno.',
  'personal.ustedAyuda': 'Su propio PIN se cambia en Ajustes, con «Cambiar mi PIN».',
  'personal.miPin': 'Cambiar mi PIN',
  'personal.miPinListo': 'Listo. Su PIN nuevo sirve desde ya en este equipo, y en los demás después de la próxima sincronización.',
  'personal.cambiarPin': 'Cambiar el PIN',
  'personal.pinActual': 'Su PIN de ahora',
  'personal.pinNuevoCampo': 'PIN nuevo (6 a 10 dígitos)',
  'personal.equipos': 'Equipos',
  'personal.equiposAyuda': 'Los teléfonos y computadoras registrados en la tienda.',
  'personal.equiposPractica': 'La tienda de práctica solo tiene este equipo.',
  'personal.equiposSinServidor': 'Sin conexión con el servidor: no se sabe cuándo se conectó cada equipo.',
  'personal.esteEquipo': '(este equipo)',
  'personal.tipo.mostrador': 'Mostrador',
  'personal.tipo.telefono': 'Teléfono',
  'personal.tipo.camion': 'Camión',
  'personal.tipo.admin': 'Oficina',
  'personal.dadoDeBaja': 'Dado de baja',
  'personal.vistoEn': 'se conectó {cuando}',
  'personal.nuncaVisto': 'nunca se ha conectado',
  'personal.relojAdelantado': 'Su reloj va {min} min adelantado: lo que registra queda con otra hora.',
  'personal.relojAtrasado': 'Su reloj va {min} min atrasado: lo que registra queda con otra hora.',
  'personal.darDeBaja': 'Dar de baja',
  'personal.darDeBajaTitulo': '¿Dar de baja «{nombre}»?',
  'personal.darDeBajaMensaje': 'Deja de sincronizar la próxima vez que intente conectarse, y lo que no haya enviado se queda en ese equipo. Si aparece, o fue un error, aquí mismo se vuelve a dar de alta, con todo lo que tenía. Si se perdió o se lo llevaron, cambie también los PIN, el suyo primero: el equipo guarda con qué comprobarlos, y en unas horas se pueden sacar.',
  'personal.agregarEquipo': 'Para agregar un equipo, abra la aplicación en él: pedirá el PIN del dueño.',
  'personal.darDeAlta': 'Dar de alta',
  'personal.darDeAltaTitulo': '¿Volver a dar de alta «{nombre}»?',
  'personal.darDeAltaMensaje': 'Vuelve a sincronizar la próxima vez que se conecte, con todo lo que tiene: lo que no alcanzó a enviar entra entonces a los libros. Hágalo solo si el equipo está otra vez en manos de la tienda.',
  'negocio.titulo': 'Configuración',
  'negocio.subtitulo': 'Vale para todos los teléfonos de la tienda.',
  'negocio.cambiar': 'Cambiar',
  'negocio.sinPoner': 'Sin poner',
  'negocio.noSeGuardo': 'No se pudo guardar el cambio. Intente otra vez.',
  'negocio.errorFalta': 'No puede quedar vacío.',
  'negocio.grupoNegocio': 'El negocio',
  'negocio.grupoNegocioAyuda': 'Así sale en cada recibo, impreso o por WhatsApp.',
  'negocio.nombre': 'Nombre',
  'negocio.nombreAyuda': 'Sale arriba en cada recibo y en la pantalla de inicio.',
  'negocio.direccion': 'Dirección',
  'negocio.direccionAyuda': 'Como se la daría a un cliente, desde un punto que todos conocen. Vacía, no sale en el recibo.',
  'negocio.direccionEjemplo': 'Del parque central, 2 cuadras al lago',
  'negocio.telefono': 'Teléfono',
  'negocio.telefonoAyuda': 'Ocho dígitos, sin el 505. Vacío, no sale en el recibo.',
  'negocio.ruc': 'RUC',
  'negocio.rucAyuda': 'Si la tienda está inscrita en la DGI. Vacío, no sale en el recibo.',
  'negocio.errorRuc': 'Solo números, letras y guiones.',
  'negocio.pie': 'Al pie del recibo',
  'negocio.pieAyuda': 'La última línea: para dar las gracias o avisar algo, como el horario. Vacía, no sale nada.',
  'negocio.muestra': 'Así sale el recibo',
  'negocio.grupoDolares': 'Dólares',
  'negocio.porDolar': 'C$ {tasa} por dólar',
  'negocio.cordobasPorDolar': 'Córdobas por cada dólar',
  'negocio.tasaTienda': 'Tasa de la tienda',
  'negocio.tasaTiendaAyuda': 'Lo que vale un dólar cuando el cliente paga con dólares, y en los gastos y las compras en dólares.',
  'negocio.tasaOficial': 'Tasa oficial del BCN',
  'negocio.tasaOficialAyuda': 'La del Banco Central. Con ella se llevan las cuentas: lo que va de una tasa a la otra es ganancia o pérdida cambiaria, no margen.',
  'negocio.avisoTasa': 'Es más de lo que vale en el Banco Central (C$ {oficial}): la tienda pierde un poco en cada dólar que recibe.',
  'negocio.errorTasa': 'Escriba cuántos córdobas vale un dólar, como 36.50.',
  'negocio.errorTasaRango': 'Un dólar vale entre C$ {min} y C$ {max}. Revise que no le falte el punto.',
  'negocio.grupoCaja': 'Caja',
  'negocio.redondeo': 'Redondeo del efectivo',
  'negocio.exacto': 'Exacto',
  'negocio.redondeoEjemplo': 'Cuando todo se paga en efectivo, {antes} se cobra {despues}. Las transferencias y las tarjetas, siempre exactas.',
  'negocio.redondeoExacto': 'El efectivo se cobra exacto, al centavo.',
  'negocio.conteoCiego': 'Conteo a ciegas',
  'negocio.conteoCiegoAyuda': 'Quien abre o cierra la caja cuenta la plata antes de ver cuánto debía haber, así el conteo no se acomoda al número.',
  'negocio.fondo': 'Fondo de caja',
  'negocio.fondoAyuda': 'Lo que se deja en la gaveta cada noche para dar vuelto. El corte lo sugiere y dice cuánto sacar.',
  'negocio.fondoLibre': 'Nada',
  'negocio.fondoCordobas': 'Córdobas que se quedan',
  'negocio.fondoHojaAyuda': 'Vacío: el corte sugiere no dejar nada.',
  'negocio.grupoPrecios': 'Precios',
  'negocio.margenMinimo': 'Margen mínimo',
  'negocio.margenMinimoAyuda': 'Vender por debajo de este margen pide el PIN del dueño. Con 0%, solo lo pide vender por debajo del costo.',
  'negocio.ventaRapida': 'Venta rápida sin el dueño',
  'negocio.ventaRapidaHasta': 'Hasta {monto} por venta',
  'negocio.ventaRapidaSiempre': 'Nunca: toda venta rápida pide el PIN',
  'negocio.ventaRapidaAyuda': 'Una venta rápida no tiene costo ni mueve inventario, así que nada revisa su precio. Pasando de esto, cobrarla pide el PIN del dueño.',
  'negocio.ventaRapidaMonto': 'Córdobas por venta',
  'negocio.ventaRapidaHojaAyuda': 'Lo que pueden sumar las ventas rápidas de una venta sin el dueño. Con 0, todas piden el PIN.',
  'negocio.porcentaje': 'Porcentaje',
  'negocio.errorMargen': 'Escriba un número de 0 a {max}, como 10 o 12.5.',
  'negocio.faltanteAviso': 'Avisar de un faltante de caja',
  'negocio.faltanteAvisoDesde': 'desde {monto}',
  'negocio.faltanteAvisoSiempre': 'todos',
  'negocio.faltanteAvisoAyuda': 'Un corte, una entrega o un efectivo recibido que salga corto por esto o más aparece en la pantalla de inicio del dueño, con de quién era la caja.',
  'negocio.faltanteAvisoMonto': 'Desde cuánto (C$)',
  'negocio.faltanteAvisoHojaAyuda': 'Vacío o cero: avisa de todos.',
  'negocio.reconteo': 'Pedir que se cuente otra vez',
  'negocio.reconteoDesde': 'si no cuadra por {monto} o más',
  'negocio.reconteoSiempre': 'si no cuadra por nada',
  'negocio.reconteoAyuda':
    'Un conteo de la gaveta (al empezar, al terminar o al recibirla) que no cuadra por esto o más se pide otra vez antes de tomarlo, sin decir cuánto ni para dónde: casi siempre es un billete mal contado. Vale el segundo, y usted ve los dos. En dólares, cualquier billete.',
  'negocio.reconteoMonto': 'Desde cuánto (C$)',
  'negocio.reconteoHojaAyuda': 'Vacío o cero: cualquier diferencia pide otro conteo.',
  'negocio.grupoPedidos': 'Pedidos',
  'negocio.apartarPedidos': 'Apartar la mercadería de los pedidos',
  'negocio.apartarPedidosAyuda':
    'Un pedido aparta lo que lleva, y uno que pide más de lo que queda sin apartar no se guarda. Los pedidos se guardan solo con conexión, para que dos teléfonos no prometan lo mismo, y la caja pide el PIN del dueño para vender lo apartado. Antes de encenderlo, actualice la aplicación en todos los teléfonos.',
  'negocio.venderSoloLoQueHay': 'La caja vende solo lo que hay',
  'negocio.venderSoloLoQueHayAyuda':
    'Lo que pasa de lo que queda libre (lo que hay menos lo apartado para pedidos) pide el sí del dueño, y con conexión cada venta espera el sí del servidor, para que dos cajas no vendan lo último. Sin conexión, la caja sigue vendiendo con un aviso. Cada producto necesita su existencia en los libros. Antes de encenderlo, actualice la aplicación en todos los teléfonos.',
  'negocio.grupoSeguridad': 'Seguridad',
  'negocio.equipoCallado': 'Avisar de un equipo sin conectarse después de',
  'negocio.equipoCalladoAyuda': 'Un teléfono que no se conecta guarda ventas y anulaciones que nadie ha visto, y las pierde si se daña. La pantalla de inicio del dueño lo dice.',
  'negocio.horas': '{n} horas',
  'negocio.unDia': '1 día',
  'negocio.bloqueo': 'Bloquear la pantalla después de',
  'negocio.bloqueoAyuda': 'Ese tiempo sin que nadie la toque, y pide el PIN de quien la estaba usando. «{boton}», en la pantalla de inicio, la bloquea de una vez.',
  'negocio.bloqueoPractica': 'En la tienda de práctica la pantalla no se bloquea sola; en la de verdad, sí.',
  'negocio.bloqueoNombre': 'Tiempo para bloquear la pantalla',
  'negocio.unMinuto': '1 minuto',
  'negocio.minutos': '{n} minutos',
  'negocio.unaHora': '1 hora',
  'negocio.anularConDueno': 'Anular y devolver pide el PIN del dueño',
  'negocio.anularConDuenoAyuda': 'También en el turno abierto: al anular una venta o un abono, y al devolver plata. Apagado, en el turno abierto cada quien confirma con su propio PIN. Lo de un turno ya cerrado siempre pide el del dueño.',
  'negocio.grupoVencimientos': 'Vencimientos',
  'negocio.grupoPlanilla': 'Planilla',
  'negocio.vacaciones': 'Las vacaciones se acumulan',
  'negocio.vacacionesAyuda':
    'Cada mes, 2.5 días y un doceavo del salario de quien tiene prestaciones (Art. 76 del Código del Trabajo). Apagado, ninguna planilla aparta vacaciones ni se ganan días, y no se ven en «Planilla»; lo ya apartado se sigue debiendo. El aguinaldo y la indemnización siguen igual.',
  'negocio.vencimientoAlerta': 'Avisar antes de que venza',
  'negocio.vencimientoAlertaAyuda': 'Con ese tiempo de anticipación un lote empieza a salir en {pantalla} y en la pantalla de inicio.',
  'negocio.dias': '{n} días',

  // Cuentas de banco: las de la tienda, en Configuración, y cuál se usa en cada pago
  'bancos.grupo': 'Cuentas de banco',
  'bancos.grupoAyuda': 'Cada una se concilia con su propio estado de cuenta.',
  'bancos.cual': 'Cuenta de banco',
  'bancos.enCordobas': 'En córdobas',
  'bancos.enDolares': 'En dólares',
  'bancos.cerrada': 'cerrada',
  'bancos.agregar': 'Agregar una cuenta',
  'bancos.nueva': 'Cuenta nueva',
  'bancos.nombre': 'Nombre',
  'bancos.nombreAyuda': 'Como la conoce la tienda: el banco y la moneda, como «Banpro córdobas» o «Cuenta en EE. UU.».',
  'bancos.moneda': 'Moneda',
  'bancos.monedaAyuda': 'En qué moneda lleva el banco la cuenta. Después no se cambia.',
  'bancos.cordobas': 'Córdobas (C$)',
  'bancos.dolares': 'Dólares (US$)',
  'bancos.faltaNombre': 'Póngale un nombre.',
  'bancos.nombreRepetido': 'Ya hay una cuenta con ese nombre.',
  'bancos.yaHayCinco': 'Ya hay cinco cuentas en esa moneda, que es lo más que lleva el sistema.',
  'bancos.tiene': 'Según los libros tiene {monto}.',
  'bancos.abierta': 'Abierta',
  'bancos.abiertaAyuda': 'Cerrada, ya no se ofrece para pagar ni para cobrar, y lo que movió sigue en los libros.',
  'bancos.noSeCierraPredeterminada': 'A esta cuenta entran las transferencias de los clientes o los pagos con tarjeta: cambie eso primero.',
  'bancos.noSeCierraConSaldo': 'Según los libros todavía tiene dinero: páselo a otra cuenta, o concíliela con el estado de cuenta, antes de cerrarla.',
  'bancos.transferencias': 'Las transferencias de los clientes entran a',
  'bancos.transferenciasAyuda': 'La cuenta que la tienda da para que le transfieran. Al confirmar cada transferencia se puede cambiar.',
  'bancos.tarjeta': 'Los pagos con tarjeta entran a',
  'bancos.tarjetaAyuda': 'La cuenta donde deposita la terminal de tarjetas (el POS) del banco.',
  'bancos.unaSola': 'Las transferencias de los clientes y los pagos con tarjeta entran a «{cuenta}».',
  'bancos.deA': 'De {desde} a {hacia}',
  'bancos.pagaDe': 'Se paga de',
  'bancos.entraA': 'Entra a',
  'bancos.saleDe': 'Sale de',
  'ventas.duenoParaAnular': 'Para anular {ticket} hace falta el PIN del dueño. La anulación queda a nombre de {nombre}.',
  'devolucion.pinDueno': 'Para devolver {monto} de la venta {ticket} hace falta el PIN del dueño. Queda a nombre de {nombre}.',
  'devolucion.pinDuenoOtroTurno': 'La venta {ticket} es de antes de este turno: devolver {monto} pide el PIN del dueño. Queda a nombre de {nombre}.',
  'ventas.duenoOtroTurno': 'La venta {ticket} es de antes de este turno: anularla pide el PIN del dueño. La anulación queda a nombre de {nombre}.',
  'abono.duenoOtroTurno': 'El abono de {monto} de {cliente} es de antes de este turno: anularlo pide el PIN del dueño. Queda a nombre de {nombre}.',
  'abono.duenoParaAnular': 'Para anular el abono de {monto} de {cliente} hace falta el PIN del dueño. Queda a nombre de {nombre}.',

  // Efectivo: lo que sale de las gavetas, recibido y contado
  'efectivo.titulo': 'Efectivo',
  'efectivo.subtitulo': 'Lo que entregan las cajas, la caja fuerte, el banco y la billetera',
  'efectivo.porRecibir': 'Por recibir',
  'efectivo.porRecibirAyuda': 'Lo que una caja entregó sin que nadie lo recibiera. Cuéntelo al recibirlo: lo que falte es de esa caja.',
  'efectivo.nadaPorRecibir': 'Nada por recibir: todo lo que salió de las gavetas ya se contó.',
  'efectivo.cajaDe': 'Caja de {nombre}, {fecha}',
  'efectivo.turnoAbierto': 'Turno abierto',
  'efectivo.turnoCerrado': 'Turno cerrado',
  'efectivo.general': 'Efectivo general',
  'efectivo.generalAyuda': 'La caja fuerte: lo que sale de las gavetas y con lo que se paga en efectivo.',
  'efectivo.segunLibros': 'Según los libros',
  'efectivo.segunLibrosAl': 'Según los libros, a esa fecha',
  'efectivo.contar': 'Contar el efectivo general',
  'efectivo.bancoBilletera': 'Banco y billetera',
  'efectivo.bancoBilleteraAyuda': 'Compárelos con el estado de cuenta: la diferencia queda apuntada con la fecha del estado.',
  'efectivo.banco': 'Banco',
  'efectivo.billetera': 'Billetera móvil',
  'efectivo.bancoDolares': 'Banco en dólares',
  'efectivo.conciliar': 'Conciliar',
  'efectivo.cuadra': 'Cuadra',
  'efectivo.faltan': 'Faltan {monto}',
  'efectivo.sobran': 'Sobran {monto}',
  'efectivo.noSeGuardo': 'No se pudo guardar.',
  'efectivo.yaRecibida': 'Esa caja ya no tiene nada por recibir: quizás ya la recibieron en otro equipo.',
  'efectivo.cambioLoEntregado': 'Lo que entregó esa caja cambió mientras contaba. Cuéntelo otra vez.',
  'efectivo.recibido': 'Recibido',
  'efectivo.entrego': 'Entregó',
  'efectivo.contado': 'Contado',
  'efectivo.faltanteDeCaja': 'Queda como faltante de la caja de {nombre}.',
  'efectivo.recibirDe': 'Recibir de {nombre}',
  'efectivo.recibir': 'Recibir',
  'efectivo.recibirAyuda': 'Cuente lo que le entregaron antes de ver cuánto debía ser, igual que en el corte.',
  'efectivo.guardarArqueo': 'Guardar el conteo',
  'efectivo.arqueoAyuda': 'Cuente todo el efectivo que no está en una gaveta. Los dólares se valoran a la tasa oficial. La diferencia queda apuntada como sobrante o faltante.',
  'efectivo.arqueoPrimera':
    'Es la primera vez que se cuenta la caja fuerte: lo que tenga es el saldo con que empieza, del dueño. La diferencia con los libros no es sobrante ni faltante.',
  'efectivo.arqueoPorRecibir': 'Hay {monto} por recibir de las cajas. Recíbalo antes de contar, o cuente sin ese dinero.',
  'efectivo.arqueoGuardado': 'Guardado: los libros ya dicen lo que usted contó.',
  'efectivo.conciliarBanco': 'Conciliar el banco',
  'efectivo.conciliarBilletera': 'Conciliar la billetera',
  'efectivo.conciliarDolares': 'Conciliar la cuenta en dólares',
  'efectivo.conciliarAyudaDolares':
    'Escriba el saldo en dólares que muestra el estado de cuenta, y de qué fecha es. Lo que tenga de más o de menos se anota a la tasa oficial.',
  'efectivo.saldoEstadoDolares': 'Saldo según el estado, en dólares',
  'efectivo.conciliarAyuda': 'Escriba el saldo que muestra el estado de cuenta, y de qué fecha es.',
  'efectivo.conciliarEnCola':
    '{n} pago(s) de hasta esa fecha esperan en la cola, por {monto}. Si aparecen en el estado de cuenta, confírmelos antes en «Transferencias sin confirmar»: conciliado sin ellos, la diferencia los cuenta, y al confirmarlos entrarían otra vez.',
  'efectivo.verLaCola': 'Ver la cola de transferencias',
  'efectivo.fechaEstado': 'Fecha del estado de cuenta',
  'efectivo.saldoEstado': 'Saldo según el estado',
  'efectivo.conciliado': 'Conciliado al {fecha}: los libros ya dicen ese saldo.',
  'inicio.porRecibir': '{n} caja(s) entregaron efectivo sin recibir',
  'inicio.rutaSinLiquidar': 'Sigue abierta una ruta de antes ({camion}, desde el {fecha}) en «{equipo}»: se liquida en ese teléfono, con su PIN.',
  'inicio.rechazosSinRevisar': '{n} registro(s) que el servidor rechazó, sin revisar',
  'inicio.equiposCallados': '{n} equipo(s) sin conectarse hace más de {dias} día(s)',
  'inicio.pinesDelDueno': '{n} intentos equivocados seguidos con el PIN del dueño en las últimas 24 horas',

  // Pagar de la gaveta
  'gaveta.sale': 'Sale de la gaveta',
  'gaveta.saleAyuda': 'Del efectivo de la caja abierta en este equipo (se esperan {monto}): el corte lo descuenta.',
  'gaveta.saleAyudaSinMonto': 'Del efectivo de la caja abierta en este equipo: el corte lo descuenta.',
  'gaveta.noSaleAyuda': 'Del efectivo general: la gaveta no se toca.',
  // La caja abierta en otro equipo, para un gasto (2026-10-16).
  'gaveta.saleAyudaDe': 'Del efectivo de la caja de {quien} en «{equipo}» (se esperan {monto}): el corte de esa caja lo descuenta.',
  'gaveta.saleAyudaDeSinMonto': 'Del efectivo de la caja de {quien} en «{equipo}»: el corte de esa caja lo descuenta.',
  'gaveta.otroEquipo': 'otro equipo',
  'gaveta.deCual': '¿De qué caja?',
  'gaveta.deEsteEquipo': '{caja} (este equipo)',
  'gaveta.noAlcanza': 'En la gaveta se esperan {monto}: no alcanza. Si lo pagó de otro lado, apague «Sale de la gaveta».',
  'gaveta.noAlcanzaSinMonto': 'Lo que hay en la gaveta no alcanza. Si lo pagó de otro lado, apague «Sale de la gaveta».',

  // Entregar la caja sin cerrarla
  'entrega.titulo': 'Recibir la caja de {nombre}',
  'entrega.recibirDe': 'Recibir la caja de {nombre}',
  'entrega.recibir': 'Recibir la caja',
  'entrega.recibida': 'Caja recibida',
  'entrega.explicacion': 'Cuente lo que hay en la gaveta sin ver cuánto debería haber. Lo que falte o sobre queda en el turno de {nombre}, y la caja sigue a su nombre, desde lo que usted contó.',
  'entrega.aSuNombre': 'Está todo. La caja ya está a su nombre.',
  'entrega.diferenciaDe': 'La diferencia queda en el turno de {nombre}. La caja ya está a su nombre, desde lo que usted contó.',
  'entrega.noSeGuardo': 'No se pudo guardar.',
  'entrega.aviso': 'Esta caja está a nombre de {nombre}. Para atender, recíbala: cuente la gaveta.',
  'entrega.cajaDe': 'La caja es de {nombre}',
  'entrega.paraVender': 'Lo que usted venda quedaría en la caja de {nombre}. Recíbala primero: se cuenta la gaveta, y desde ahí la caja es suya.',

  // Control por persona
  'control.titulo': 'Control',
  'control.subtitulo': 'Lo que cada quien hizo con la plata, lado a lado',
  'control.periodo': 'Período',
  'control.ultimosDias': 'Últimos {n} días',
  'control.nada': 'Nadie ha hecho nada en estos días.',
  'control.sinAutorizar': 'Sin la autorización del dueño',
  'control.sinAutorizarAyuda': 'Ventas que el mostrador habría pedido al dueño y pasaron sin su PIN: vienen de un equipo viejo, o de alguien que se lo saltó.',
  'control.motivo.lista': 'otra lista de precios',
  'control.motivo.rapidas': 'ventas rápidas de más',
  'control.motivo.margen': 'precio bajo el margen mínimo',
  'control.motivo.fiado': 'fiado sin límite o pasado de él',
  'control.motivo.noEsDueno': 'la autorizó alguien que no es dueño',
  'control.motivo.otroNombre': 'a nombre de alguien que no estaba usando el equipo',
  'control.faltantes': 'Faltantes de caja',
  'control.faltantesAyuda': 'Cortes, entregas y efectivo recibido que salieron cortos, a nombre de quien tenía la caja.',
  'control.ventas': 'Ventas',
  'control.anuladas': 'Anuladas',
  'control.devueltas': 'Devoluciones',
  'control.rebajas': 'Precios rebajados',
  'control.rapidas': 'Ventas rápidas',
  'control.mermas': 'Mermas',
  'control.caja': 'Caja',
  'control.cajaCuadra': 'cuadra',
  'control.pinesMal': 'PIN equivocados',
  'control.conSiDelDueno': 'Con el sí del dueño',
  'control.entradasDueno': 'Dónde entró el dueño',
  'control.entradasDuenoAyuda':
    'Cada entrada con el PIN del dueño, equipo por equipo. Si alguna no fue usted, alguien sabe su PIN: cámbielo en Ajustes.',
  'control.vecesUltima': '{n} entrada(s) · la última el {cuando}',
  // Lo que hizo una persona: su tarjeta de «Control», abierta (2026-10-23)
  'controlPersona.noExiste': 'Esa persona no está en esta tienda.',
  'controlPersona.ver': 'Qué ver',
  'controlPersona.ver.todo': 'Todo',
  'controlPersona.ver.caja': 'Caja',
  'controlPersona.ver.ventas': 'Ventas',
  'controlPersona.ayuda':
    'Cada apertura, entrega y corte de caja, y cada venta, anulación y devolución, de lo más nuevo a lo más viejo. Toque uno para verlo; un conteo mal hecho se corrige aquí mismo.',
  'controlPersona.nada': 'Nada en estos días.',
  'controlPersona.nadaCaja': 'Ninguna caja abierta, entregada ni cerrada en estos días.',
  'controlPersona.nadaVentas': 'Ninguna venta, anulación ni devolución en estos días.',
  'controlPersona.abrio': 'Abrió la caja',
  'controlPersona.recibioDe': 'Recibió la caja de {nombre}',
  'controlPersona.entregoA': 'Entregó la caja a {nombre}',
  'controlPersona.corte': 'Corte de caja',
  'controlPersona.corteDe': 'Cerró la caja de {nombre}',
  'controlPersona.cortePor': 'Corte de caja, por {nombre}',
  'controlPersona.recibioLoDe': 'Recibió lo que entregó {nombre}',
  'controlPersona.recibidoPor': 'Lo que entregó, recibido por {nombre}',
  'controlPersona.conto': 'contó {monto}',
  'controlPersona.corregido': 'corregido',
  'controlPersona.lineas': '{n} línea(s)',
  'controlPersona.anulo': 'Anuló {ticket}',
  'controlPersona.devolucion': 'Devolución de {ticket}',
  'inicio.faltantesCaja': '{n} faltante(s) de caja estos 7 días, el mayor de {monto} ({nombre})',
  'inicio.sinAutorizar': '{n} venta(s) sin la autorización del dueño estos 7 días',

  // Precios bajo el margen
  'margen.titulo': 'Precios bajo el margen',
  'margen.explicacion': 'El costo subió y estos precios quedaron bajo el margen mínimo ({minimo}): cada venta gana menos de lo que usted pidió, o pierde. Súbalos al mínimo con un toque, o déjelos si es a propósito.',
  'margen.todosBien': 'Todos los precios están sobre el margen mínimo.',
  'margen.subir': 'Subir',
  'margen.subirTodos': 'Subir los {n}',
  'margen.dejarlos': 'Dejarlos así',
  'inicio.preciosBajoMargen': '{n} precio(s) bajo el margen mínimo',
  'inicio.negativos': '{n} producto(s) con existencia negativa: hay que contarlos',
  // --- «Cuadrar la semana»: the owner going over the week's money, a step at a time ---
  'cuadrar.titulo': 'Cuadrar la semana',
  'cuadrar.subtitulo': 'El dinero de la semana, paso a paso',
  'cuadrar.explicacion':
    'Del {desde} al {hasta}: los sobres que dejaron las cajas, lo que salió de la caja fuerte, la caja fuerte contada, el banco, y lo que dejó la semana. Cada paso dice qué hacer.',
  'cuadrar.cajasPorRecibir': '{n} sobre(s) de las cajas por contar.',
  'cuadrar.nadaPorRecibir': 'No hay sobres de las cajas por contar.',
  'cuadrar.transferenciasPorVer': '{n} transferencia(s) o pago(s) por billetera esperan que los vea en el banco.',
  'cuadrar.nadaPorVer': 'No hay transferencias por ver.',
  'cuadrar.yDespues':
    'Después: lo que salió de la caja fuerte, contarla, el banco, los proveedores, y lo que dejó la semana.',
  'cuadrar.empezar': 'Empezar',
  'cuadrar.contarCordobas': 'Cuente los córdobas que entregó {nombre} ({fecha})',
  'cuadrar.contarCordobasExplicacion':
    'Es el dinero que salió de la caja de {nombre} y que nadie ha contado todavía. Cuéntelo billete por billete: el sistema no le dice cuánto debería haber hasta el final.',
  'cuadrar.contarDolares': '¿Hay dólares en lo que entregó {nombre}?',
  'cuadrar.contarDolaresExplicacion': 'Cuente los billetes de dólar aparte. Si no hay ninguno, toque «No hay dólares».',
  'cuadrar.reviseRecibir':
    'Si algo está mal, toque «Atrás» y corríjalo. Al recibirlo, el dinero pasa al efectivo general, y lo que falte queda en la caja de {nombre}.',
  'cuadrar.entregoMas': 'Mientras usted contaba, la caja de {nombre} entregó más dinero. Cuéntelo todo otra vez, junto.',
  'cuadrar.recibir': 'Recibir el dinero',
  'cuadrar.recibidoTitulo': 'Recibido de {nombre}',
  'cuadrar.recibidoExplicacion': 'Esto encontró al contar lo que entregó {nombre}.',
  'cuadrar.yaRecibidoTitulo': 'El sobre de {nombre} ya fue recibido',
  'cuadrar.yaRecibidoExplicacion':
    'Mientras usted contaba, lo recibieron en otro teléfono: aquí no queda nada que recibir, ni nada que anotar contra la caja.',
  'cuadrar.entregoCordobas': 'Entregó en córdobas',
  'cuadrar.entregoDolares': 'Entregó en dólares',
  'cuadrar.faltanteDe': 'Lo que falta queda anotado en la caja de {nombre}.',
  'cuadrar.transferenciaTitulo': '¿Llegó esta transferencia?',
  'cuadrar.transferenciaExplicacion':
    'Abra la aplicación del banco y busque esta transferencia por la referencia y el monto. Una captura de pantalla no es un pago: confírmela solo si la ve en el banco.',
  'cuadrar.billeteraTitulo': '¿Llegó este pago por billetera?',
  'cuadrar.billeteraExplicacion': 'Abra la billetera móvil y busque este pago por la referencia y el monto. Confírmelo solo si lo ve ahí.',
  'cuadrar.monto': 'Monto',
  'cuadrar.deLaVenta': 'De la venta',
  'cuadrar.deLaRecarga': 'De la recarga',
  'cuadrar.cliente': 'Cliente',
  'cuadrar.sinReferencia': 'Sin número',
  'cuadrar.fecha': 'Fecha',
  'cuadrar.referenciaAyuda': 'Vino sin número: escriba el que aparece en el banco para confirmarla.',
  'cuadrar.faltaReferencia': 'Escriba primero el número que aparece en el banco.',
  'cuadrar.siLlego': 'Sí, aparece en el banco',
  'cuadrar.siLlegoBilletera': 'Sí, aparece en la billetera',
  'cuadrar.siLlegoDetalle': 'Queda confirmada, y el dinero cuenta como recibido.',
  'cuadrar.todaviaNo': 'Todavía no aparece',
  'cuadrar.todaviaNoDetalle': 'Queda pendiente, para verla otro día.',
  'cuadrar.noLlegoDetalle': 'El dinero nunca llegó: se anota qué pasó.',
  'cuadrar.confirmada': 'Confirmada: el dinero llegó.',
  'cuadrar.alFiado': 'Pasó a la cuenta de {nombre}, como fiado.',
  'cuadrar.perdida': 'Anotada como pérdida.',
  'cuadrar.noLlegoCliente':
    'La venta queda hecha. Lo que no llegó se puede pasar a la cuenta de {nombre}, como fiado, o anotarse como pérdida.',
  'cuadrar.noLlegoSinCliente': 'La venta queda hecha, y lo que no llegó se anota como pérdida.',
  'cuadrar.aFiadoDetalle': 'Lo debe como cualquier fiado, y aparece en su estado de cuenta.',
  'cuadrar.perdidaDetalle': 'Dinero que no se va a cobrar: queda anotado.',
  'cuadrar.faltaMotivo': 'Escriba primero qué pasó.',
  'cuadrar.gastosTitulo': 'Los gastos de la semana',
  'cuadrar.gastosExplicacion':
    'Antes de contar la caja fuerte, todo lo que salió de ella tiene que estar anotado, o va a faltar. Primero los gastos: ¿pagó algo que no esté en la lista?',
  'cuadrar.sinGastos': 'No hay gastos anotados.',
  'cuadrar.anotarGasto': 'Sí, anotar un gasto',
  'cuadrar.anotarOtro': 'Anotar otro gasto',
  'cuadrar.anotarDetalle': 'Un recibo, una compra para la tienda, un pago que no esté en la lista.',
  'cuadrar.noPague': 'No pagué nada',
  'cuadrar.esoEsTodo': 'Eso es todo',
  'cuadrar.depositoTitulo': '¿Llevó dinero al banco esta semana?',
  'cuadrar.depositoExplicacion':
    'Lo que llevó al banco salió de la caja fuerte. Anote cada depósito con su boleta, si no está en la lista.',
  'cuadrar.siDeposite': 'Sí, deposité',
  'cuadrar.otroDeposito': 'Anotar otro depósito',
  'cuadrar.siDepositeDetalle': 'Los córdobas a la cuenta en córdobas, los dólares a la cuenta en dólares.',
  'cuadrar.noDeposite': 'No deposité',
  'cuadrar.resumenTitulo': 'Lo que dejó la semana',
  'cuadrar.resumenExplicacion':
    'Del {desde} al {hasta}: lo que se vendió, lo que costó, los gastos y lo que quedó; cómo pagaron los clientes, y lo que fue al banco.',
  'cuadrar.pendientesTitulo': 'Lo que queda pendiente',
  'cuadrar.pendientesExplicacion': 'No hay que hacerlo ahora, pero no se olvide: cada uno lleva a donde se resuelve.',
  'cuadrar.nadaPendiente': 'Ya no queda nada pendiente.',
  'cuadrar.sigueAbierta': 'La caja de {nombre} sigue abierta: su efectivo se recibe cuando termine el turno.',
  'cuadrar.terminar': 'Terminar',
  'cuadrar.listoTitulo': '¡Listo! La semana está cuadrada',
  'cuadrar.listoExplicacion':
    'El inicio se lo vuelve a pedir dentro de una semana. Lo que quedó pendiente sigue en su lugar.',
  'cuadrar.verEfectivo': 'Ver el efectivo',
  'cuadrar.desdeEfectivo': 'Los sobres, la caja fuerte, el banco y los proveedores, paso a paso',
  'cuadrar.inicioPrimera': 'Repase el dinero de la semana: los sobres, la caja fuerte y el banco',
  'cuadrar.inicioHaceDias': 'Hace {n} días que no repasa el dinero',
  'cuadrar.resumenTituloDia': 'Lo que dejó el día',
  'cuadrar.sinDepositos': 'No hay depósitos anotados.',
  'cuadrar.boleta': 'Boleta {numero}',
  'cuadrar.noHuboMas': 'No hubo más',
  'cuadrar.duenoTitulo': '¿Sacó dinero para usted?',
  'cuadrar.duenoExplicacion':
    'Lo que sacó para usted de la caja fuerte no es un gasto de la tienda, pero salió de ella. Anótelo, si no está en la lista.',
  'cuadrar.paraUsted': 'Para usted',
  'cuadrar.sinRetiros': 'No hay nada anotado.',
  'cuadrar.siSaque': 'Sí, saqué dinero',
  'cuadrar.otroRetiro': 'Anotar otro',
  'cuadrar.siSaqueDetalle': 'Cuánto, en córdobas o dólares, y qué día.',
  'cuadrar.noSaque': 'No saqué nada',
  'cuadrar.pagosTitulo': '¿Le pagó a algún proveedor?',
  'cuadrar.pagosExplicacion':
    'Un pago en efectivo a un proveedor salió de la caja fuerte. Anótelo, si no está en la lista: también baja lo que se le debe.',
  'cuadrar.sinPagos': 'No hay pagos anotados.',
  'cuadrar.anotarPago': 'Anotar un pago',
  'cuadrar.anotarPagoDetalle': 'A quién, cuánto, y cómo le pagó.',
  'cuadrar.noPagueProveedor': 'No le pagué a nadie',
  'cuadrar.proveedoresTitulo': 'Lo que hay que pagar a proveedores',
  'cuadrar.proveedoresExplicacion':
    'Lo vencido y lo que vence en los próximos siete días. Puede pagarlo ahora, o cuando le toque.',
  'cuadrar.vencio': 'venció el {fecha}',
  'cuadrar.pagarUno': 'Pagar uno ahora',
  'cuadrar.pagarDespues': 'Seguir',
  'cuadrar.nadaPronto': 'Ya no vence nada esta semana.',
  'sobres.titulo': '¿Tiene a mano los sobres?',
  'sobres.explicacion':
    'Cada caja que terminó su turno dejó un sobre con el dinero para usted. Toque el que no tenga ahora: queda para la próxima vez. Los demás se cuentan todos juntos, sin saber cuánto debería haber.',
  'sobres.de': '{nombre}, {fecha}',
  'sobres.loTengo': 'Lo tengo',
  'sobres.noLoTengo': 'No lo tengo: queda para después',
  'sobres.yaRecibido': 'Lo recibieron en otro teléfono',
  'sobres.contar': 'Contar {n} sobre(s)',
  'sobres.ninguno': 'Seguir sin contarlos',
  'sobres.contarCordobas': 'Cuente los córdobas de {n} sobre(s), todos juntos',
  'sobres.contarCordobasExplicacion':
    'Abra los sobres y junte el dinero. Billete por billete, cuántos hay de cada uno; las monedas, en total. Sin saber cuánto debería haber: así se cuenta lo que hay.',
  'sobres.entregaronMas': 'Mientras usted contaba, una caja entregó más dinero. Cuéntelo todo otra vez, junto.',
  'sobres.recibidoEnOtro': 'Mientras usted contaba, recibieron un sobre en otro teléfono. Cuente otra vez los que quedan, todos juntos.',
  'sobres.contarDolares': '¿Hay dólares en los sobres?',
  'sobres.revise':
    'Lo que contó de {n} sobre(s). Si cuadra con lo que entregaron las cajas, queda recibido; si no, se cuenta cada sobre por separado.',
  'sobres.cuadranTitulo': '{n} sobre(s) recibido(s): todo cuadra',
  'sobres.cuadranExplicacion':
    'El total es lo que entregaron las cajas. El dinero ya es efectivo general: guárdelo en la caja fuerte.',
  'sobres.cadaTitulo': 'El total no cuadra: cuente cada sobre por separado',
  'sobres.cadaExplicacion':
    'Así se sabe de qué caja es la diferencia. Uno a la vez, igual que antes: sin saber cuánto debería haber.',
  'fuerte.contarCordobas': 'Cuente los córdobas de la caja fuerte',
  'fuerte.contarExplicacion':
    'Todo lo que hay, con lo de los sobres. Billete por billete, cuántos hay de cada uno; las monedas, en total. Sin saber cuánto debería haber.',
  'fuerte.primeraVez':
    'Es la primera vez que la cuenta aquí: lo que tenga es el saldo con que empieza la caja fuerte. Cuéntelo todo, con lo de los sobres: billete por billete, y las monedas en total.',
  'fuerte.contarDolares': '¿Hay dólares en la caja fuerte?',
  'fuerte.revise':
    'Lo que contó en la caja fuerte. Se compara con los libros: si algo no cuadra, se cuenta una vez más.',
  'fuerte.reviseInicial': 'Lo que contó en la caja fuerte. Desde hoy, es lo que tiene: los libros empiezan aquí.',
  'fuerte.guardar': 'Guardar el conteo',
  'fuerte.empiezaTitulo': 'La caja fuerte empieza con esto',
  'fuerte.empiezaExplicacion':
    'Lo que contó queda como el saldo inicial del efectivo general, del dueño. Desde la próxima vez, lo que falte o sobre se anota como faltante o sobrante.',
  'fuerte.resultadoTitulo': 'La caja fuerte, contada',
  'fuerte.resultadoExplicacion': 'Lo que contó, contra todo lo que la semana anotó que entró y salió.',
  'fuerte.enTotal': 'En total, a la tasa oficial',
  'fuerte.segunLibros': 'Según los libros',
  'fuerte.cuadra': 'La caja fuerte cuadra exacto.',
  'fuerte.sobranteAnotado': 'Lo que sobra queda anotado como sobrante del efectivo general.',
  'fuerte.faltanteAnotado': 'Lo que falta queda anotado como faltante del efectivo general: no es de ninguna caja.',
  'estado.banco': '¿Cuánto dice el banco?',
  'estado.dolares': '¿Cuánto dice la cuenta en dólares?',
  'estado.billetera': '¿Cuánto dice la billetera móvil?',
  'estado.cuentaNombrada': '¿Cuánto dice «{cuenta}»?',
  'estado.bancoExplicacion':
    'Busque el saldo de hoy en la app del banco o en el estado de cuenta, y escríbalo tal como aparece. Después se compara con los libros.',
  'estado.billeteraExplicacion':
    'Busque el saldo de hoy en la billetera, y escríbalo tal como aparece. Después se compara con los libros.',
  'estado.saldoCordobas': 'Saldo, en córdobas',
  'estado.saldoDolares': 'Saldo, en dólares',
  'estado.sinEstado': 'No lo tengo a mano ahora',
  'estado.comparar': 'Comparar',
  'estado.resultadoTitulo': 'Comparado con los libros',
  'estado.segunEstado': 'Según el estado',
  'estado.segunLibros': 'Según los libros',
  'estado.cuadra': 'Cuadra con los libros.',
  'estado.deMas': 'El estado tiene de más',
  'estado.deMenos': 'El estado tiene de menos',
  'estado.diferenciaAnotada':
    'La diferencia queda anotada como diferencia de conciliación: una comisión del banco, un interés, o algo que no se anotó.',
  'duenoPaso.monto': '¿Cuánto sacó para usted?',
  'duenoPaso.montoExplicacion':
    'No es un gasto de la tienda: baja lo que usted tiene en el negocio, no la ganancia. En córdobas, en dólares, o los dos.',
  'duenoPaso.fecha': '¿Qué día?',
  'duenoPaso.motivo': '¿Para qué? (si quiere)',
  'duenoPaso.motivoAyuda': 'Para acordarse después. No cambia nada en los libros.',
  'duenoPaso.reviseExplicacion': 'Sale de la caja fuerte y queda anotado como retiro del dueño.',
  'duenoPaso.guardar': 'Guardar',
  'pagoPaso.deuda': '¿A quién le pagó?',
  'pagoPaso.deudaExplicacion': 'Lo que se le debe a cada proveedor, compra por compra. Toque la que pagó.',
  'pagoPaso.nadaPorPagar': 'No se le debe nada a ningún proveedor.',
  'pagoPaso.debe': 'debe {monto}',
  'pagoPaso.vence': 'vence el {fecha}',
  'pagoPaso.monto': '¿Cuánto le pagó a {nombre}?',
  'pagoPaso.montoExplicacion': 'Se le debe {monto}. Si pagó una parte, escriba esa parte: lo demás queda debiéndose.',
  'pagoPaso.montoInvalido': 'Un monto mayor que cero y no más de lo que se debe.',
  'pagoPaso.fecha': '¿Qué día le pagó?',
  'pagoPaso.forma': '¿Cómo le pagó?',
  'pagoPaso.formaExplicacion':
    'En efectivo sale de la caja fuerte; por transferencia o billetera, del banco o de la billetera.',
  'pagoPaso.efectivo': 'En efectivo, de la caja fuerte',
  'pagoPaso.efectivoDetalle': 'En córdobas, de la caja fuerte.',
  'pagoPaso.reviseExplicacion': 'Baja lo que se le debe al proveedor, y sale de donde lo pagó.',
  'pagoPaso.de': 'De',
  'pagoPaso.cuanto': 'Cuánto',
  'pagoPaso.guardar': 'Guardar el pago',
  'dejo.titulo': 'Lo que dejó',
  'dejo.ingresos': 'Vendido y otros ingresos',
  'dejo.costo': 'Lo que costó lo vendido',
  'dejo.ganancia': 'Ganancia en lo vendido ({margen})',
  'dejo.gananciaSinMargen': 'Ganancia en lo vendido',
  'dejo.gastos': 'Gastos',
  'dejo.quedo': 'Quedó',
  'dejo.perdio': 'Se perdió',
  'dejo.cobrado': 'Cómo pagaron ({n} venta(s))',
  'dejo.sinVentas': 'No hubo ventas.',
  'dejo.alBanco': 'Al banco',

  // --- Cash taken to the bank, a step at a time ---
  'deposito.monto': '¿Cuánto depositó?',
  'deposito.montoExplicacion':
    'Lo que dice la boleta del banco. Si depositó solo córdobas o solo dólares, deje el otro vacío.',
  'deposito.cordobas': 'Córdobas',
  'deposito.cordobasAyuda': 'Van a la cuenta en córdobas.',
  'deposito.dolares': 'Dólares',
  'deposito.dolaresAyuda': 'Van a la cuenta en dólares.',
  'deposito.boleta': 'El número de la boleta',
  'deposito.boletaExplicacion':
    'Viene impreso en la boleta, y sirve para encontrar el depósito en el estado de cuenta. Si no lo tiene, déjelo vacío.',
  'deposito.numeroBoleta': 'Número de boleta',
  'deposito.fecha': 'Fecha del depósito',
  'mover.titulo': 'Mover dinero',
  'mover.sentido': '¿De dónde a dónde?',
  'mover.alBanco': 'Del efectivo al banco',
  'mover.delBanco': 'Del banco al efectivo',
  'mover.enEfectivo': 'Efectivo general, según los libros',
  'mover.enBanco': 'Banco, según los libros',
  'mover.enBancoDolares': 'Banco en dólares, según los libros',
  'mover.cordobasDelBanco': 'Salen de la cuenta en córdobas.',
  'mover.dolaresDelBanco': 'Salen de la cuenta en dólares.',
  'mover.referenciaDelBanco': 'Número del retiro o del cheque',
  'mover.fecha': 'Fecha',
  'mover.nota': 'Nota (opcional)',
  'mover.guardarAlBanco': 'Guardar el depósito',
  'mover.guardarDelBanco': 'Guardar lo sacado',
  'mover.explicacionAlBanco': 'Sale del efectivo general (la caja fuerte) y entra al banco, el día de la boleta. Queda en «Efectivo» con los demás depósitos, donde se anula si no se hizo.',
  'mover.explicacionDelBanco': 'Sale del banco y entra al efectivo general (la caja fuerte), el día que se sacó. Queda en «Efectivo», donde se anula si no se hizo.',
  'mover.entreCuentas': 'Entre cuentas',
  'mover.enCuenta': '«{cuenta}», según los libros',
  'mover.cordobasA': 'Los córdobas van a',
  'mover.cordobasDe': 'Los córdobas salen de',
  'mover.dolaresA': 'Los dólares van a',
  'mover.dolaresDe': 'Los dólares salen de',
  'mover.desde': 'Sale de',
  'mover.hacia': 'Entra a',
  'mover.saleCordobas': 'Lo que salió, en córdobas',
  'mover.saleDolares': 'Lo que salió, en dólares',
  'mover.llegaCordobas': 'Lo que llegó, en córdobas',
  'mover.llegaDolares': 'Lo que llegó, en dólares',
  'mover.recibidoAyuda': 'Cambia de moneda: lo que el banco puso en la otra cuenta, según el comprobante.',
  'mover.tasaDelBanco': 'El banco lo cambió a C$ {tasa} por dólar; la tasa oficial es C$ {oficial}.',
  'mover.referenciaEntre': 'Número de la transferencia',
  'mover.guardarEntre': 'Guardar la transferencia',
  'mover.unaSolaCuenta': 'La tienda tiene una sola cuenta de banco abierta. Para pasar dinero entre cuentas, agregue otra en «Configuración».',
  'mover.explicacionEntre':
    'Sale de una cuenta y entra a la otra, el día de la transferencia. Si cambia de moneda, lo que va de la tasa del banco a la oficial es ganancia o pérdida cambiaria. Queda en «Efectivo», donde se anula si no se hizo.',
  'aporte.titulo': 'Aporte del dueño',
  'aporte.motivo': 'Para qué (opcional)',
  'aporte.guardar': 'Guardar el aporte',
  'aporte.explicacion': 'El dinero que el dueño mete al negocio sube el capital. No es una venta ni un préstamo, y no cambia la ganancia. Queda en «Gastos y pagos», pestaña «Dueño», donde se anula si no se hizo.',
  'deposito.reviseExplicacion':
    'Si algo está mal, toque «Atrás» y corríjalo. Al guardarlo, el dinero sale del efectivo general y entra al banco.',
  'deposito.alBancoCordobas': 'A la cuenta en córdobas',
  'deposito.alBancoDolares': 'A la cuenta en dólares',
  'deposito.guardar': 'Guardar el depósito',

  // --- An expense, a step at a time ---
  'gastoPaso.categoria': '¿En qué se fue el dinero?',
  'gastoPaso.categoriaExplicacion': 'Elija lo que más se parezca. Sirve para saber después en qué se va el dinero de la tienda.',
  'gastoPaso.monto': '¿Cuánto pagó?',
  'gastoPaso.montoExplicacion': 'Lo que dice el recibo. Si pagó en dólares, toque «Dólares» primero.',
  'gastoPaso.descripcion': '¿Qué fue, exactamente?',
  'gastoPaso.descripcionExplicacion': 'Unas pocas palabras, para reconocerlo después en la lista.',
  'gastoPaso.pago': '¿Cómo lo pagó?',
  'gastoPaso.pagoExplicacion': 'De dónde salió el dinero. Si todavía no lo pagó, es «Lo quedé debiendo».',
  'gastoPaso.efectivo': 'En efectivo',
  'gastoPaso.efectivoDetalle': 'Sale del efectivo general, la caja fuerte.',
  'gastoPaso.efectivoGaveta': 'En efectivo, de la gaveta',
  'gastoPaso.efectivoGavetaDetalle': 'Sale de la caja abierta en este aparato: el corte ya no lo espera.',
  'gastoPaso.transferencia': 'Por transferencia',
  'gastoPaso.transferenciaDetalle': 'Sale de la cuenta del banco.',
  'gastoPaso.billetera': 'Con la billetera móvil',
  'gastoPaso.billeteraDetalle': 'Sale de la billetera.',
  'gastoPaso.credito': 'Lo quedé debiendo',
  'gastoPaso.creditoDetalle': 'Queda en cuentas por pagar, para pagarlo después.',
  'gastoPaso.deLaGaveta': 'En efectivo, de la gaveta',
  'gastoPaso.delGeneral': 'En efectivo, del efectivo general',
  'gastoPaso.proveedor': '¿A quién se lo debe?',
  'gastoPaso.proveedorExplicacion': 'Si es un proveedor de la lista, elíjalo: así aparece con lo que se le debe.',
  'gastoPaso.referencia': 'El número de la transferencia',
  'gastoPaso.referenciaExplicacion': 'Viene en el comprobante. Si no lo tiene, déjelo vacío.',
  'gastoPaso.foto': '¿Tiene el recibo?',
  'gastoPaso.fotoExplicacion':
    'Tómele una foto: queda con el gasto, para saber después en qué se fue el dinero. Si no lo tiene, siga.',
  'gastoPaso.reviseExplicacion': 'Si algo está mal, toque «Atrás» y corríjalo.',
  'gastoPaso.cuanto': 'Monto',
  'gastoPaso.fecha': '¿Qué día lo pagó?',
  'gastoPaso.fechaFutura': 'No puede ser un día que no ha llegado.',
  'gastoPaso.conFoto': 'Sí',
  'gastoPaso.sinFoto': 'No',
  // Lo que se olvidó, puesto en su lugar: una caja de otro día, lo que faltó explicado, lo anotado de más anulado.
  'inicio.cajaDeOtroDia': 'Esta caja está abierta desde el {fecha}: haga su corte con «Terminar mi turno» antes de seguir vendiendo.',
  'inicio.cajaAbiertaDesde': 'La caja de {nombre} en {equipo} está abierta desde el {fecha}: le falta su corte.',
  'explicar.boton': 'Explicar',
  'explicar.botonFaltante': 'Explicar lo que faltó',
  'explicar.titulo': 'Explicar lo que faltó',
  'explicar.conteo.corte': 'En el corte del {fecha}',
  'explicar.conteo.entrega': 'Al entregar la caja el {fecha}',
  'explicar.conteo.apertura': 'Al abrir la caja el {fecha}',
  'explicar.conteo.recibido': 'Al recibir lo que entregó la caja, el {fecha},',
  'explicar.conteo.arqueo': 'Al contar el efectivo general el {fecha}',
  'explicar.conteo.otro': 'Al contar el {fecha}',
  'explicar.falto': '{conteo} faltaron {monto}.',
  'explicar.faltoA': '{conteo} faltaron {monto}, a cuenta de {nombre}.',
  'explicar.yaExplicado': 'Ya explicado: {monto}, {descripcion}',
  'explicar.queda': 'Queda por explicar: {monto}',
  'explicar.ayuda':
    'A veces lo que falta fue un gasto que nadie anotó: la gasolina de la moto, el hielo, el recibo de la luz. Explicado aquí, pasa a ser ese gasto, el día del conteo, y deja de contar como faltante. No mueve dinero: el conteo ya lo sacó.',
  'explicar.monto': '¿Cuánto fue?',
  'explicar.hasta': 'Hasta {monto}',
  'explicar.demasiado': 'Es más de lo que queda por explicar: {monto}',
  'explicar.descripcion': '¿En qué se fue?',
  'explicar.descripcionEjemplo': 'Gasolina de la moto',
  'explicar.guardar': 'Explicar',
  'explicar.pin': 'Explicar {monto} de lo que faltó: «{descripcion}».',
  'explicar.listo': 'Listo: {monto} quedan como {categoria}, y ya no cuentan como faltante.',
  'explicar.nada': 'Lo que faltó en ese conteo ya está explicado.',
  'explicar.noSeExplico': 'No se pudo explicar: {motivo}',
  'explicar.explicado': '{monto} ya explicado',
  'anular.porQue': '¿Por qué se anula?',
  'anular.noSePuede': 'Ya no se puede anular: {motivo}.',
  'anular.noSeAnulo': 'No se pudo anular: {motivo}',
  'anular.pin': '{titulo}.',
  'anular.listo': 'Anulado: el dinero volvió a donde estaba.',
  'anular.deposito': 'Anular el depósito',
  'anular.depositoDel': 'Depósito del {fecha}',
  'anular.boleta': 'Boleta {referencia}',
  'anular.efectoDeposito':
    'Para un depósito que no se hizo, o que se anotó dos veces: el dinero vuelve al efectivo general, el día del depósito.',
  'anular.sacado': 'Anular lo sacado del banco',
  'anular.sacadoDel': 'Sacado del banco el {fecha}',
  'anular.efectoSacado': 'Para lo que no se sacó, o que se anotó dos veces: el dinero vuelve al banco, el día que se sacó.',
  'anular.transferenciaBanco': 'Anular la transferencia entre cuentas',
  'anular.efectoTransferenciaBanco':
    'Para una transferencia que no se hizo, o que se anotó dos veces: el dinero vuelve a la cuenta de donde salió, el día de la transferencia.',
  'anular.retiro': 'Anular el retiro del dueño',
  'anular.aporte': 'Anular el aporte del dueño',
  'anular.efectoRetiro':
    'Para un retiro que no se hizo, o que se anotó dos veces: el dinero vuelve a donde salió, el día del retiro.',
  'anular.efectoAporte':
    'Para un aporte que no se hizo, o que se anotó dos veces: el dinero sale de donde entró y vuelve al dueño, el día del aporte.',
  'anular.pago': 'Anular el pago',
  'anular.pagoA': 'Pago a {nombre} · {fecha}',
  'anular.efectoPago':
    'Para un pago que no se hizo, o que se anotó dos veces: el dinero vuelve a donde salió, y se le vuelve a deber al proveedor.',
  'anular.efectoPagoDeGaveta':
    'Para un pago que no se hizo, o que se anotó dos veces: el dinero vuelve a la gaveta, el corte lo espera, y se le vuelve a deber al proveedor.',
  'anular.gasto': 'Anular el gasto',
  'anular.efectoExplicacion': 'Lo que explicaba vuelve a ser lo que faltó en ese conteo, y se puede explicar de nuevo.',
  'anular.efectoGasto': 'Para un gasto que no se hizo, o que se anotó dos veces: deja de contar como gasto, y el dinero vuelve a donde salió.',
  'efectivo.depositos': 'Depósitos',
  'efectivo.depositosAyuda':
    'Lo que se llevó al banco. Uno que no se hizo se anula aquí, antes de volver a contar la caja fuerte o de comparar el banco con su estado de cuenta.',
  'efectivo.delBanco': 'Sacado del banco',
  'efectivo.delBancoAyuda': 'Lo que se trajo del banco al efectivo general. Uno que no se hizo se anula aquí, antes de volver a contar la caja fuerte o de comparar el banco con su estado de cuenta.',
  'efectivo.entreCuentas': 'Entre cuentas',
  'efectivo.entreCuentasAyuda': 'Lo que se pasó de una cuenta de banco a otra. Una que no se hizo se anula aquí, antes de comparar las cuentas con su estado.',
  'efectivo.faltantes': 'Lo que faltó al contar',
  'efectivo.faltantesAyuda': 'Conteos del efectivo general que salieron cortos. Si fue un gasto que nadie anotó, explíquelo: deja de contar como faltante.',
  'gastos.pagosAProveedores': 'Pagos a proveedores',
  'gastos.pagosAProveedoresAyuda': 'Los últimos. Uno que no se hizo, o que se anotó dos veces, se anula aquí.',
  'gastos.deFaltante': ' · lo que faltó al contar',
  'gastos.explicaFaltante': 'Explica lo que faltó al contar el {fecha}. No movió dinero: el conteo ya lo había sacado.',
  'gastos.formaFaltante': 'Lo que faltó al contar',
  'gastos.explicacionNoSeCorrige': 'Una explicación no se corrige: anúlela, y vuelva a explicar lo que faltó.',
  'gastos.anularExplicacion': 'Anular esta explicación',

  // --- Buscar en el historial: las ventas y los pedidos (lib/historial.ts) ---
  'historial.buscarVentas': 'Ticket, cliente o producto',
  'historial.buscarPedidos': 'Cliente, producto o nota',
  'historial.buscarCompras': 'Proveedor, factura o producto',
  'historial.quitar': 'Quitar «{filtro}»',
  'historial.quitarTodos': 'Quitar los filtros',
  'historial.periodo': 'Fechas',
  'historial.periodo.todo': 'Todo',
  'historial.periodo.hoy': 'Hoy',
  'historial.periodo.ayer': 'Ayer',
  'historial.periodo.mes': 'Este mes',
  'historial.periodo.mesPasado': 'Mes pasado',
  'historial.periodo.elegir': 'Elegir fechas',
  'historial.cliente': 'Cliente',
  'historial.todos': 'Todos',
  'historial.forma': 'Forma de pago',
  'historial.todas': 'Todas',
  'historial.estado': 'Estado',
  'historial.estado.todas': 'Todas',
  'historial.estado.validas': 'Sin anular',
  'historial.estado.anuladas': 'Anuladas',
  'historial.estado.conDevolucion': 'Con devolución',
  'historial.estado.porConfirmar': 'Transferencia sin confirmar',
  'historial.estado.porPagar': 'Por pagar',
  'historial.tipo': 'De dónde',
  'historial.tipo.todas': 'Todas',
  'historial.tipo.mostrador': 'Del mostrador',
  'historial.tipo.pedido': 'Pedidos entregados',
  'historial.tipo.conEnvio': 'Con envío',
  'historial.tipo.rapida': 'Con venta rápida',
  'historial.quien': 'Quién cobró',
  'historial.cobro': 'Cobró {nombre}',
  'historial.conEnvio': 'Solo los que pagaron envío',
  'historial.porEntrega': 'Por el día de entrega.',
  'historial.porCobro': 'Por el día en que se cobró.',
  'historial.encontradas': '{n} encontrada(s) · {total}',
  'historial.encontrados': '{n} encontrado(s) · {total}',
  'historial.ninguna': 'Ninguna venta coincide con lo que busca.',
  'historial.ninguno': 'Ningún pedido coincide con lo que busca.',
  'historial.ningunaCompra': 'Ninguna compra coincide con lo que busca.',
  'historial.quitarBusqueda': 'Quitar la búsqueda y los filtros',
  'historial.calendario.anterior': 'Mes anterior',
  'historial.calendario.siguiente': 'Mes siguiente',
  'historial.calendario.primero': 'Toque el primer día.',
  'historial.calendario.ultimo': 'Desde el {dia}: toque el último día, o «Listo» para ese día solo.',
  'historial.buscarProveedor': 'Buscar un proveedor',
  'historial.buscarCliente': 'Buscar un cliente',
  'historial.ningunoSeLlamaAsi': 'Ninguno se llama así.',
  'historial.verTodos': 'Ver todos',
  'historial.verTodas': 'Ver todas',
  'historial.vigencia.todos': 'Todos',
  'historial.vigencia.vigentes': 'Sin anular',
  'historial.vigencia.anulados': 'Anulados',
  'pagosProv.registrados': '{n} pago(s)',
  'pagosProv.buscar': 'Proveedor, factura o recibo',
  'pagosProv.ninguno': 'Ningún pago coincide con lo que busca.',
  'pagosProv.vacio': 'Todavía no se le ha pagado nada a un proveedor.',
  'pagosProv.factura': 'Factura {documento}',
  'pagosProv.compraDel': 'Compra del {fecha}',
  'pagosProv.deudaAnterior': 'Deuda anterior',
  'duenoHist.registrados': '{n} movimiento(s)',
  'duenoHist.buscar': 'Para qué fue',
  'duenoHist.tipoTodos': 'Todos',
  'duenoHist.cuenta': 'Cuenta',
  'duenoHist.resumen': '{n} encontrado(s) · sacó {retiros} · metió {aportes}',
  'duenoHist.ninguno': 'Ningún movimiento coincide con lo que busca.',
  'duenoHist.vacio': 'El dueño todavía no ha sacado ni metido dinero.',
  'turnosHist.registrados': '{n} turno(s) cerrado(s)',
  'turnosHist.porApertura': 'Por el día en que se abrió.',
  'turnosHist.deQuien': 'De quién',
  'turnosHist.buscarQuien': 'Buscar a alguien del personal',
  'turnosHist.resultado': 'Cómo cuadró',
  'turnosHist.resultado.todos': 'Todos',
  'turnosHist.resultado.cuadro': 'Cuadró',
  'turnosHist.resultado.falto': 'Faltó',
  'turnosHist.resultado.sobro': 'Sobró',
  'turnosHist.resumen': '{n} encontrado(s) · vendido {vendido}',
  'turnosHist.resumenDiferencia': '{n} encontrado(s) · vendido {vendido} · al cerrar {diferencia}',
  'turnosHist.ninguno': 'Ningún turno coincide con lo que busca.',
  'recargasHist.titulo': 'Recargas anteriores',
  'recargasHist.registradas': '{n} recarga(s)',
  'recargasHist.buscar': 'Número de teléfono o referencia',
  'recargasHist.estado.todas': 'Todas',
  'recargasHist.estado.confirmado': 'Pagadas',
  'recargasHist.estado.pendiente': 'Por confirmar',
  'recargasHist.estado.rechazado': 'No llegó el pago',
  'recargasHist.resumen': '{n} encontrada(s) · vendido {vendido} · comisión {comision}',
  'recargasHist.ninguna': 'Ninguna recarga coincide con lo que busca.',
  'recargasHist.vacio': 'Todavía no se ha vendido ninguna recarga.',
  'depositosHist.registrados': '{n} depósito(s)',
  'depositosHist.buscar': 'Número de boleta o nota',
  'depositosHist.moneda': 'Moneda',
  'depositosHist.moneda.todas': 'Todas',
  'depositosHist.moneda.cordobas': 'Córdobas',
  'depositosHist.moneda.dolares': 'Dólares',
  'depositosHist.ninguno': 'Ningún depósito coincide con lo que busca.',
  'depositosHist.vacio': 'Todavía no se ha llevado nada al banco.',
  'bitacora.buscar': 'Qué se hizo, quién, un ticket o un motivo',
  'bitacora.quien': 'Quién lo hizo',
  'bitacora.ninguno': 'Ningún registro coincide con lo que busca.',
  // «Bitácora», one record opened (`lib/detalleEvento.ts`, `ui/DetalleEvento.tsx`).
  'registro.loHizo': 'Lo hizo',
  'registro.seIntentoComo': 'Se intentó entrar como',
  'registro.cuando': 'Cuándo',
  'registro.equipo': 'Equipo',
  'registro.numero': 'Número en el servidor',
  'registro.soloAqui': 'Todavía solo en este equipo: no ha llegado al servidor.',
  'registro.rechazado': 'Los libros no lo aceptaron: {motivo}',
  'registro.llegoDespues': 'Llegó al servidor {cuanto} después: se hizo sin señal.',
  'registro.reloj': 'El reloj del equipo estaba desfasado {cuanto}.',
  'registro.loQueSeRegistro': 'Lo que se registró',
  'registro.nadaMas': 'Este registro no guarda nada más.',
  'registro.despues': 'Lo que pasó después',
  'registro.libros': 'Cómo quedó en los libros',
  'registro.debe': 'Debe',
  'registro.haber': 'Haber',
  'registro.antes': 'Antes: {valor}',
  'registro.noEstaAqui': 'No está en este equipo',
  'registro.ninguno': 'Ninguno',
  'registro.vacio': '(vacío)',
  'registro.porUnidad': '{costo} por {unidad}',
  'registro.numeroN': 'N.º {n}',
  'registro.conFoto': 'Con foto',
  'registro.cosas': '{n} en la lista',
  'registro.personasN': '{n} persona(s)',
  'registro.planillaAnulada': 'Anulada: nadie quedó en ella',
  'registro.pagoAnulado': 'Anulado: nadie quedó en él',
  'registro.deLaGaveta': 'De la gaveta',
  'registro.ventaRapida': 'venta rápida',
  'registro.diferencia': 'Diferencia',
  'registro.falto': 'Faltó',
  'registro.sobro': 'Sobró',
  'registro.cuadro': 'Ninguna: cuadró',
  'registro.corregido': 'Con lo corregido',
  'registro.corregidoFalta': 'Faltan {monto}',
  'registro.corregidoSobra': 'Sobran {monto}',
  'registro.minutos': '{n} min',
  'registro.horas': '{n} h',
  'registro.dias': '{n} días',
  'registro.equivaleAlMes': 'Equivale al mes',
  'detalle.enExistencia': 'En existencia',
  // ---------- Análisis ----------
  'analisis.titulo': 'Análisis',
  'analisis.periodo': 'Período',
  'analisis.vistas': 'Qué ver',
  'analisis.enDolares': 'En dólares a la tasa oficial, C$ {tasa} por dólar.',
  'analisis.tresMeses': 'Últimos 3 meses',
  'analisis.ventas': 'Ventas',
  'analisis.productos': 'Productos',
  'analisis.clientes': 'Clientes',
  'analisis.compras': 'Compras',
  'analisis.gastos': 'Gastos',
  'analisis.dinero': 'Dinero',
  'analisis.cargando': 'Sacando las cuentas…',
  'analisis.comparadoCon': 'Las flechas comparan con {rango}.',
  'analisis.comparadoConDiaEntero': 'Las flechas comparan con el {rango} entero: hoy todavía no termina.',
  'analisis.sinAntes': 'Del {rango} no hay ventas para comparar.',
  'analisis.verMas': 'Ver {n} más',
  'analisis.vendido': 'Vendido',
  'analisis.utilidad': 'Utilidad bruta',
  'analisis.margen': 'margen {pct}',
  'analisis.numVentas': 'Ventas',
  'analisis.ticket': 'Venta promedio',
  'analisis.porDia': 'Día por día',
  'analisis.porSemana': 'Semana por semana',
  'analisis.porMes': 'Mes por mes',
  'analisis.leyendaVendido': 'Vendido',
  'analisis.leyendaUtilidad': 'Utilidad',
  'analisis.toqueColumna': 'Toque una columna para ver sus cifras.',
  'analisis.columna': '{fecha}: vendido {vendido}, utilidad {utilidad}, {n} venta(s)',
  'analisis.promedioDia': 'Promedio por día: {monto}',
  'analisis.mejorDia': 'Mejor día: {fecha} ({monto})',
  'analisis.mejorSemana': 'Mejor semana: {fecha} ({monto})',
  'analisis.mejorMes': 'Mejor mes: {fecha} ({monto})',
  'analisis.sinVentas': 'No hubo ventas en este período.',
  'analisis.comoPagan': 'Cómo pagan',
  'analisis.cuandoSeVende': 'Cuándo se vende',
  'analisis.cuandoAyuda': 'Las ventas por día y hora: entre más clara la casilla, más ventas.',
  'analisis.horaPico': 'Lo más movido: {dia}, de {desde} a {hasta}.',
  'analisis.masDeja': 'Lo que más deja',
  'analisis.masDejaAyuda': 'Los productos que más utilidad dejaron en el período.',
  'analisis.vendidoMargen': 'Vendido {monto} · margen {pct}',
  'analisis.concentracion': '{n} producto(s) dejan el 80% de la utilidad, de {total} que se vendieron.',
  'analisis.bajoMargen': 'Bajo el margen mínimo ({pct})',
  'analisis.bajoMargenAyuda': 'Se vendieron con menos margen que el mínimo de Configuración. Los de pérdida primero.',
  'analisis.todosSobreMargen': 'Todo se vendió sobre el margen mínimo.',
  'analisis.vendidoVeces': 'Vendido {monto} en {n} venta(s)',
  'analisis.aPerdida': 'a pérdida',
  'analisis.parada': 'Mercadería parada',
  'analisis.paradaAyuda': 'Hay existencias, y en 30 días ni se vendió ni se compró.',
  'analisis.paradaTotal': '{monto} parados en {n} producto(s), a lo que costaron.',
  'analisis.nadaParado': 'Nada lleva 30 días sin moverse.',
  'analisis.ultimaVenta': 'última venta {fecha}',
  'analisis.masDe90': 'más de 90 días sin venderse',
  'analisis.nuncaVendido': 'no se ha vendido',
  'analisis.fiado': 'Fiado por antigüedad',
  'analisis.fiadoAyuda': 'Lo que deben hoy, según hace cuánto se fió. Los abonos pagan lo más viejo primero.',
  'analisis.fiadoTotal': 'Deben {monto} entre {n} cliente(s).',
  'analisis.tramo30': 'Hasta 30 días',
  'analisis.tramo60': 'De 31 a 60 días',
  'analisis.tramo90': 'De 61 a 90 días',
  'analisis.tramoMas': 'Más de 90 días',
  'analisis.nClientes': '{n} cliente(s)',
  'analisis.debenHace': 'Quién debe hace más tiempo',
  'analisis.haceDias': 'Lo más viejo es de hace {n} día(s)',
  'analisis.sinFiado': 'Nadie debe nada.',
  'porCobrar.titulo': 'Fiado',
  'porCobrar.ordenAntiguo': 'Lo más viejo primero',
  'porCobrar.ordenMonto': 'Lo que más deben',
  'porCobrar.ultimoAbono': 'Último abono el {fecha}',
  'porCobrar.nuncaAbono': 'Todavía no ha abonado nada',
  'porCobrar.deHoy': 'Todo es de hoy',
  'porCobrar.limite': 'Su límite: {monto}',
  'porCobrar.pasoLimite': 'Pasó su límite de {monto}',
  'porCobrar.inactivo': 'Desactivado',
  'porCobrar.nadieAsi': 'Nadie de los que deben se llama así.',
  'analisis.mejoresClientes': 'Mejores clientes',
  'analisis.mejoresAyuda': 'Los que más compraron en el período. Las ventas sin cliente no cuentan.',
  'analisis.comprasUtilidad': '{n} compra(s) · utilidad {monto}',
  'analisis.sinClientes': 'Ninguna venta del período tiene cliente.',
  'analisis.seFueron': 'Dejaron de venir',
  'analisis.seFueronAyuda': 'Compraban seguido y no han vuelto en 30 días.',
  'analisis.seFueDetalle': 'Última vez {fecha} · compró {n} día(s) en los 3 meses antes',
  'analisis.nadieSeFue': 'Los clientes de siempre siguen viniendo.',
  'analisis.gastosTotal': 'Gastos',
  'analisis.utilidadNeta': 'Lo que quedó',
  'analisis.seLlevan': 'Los gastos se llevan el {pct} de los ingresos.',
  'analisis.enQueSeVa': 'En qué se va',
  'analisis.parteDeVentas': '{pct} de los ingresos',
  'analisis.sinGastos': 'No hay gastos en este período.',
  'analisis.equilibrio': 'Punto de equilibrio',
  'analisis.equilibrioAyuda': 'Con los ingresos, los costos y los gastos de los últimos {n} día(s), como los lleva Contabilidad.',
  'analisis.equilibrioNecesita': 'Para cubrir los gastos hacen falta {monto} de ingresos al día.',
  'analisis.equilibrioVende': 'Los ingresos van en {monto} al día.',
  'analisis.sobra': 'Se cubren, y sobran {monto} al día.',
  'analisis.falta': 'Faltan {monto} al día para cubrirlos.',
  'analisis.sinEquilibrio': 'Hace falta vender con margen para calcularlo.',
  'analisis.alzas': 'Subieron de precio',
  'analisis.alzasAyuda': 'Lo que el proveedor cobró al menos 5% más que la vez anterior, sin contar el flete.',
  'analisis.porProveedor': '{proveedor}: {n} producto(s), {pct} más en promedio',
  'analisis.precioAntesAhora': '{antes} → {ahora} por {unidad}',
  'analisis.sinAlzas': 'Ningún proveedor subió precios en este período.',
  'analisis.detalle.ventas': 'Las ventas del período',
  'analisis.detalle.ventasResumen': '{n} venta(s): {monto}, que dejaron {utilidad}.',
  'analisis.detalle.ticket': 'Ticket {ticket}',
  'analisis.detalle.dejo': 'dejó {monto}',
  'analisis.detalle.gastos': 'Los gastos del período',
  'analisis.detalle.gastosResumen': '{n} movimiento(s), {monto} en total.',
  'analisis.detalle.verContabilidad': 'Ver en Contabilidad',
  'analisis.mes.titulo': 'Cómo va el mes',
  'analisis.mes.ayudaSemana': 'Lo que falta del mes, a lo que cada día de la semana ha vendido las últimas {n} semanas.',
  'analisis.mes.ayudaRitmo': 'Lo que falta del mes, al ritmo que lleva: todavía hay pocas semanas de ventas para medir cada día de la semana.',
  'analisis.mes.cierra': 'A este ritmo, el mes cierra en {monto} de ventas.',
  'analisis.mes.deja': 'Y deja {monto} de utilidad bruta.',
  'analisis.mes.van': 'Van {n} de {de} días: {monto} vendido.',
  'analisis.mes.pasado': 'El mes pasado entero: {monto}',
  'analisis.mes.anioPasado': '{mes}: {monto}',
  'analisis.metas.boton': 'Metas',
  'analisis.metas.titulo': 'Las metas del mes',
  'analisis.metas.ayuda': 'Lo que cada mes debería vender y dejar, en córdobas. Vacío: sin meta.',
  'analisis.metas.ventas': 'Meta de ventas',
  'analisis.metas.utilidad': 'Meta de utilidad bruta',
  'analisis.metas.mal': 'Escriba un monto, o déjelo vacío.',
  'analisis.metas.deMeta': '{llevado} de {meta}',
  'analisis.metas.cumplida': 'Cumplida.',
  'analisis.metas.llega': 'A este ritmo, se llega.',
  'analisis.metas.falta': 'Para llegar: {monto} cada día que queda.',
  'analisis.metas.sinMetas': 'Sin metas puestas: «Metas» las pone.',
  'analisis.diaDelMes.titulo': 'Por día del mes',
  'analisis.diaDelMes.ayuda': 'Lo que vende cada día del mes en promedio, los últimos seis meses: los días de pago se notan.',
  'analisis.diaDelMes.columna': 'Día {dia}: {monto} en promedio',
  'analisis.diaDelMes.fuertes': 'Los días que más se vende: {dias}. El mejor vende {pct} más que un día cualquiera.',
  'analisis.canal.titulo': 'Por dónde se vende',
  'analisis.canal.ayuda': 'El mostrador, los pedidos y los pedidos con envío: lo que vende y deja cada uno.',
  'analisis.canal.mostrador': 'Mostrador',
  'analisis.canal.pedido': 'Pedidos',
  'analisis.canal.envio': 'Pedidos con envío',
  'analisis.canal.detalle': '{n} venta(s) · deja {utilidad} ({margen}) · {ticket} por venta',
  'analisis.canal.envioCobro': 'El envío cobró {monto} en {n} entrega(s).',
  'analisis.canal.transporte': '{categoria} costó {monto}.',
  'analisis.canal.envioSobra': 'El envío paga el transporte, y sobran {monto}.',
  'analisis.canal.envioFalta': 'Al envío le faltan {monto} para pagar el transporte.',
  'analisis.canal.pedidoPromedio': 'Un pedido con envío lleva {monto} de mercadería en promedio. Lo que gana quien maneja va en la planilla, no aquí.',
  'analisis.lista.titulo': 'Por lista de precios',
  'analisis.lista.ayuda': 'Lo que se vendió a cada precio y lo que dejó.',
  'analisis.lista.detalle': '{n} venta(s) · deja {utilidad} ({margen})',
  'analisis.categoria.titulo': 'Por categoría',
  'analisis.categoria.ayuda': 'Lo que vendió y dejó cada categoría en el período, lo que tiene hoy en el estante a lo que costó, y lo que eso deja al mes. Toque una para ver sus productos.',
  'analisis.categoria.vendio': 'vendió {monto} a {pct} de margen',
  'analisis.categoria.nadaVendido': 'nada vendido',
  'analisis.categoria.estante': '{monto} en el estante',
  'analisis.categoria.rinde': 'deja {pct} de eso al mes',
  'analisis.agotado.titulo': 'Agotados',
  'analisis.agotado.ayuda': 'Lo que se acabó y se vendía: desde cuándo no hay, y lo que se deja de vender cada día sin él, a lo que se vendía las cuatro semanas antes.',
  'analisis.agotado.nada': 'No falta nada de lo que se vende.',
  'analisis.agotado.total': 'Entre todos, unos {venta} de venta al día, que dejarían {utilidad}.',
  'analisis.agotado.hoy': 'Se acabó hoy.',
  'analisis.agotado.desde': 'No hay desde el {fecha}: unos {monto} sin vender.',
  'analisis.agotado.alDia': '{monto} al día',
  'analisis.sobra.titulo': 'Mucho en el estante',
  'analisis.sobra.ayuda': 'Lo que se vende, pero hay para más de tres meses a lo que se vendió los últimos {n} días: plata metida antes de tiempo.',
  'analisis.sobra.nada': 'Nada tiene para más de tres meses.',
  'analisis.sobra.total': '{monto} en {n} producto(s).',
  'analisis.sobra.alcanza': '{cantidad} · alcanza para {tiempo}',
  'analisis.sobra.meses': 'unos {n} meses',
  'analisis.sobra.anios': 'unos {n} años',
  'analisis.simular.titulo': 'Simular un precio',
  'analisis.simular.ayuda': 'Un precio probado antes de ponerlo, contra lo que se vendió los últimos {n} días.',
  'analisis.simular.boton': 'Simular',
  'analisis.simular.explica': 'Cuánto deja cada una al precio nuevo, y cuántas habría que vender para dejar lo mismo que ahora. Nada cambia hasta que el precio se pone en el producto.',
  'analisis.simular.producto': 'Producto',
  'analisis.simular.buscar': 'Escriba el nombre',
  'analisis.simular.hoy': 'Hoy, {unidad}: {precio} · cuesta {costo} · deja {deja} ({pct}).',
  'analisis.simular.vendidas': 'Los últimos {n} días se vendieron {cuantas}, que dejan {monto} a este precio.',
  'analisis.simular.sinVentas': 'No se vendió en los últimos {n} días.',
  'analisis.simular.nuevo': 'Precio nuevo',
  'analisis.simular.mal': 'Escriba un precio.',
  'analisis.simular.deja': 'A {precio}, cada una deja {deja} ({pct}).',
  'analisis.simular.perdida': 'A ese precio se pierde en cada una.',
  'analisis.simular.bajoMinimo': 'Queda bajo el margen mínimo de {pct}.',
  'analisis.simular.menos': 'Con vender {mismas} en vez de {vendidas} deja lo mismo que los últimos {n} días.',
  'analisis.simular.mas': 'Para dejar lo mismo que los últimos {n} días hay que vender {mismas} en vez de {vendidas}.',
  'analisis.simular.alProducto': 'Ir al producto',
  'analisis.fiadoVa.titulo': 'Cómo va el fiado',
  'analisis.fiadoVa.ayuda': 'Lo que se fió, se cobró y se perdió en el período, y lo que dejó vender al fiado; quién debe más que hace un mes, contra su límite, y en cuántos días paga.',
  'analisis.fiadoVa.periodo': 'Se fiaron {dado} y se cobraron {cobrado}; se dio por perdido {perdido}.',
  'analisis.fiadoVa.queda': 'Lo vendido al fiado dejó {utilidad}; menos lo perdido, quedan {queda}.',
  'analisis.fiadoVa.deben': 'Quién debe',
  'analisis.fiadoVa.subio': 'subió {monto} en 30 días',
  'analisis.fiadoVa.bajo': 'bajó {monto} en 30 días',
  'analisis.fiadoVa.igual': 'igual que hace 30 días',
  'analisis.fiadoVa.limite': '{pct} de su límite',
  'analisis.fiadoVa.paga': 'paga en {n} días',
  'analisis.fiadoVa.nada': 'Ni fiado ni deudas en el período.',
  'analisis.toca.titulo': 'Les toca comprar',
  'analisis.toca.ayuda': 'Los clientes de siempre a los que ya les tocó volver, según cada cuánto compró cada uno los últimos seis meses. El más atrasado para su ritmo primero.',
  'analisis.toca.detalle': 'Compra cada {n} día(s) · vino hace {m} día(s)',
  'analisis.toca.porVez': '{monto} por vez',
  'analisis.toca.nada': 'Nadie atrasado: los de siempre han venido a su tiempo.',
  'analisis.proveedores.titulo': 'A quién se le compra',
  'analisis.proveedores.ayuda': 'Lo comprado a cada proveedor en el período, menos lo devuelto, y lo que se le debe hoy. Toque uno para ver sus compras.',
  'analisis.proveedores.nada': 'No hubo compras en este período.',
  'analisis.proveedores.total': '{monto} en {n} compra(s) a {m} proveedor(es).',
  'analisis.proveedores.compras': '{n} compra(s)',
  'analisis.proveedores.debe': 'se le debe {monto}',
  'analisis.proveedores.lineas': '{n} producto(s)',
  'analisis.proveedores.alCredito': 'al crédito',
  'analisis.barato.titulo': 'Quién lo vende más barato',
  'analisis.barato.ayuda': 'Lo que otro proveedor dio más barato que el último al que se le compró, en los últimos {n} meses, sin el flete. Lo que más ahorraría al mes primero.',
  'analisis.barato.nada': 'Lo último se compró donde estaba más barato.',
  'analisis.barato.detalle': 'Se compró a {ultimo} a {precio}; {barato} lo dio a {precioBarato} el {fecha}, {pct} menos.',
  'analisis.barato.alMes': '{monto} al mes',
  'analisis.indice.titulo': 'Lo que cuesta comprar',
  'analisis.indice.ayuda': 'Cada producto comprado en un mes contra la última vez que se compró antes, pesado por lo que se gastó en él: cuánto más caro, o más barato, sale lo que compra la tienda.',
  'analisis.indice.nada': 'Todavía no hay compras que comparar.',
  'analisis.indice.subio': 'Lo que compra la tienda cuesta {pct} más que hace {n} meses.',
  'analisis.indice.bajo': 'Lo que compra la tienda cuesta {pct} menos que hace {n} meses.',
  'analisis.indice.igual': 'Lo que compra la tienda cuesta lo mismo que hace {n} meses.',
  'analisis.oferta.titulo': '¿Conviene la oferta?',
  'analisis.oferta.ayuda': 'Cuando un proveedor da mejor precio por llevar más: cuánto se ahorra, cuánto tarda en venderse y si el ahorro paga la plata que se queda en el estante.',
  'analisis.oferta.boton': 'Calcular',
  'analisis.oferta.explica': 'Nada se compra aquí: es solo la cuenta.',
  'analisis.oferta.cuantas': 'Cantidad ({unidad})',
  'analisis.oferta.malCantidad': 'Escriba una cantidad.',
  'analisis.oferta.precio': 'Precio de la oferta, por {unidad}',
  'analisis.oferta.siempre': 'Precio de siempre, por {unidad}',
  'analisis.oferta.siempreAyuda': 'El de la última compra, sin el flete.',
  'analisis.oferta.ahorra': 'Cuesta {invertido} y ahorra {ahorro} ({pct}).',
  'analisis.oferta.noAhorra': 'Cuesta {invertido} y no ahorra nada: no es más barata.',
  'analisis.oferta.dias': 'A lo que se vende, se termina en unos {n} días, detrás de lo que ya hay.',
  'analisis.oferta.sinRitmo': 'No se vendió en los últimos {n} días: no hay a qué ritmo medirlo.',
  'analisis.oferta.rinde': 'El ahorro es como ganar {pct} al mes sobre la plata que se mete.',
  'analisis.oferta.perecedero': 'Es perecedero: revise que aguante {n} días.',
  'analisis.oferta.largo': 'Pasa de tres meses en el estante.',
  'analisis.presupuesto.titulo': 'Presupuesto del mes',
  'analisis.presupuesto.ayuda': 'Lo que cada cuenta de gastos lleva gastado en el mes contra lo que puede gastar.',
  'analisis.presupuesto.boton': 'Presupuestos',
  'analisis.presupuesto.nada': 'Sin presupuestos: «Presupuestos» los pone.',
  'analisis.presupuesto.total': 'Gastado {gastado} de {presupuesto} presupuestado.',
  'analisis.presupuesto.pasado': 'Se pasó por {monto}.',
  'analisis.presupuesto.quedan': 'Quedan {monto} · {pct} usado',
  'analisis.presupuesto.sinPresupuesto': 'Sin presupuesto: {monto} en {n} cuenta(s).',
  'analisis.presupuesto.explica': 'Lo que cada cuenta puede gastar al mes, en córdobas. Vacío: sin presupuesto. Las cuentas son las que tuvieron gastos los últimos 90 días.',
  'analisis.presupuesto.sinCuentas': 'Todavía no hay gastos a los que ponerles presupuesto.',
  'analisis.perdidas.titulo': 'Lo que se pierde',
  'analisis.perdidas.ayuda': 'Merma, vencido, consumo de la casa, faltantes, transferencias que no llegaron y fiado perdido, a lo que costaron; y los últimos seis meses.',
  'analisis.perdidas.nada': 'No se perdió nada en el período.',
  'analisis.perdidas.total': '{monto} perdido: {pct} de lo vendido.',
  'analisis.planilla.titulo': 'La planilla',
  'analisis.planilla.ayuda': 'Sueldos, INSS patronal, INATEC, aguinaldo, vacaciones e indemnización del período, contra lo vendido y lo que dejó.',
  'analisis.planilla.nada': 'Sin planilla en el período.',
  'analisis.planilla.costo': 'La planilla costó {monto}.',
  'analisis.planilla.deVentas': 'Es {pct} de lo vendido.',
  'analisis.planilla.deUtilidad': 'Y {pct} de la utilidad bruta.',
  'analisis.horas.titulo': 'Horas de caja',
  'analisis.horas.ayuda': 'Las horas que la caja estuvo abierta contra las ventas que hubo en ellas: dónde hace falta otra mano y dónde sobra.',
  'analisis.horas.nada': 'La caja no estuvo abierta en el período.',
  'analisis.horas.total': 'La caja estuvo abierta {n} hora(s); en {m} no se vendió nada.',
  'analisis.horas.movidas': 'Las horas más movidas',
  'analisis.horas.flojas': 'Las más flojas con la caja abierta',
  'analisis.horas.cuando': '{dia}, de {desde} a {hasta}',
  'analisis.horas.porHora': '{n} ventas por hora',
  'analisis.alcanza.titulo': '¿Me alcanza?',
  'analisis.alcanza.ayuda': 'Una persona más o un gasto fijo nuevo contra lo que la tienda dejó los últimos {n} días: cuánto quedaría al mes y cuánto más habría que vender.',
  'analisis.alcanza.persona': 'Una persona más',
  'analisis.alcanza.gasto': 'Un gasto fijo nuevo',
  'analisis.alcanza.sueldo': 'Sueldo al mes',
  'analisis.alcanza.monto': 'Cuánto al mes',
  'analisis.alcanza.costo': 'Le cuesta a la tienda {total} al mes: {sueldo} de sueldo, {patronal} de INSS patronal e INATEC y {prestaciones} de aguinaldo y vacaciones.',
  'analisis.alcanza.queda': 'A lo de los últimos {n} días, después de todos los gastos quedan {queda} al mes.',
  'analisis.alcanza.quedaria': 'Con esto quedarían {monto} al mes.',
  'analisis.alcanza.noAlcanza': 'No alcanza: faltarían {monto} al mes.',
  'analisis.alcanza.vender': 'Para pagarlo hay que vender {mes} más al mes, unos {dia} al día, al margen de {pct}.',
  'analisis.alcanza.explica': 'Nadie se contrata ni se gasta nada aquí: es solo la cuenta.',
  'analisis.hoyEs': 'Hoy, {fecha}',
  'analisis.dinero.hoyTitulo': 'El dinero de hoy',
  'analisis.dinero.hoyAyuda': 'Lo que hay en las cajas, el efectivo general, lo entregado sin contar, cada cuenta de banco y la billetera, como lo llevan los libros.',
  'analisis.dinero.hay': 'Hay {monto} en total.',
  'analisis.dinero.nada': 'Los libros no tienen dinero todavía.',
  'analisis.dinero.pronosticoTitulo': 'Los próximos {n} días',
  'analisis.dinero.pronosticoAyuda': 'Lo que traerían las ventas de contado y el fiado cobrado, a lo de las últimas {n} semanas, menos reponer lo vendido al costo y lo que vence cada día.',
  'analisis.dinero.final': 'En {n} días habría unos {monto}.',
  'analisis.dinero.minimo': 'El día más bajo: {fecha}, con {monto}.',
  'analisis.dinero.falta': 'El {fecha} faltarían {monto}.',
  'analisis.dinero.columna': '{fecha}: {monto}',
  'analisis.toqueDia': 'Toque un día para ver su cifra.',
  'analisis.dinero.bajoCero': 'Los libros dan {monto} bajo cero: salió más dinero del que entró en ellos, y falta registrar alguna entrada.',
  'analisis.dinero.finalFalta': 'En {n} días faltarían unos {monto}.',
  'analisis.dinero.ventas': 'Ventas de contado',
  'analisis.dinero.cobros': 'Fiado cobrado',
  'analisis.dinero.reponer': 'Reponer lo vendido',
  'analisis.dinero.planilla': 'Planilla',
  'analisis.dinero.fijos': 'Gastos fijos',
  'analisis.dinero.compras': 'Compras al crédito',
  'analisis.dinero.gastos': 'Gastos al crédito',
  'analisis.dinero.deudas': 'INSS, INATEC, IR y sueldos por pagar',
  'analisis.dinero.supuestos': 'Lo que se debe al INSS, al INATEC y del IR, y los sueldos sin entregar, no tienen día en la app: se cuentan como pagados hoy; una compra al crédito sin día, también.',
  'analisis.dinero.porDia': '{n} persona(s) pagada(s) por día no están en la cuenta: lo que cobran depende de los días que trabajen.',
  'analisis.dinero.sinMonto': 'Sin monto fijo, no están en la cuenta: {lista}.',
  'analisis.dinero.venceTitulo': 'Lo que vence en {n} días',
  'analisis.dinero.venceAyuda': 'La planilla en sus días de pago, el aguinaldo el 10 de diciembre, los gastos fijos, las compras al crédito y lo que se debe sin día.',
  'analisis.dinero.venceNada': 'Nada vence en estos días.',
  'analisis.dinero.planillaDe': 'Planilla del {desde} al {hasta}',
  'analisis.dinero.aguinaldo': 'Aguinaldo de diciembre',
  'analisis.dinero.hoyMismo': 'hoy',
  'analisis.capital.titulo': 'Capital de trabajo',
  'analisis.capital.ayuda': 'Lo que la tienda tiene para trabajar, y cuánto tarda el dinero en volver, a lo de los últimos {n} días.',
  'analisis.capital.tiene': 'Para trabajar hay {capital}: {dinero} en dinero, {inventario} en mercadería, {fiado} en fiado y {otros} más, menos {proveedores} a proveedores y {deudas} de otras deudas.',
  'analisis.capital.ciclo': 'El dinero tarda unos {n} días en volver: {inventario} en el estante y {cobro} en el fiado, menos {pago} que esperan los proveedores.',
  'analisis.capital.cicloAntes': 'El dinero vuelve unos {n} días antes de pagarles a los proveedores: {inventario} en el estante y {cobro} en el fiado, contra {pago} que esperan.',
  'analisis.hoy': 'Hoy',
  'analisis.decidir.titulo': 'Qué hacer hoy',
  'analisis.decidir.ayuda': 'Lo que más dinero pone en juego primero; cada uno abre donde se resuelve.',
  'analisis.decidir.nada': 'Nada que decidir hoy: no se acaba nada que se venda, no hay precios bajo el margen ni lotes por vencer, nadie pasó su límite de fiado y no faltó dinero en la caja.',
  'analisis.decidir.yMas': '{lista} y {n} más',
  'analisis.decidir.dinero': 'Faltaría dinero el {fecha}',
  'analisis.decidir.dineroDetalle': 'Lo que vence en {n} días pasa de lo que entraría.',
  'analisis.decidir.dineroMonto': 'faltarían',
  'analisis.decidir.reponer': 'Se acabaron o se están acabando',
  'analisis.decidir.reponerMonto': 'de venta a la semana',
  'analisis.decidir.vencen': 'Vencidos o por vencer',
  'analisis.decidir.vencenMonto': 'en mercadería',
  'analisis.decidir.limite': 'Pasaron su límite de fiado',
  'analisis.decidir.limiteMonto': 'sobre el límite',
  'analisis.decidir.fiadoViejo': 'Fiado de hace más de 90 días',
  'analisis.decidir.fiadoViejoMonto': 'por cobrar',
  'analisis.decidir.faltantes': 'Faltantes de caja estos 7 días',
  'analisis.decidir.faltantesMonto': 'faltaron',
  'analisis.decidir.transferencias': 'Transferencias sin confirmar',
  'analisis.decidir.transferenciasDetalle': '{n}; la más vieja, del {fecha}',
  'analisis.decidir.transferenciasUna': 'Del {fecha}',
  'analisis.decidir.transferenciasMonto': 'por confirmar',
  'analisis.decidir.margen': 'Precios bajo el margen',
  'analisis.decidir.margenMonto': 'más al mes',
  'analisis.decidir.lesToca': 'Les toca comprar',
  'analisis.decidir.lesTocaMonto': 'cada vez',
  'analisis.decidir.barato': 'Se consiguen más baratos',
  'analisis.decidir.baratoMonto': 'de ahorro al mes',
  'analisis.decidir.sobra': 'Tienen para más de 3 meses',
  'analisis.decidir.sobraMonto': 'parados',
  'analisis.confianza.titulo': '¿Cuánto creerle a las cifras?',
  'analisis.confianza.ayuda': 'Lo que puede hacer que una cifra no sea la real.',
  'analisis.confianza.bien': 'Todo lo vendido estos 30 días tiene costo y ninguna existencia está bajo cero.',
  'analisis.confianza.rapidas': '{monto} en {n} venta(s) rápida(s) estos 30 días: no tienen costo, así que todo cuenta como utilidad.',
  'analisis.confianza.sinCosto': '{n} producto(s) se vendieron sin costo estos 30 días ({lista}): {monto} cuentan como utilidad entera.',
  'analisis.confianza.negativos': '{n} producto(s) con existencia bajo cero: hasta contarlos, el inventario y lo que cuesta no son los reales.',
  'analisis.confianza.verNegativos': 'Ver cuáles',
  'analisis.confianza.pocosDias': 'Las ventas empiezan el {fecha}: los ritmos y promedios salen de {n} día(s).',
  'analisis.confianza.dinero': 'Los libros dan dinero bajo cero: falta registrar alguna entrada.',
  'analisis.confianza.categorias': 'Cuándo se contó cada categoría',
  'analisis.confianza.categoriasAyuda': 'Lo que no se cuenta puede faltar sin que se note.',
  'analisis.confianza.hace': 'Hace {n} días',
  'analisis.confianza.nuncaContadas': '{n} categoría(s) nunca se han contado: {lista}.',
  'analisis.confianza.hoyMismo': 'Hoy',
  'analisis.confianza.contados': '{n} de {total} productos contados en 90 días',
  'analisis.confianza.contar': 'Contar',
  'analisis.confianza.sinCategorias': 'No hay nada en el estante que contar.',
  'analisis.resumen.titulo': 'Resumen del mes',
  'analisis.resumen.ayuda': 'Lo vendido, la utilidad, los gastos y lo que quedó, para mandar por WhatsApp o imprimir.',
  'analisis.resumen.ver': 'Ver el resumen',
  'analisis.resumen.de': 'Resumen de {mes}',
  'analisis.resumen.contra': 'Contra {mes}',
  'analisis.resumen.margen': 'Margen',
  'analisis.resumen.cierra': 'Cierre a este ritmo',
  'analisis.resumen.fiado': 'Fiado por cobrar',
  'analisis.resumen.dinero': 'Dinero hoy',
  'analisis.resumen.pdf': 'Para un PDF, toque «Imprimir» y elija «Guardar como PDF».',
  'inicio.ayudaAnalisis': 'Cómo va el negocio: las ventas, lo que más deja, quién debe y en qué se va la plata.',
} as const;
